{
  "auth": {
    "agree": "I Agree",
    "createAccount": "Create Account",
    "createNewAccount": "Create New Account",
    "email": "Email",
    "tokenSuccess": "Token verified successfully",
    "tokenInvalid": "Invalid or expired token",
    "login": "Login",
    "tokenMissing": "Token missing in URL",
    "password": "Password",
    "recover_password": "Recover Password",
    "sign_up": "Sign Up",
    "keep_logged_in": "Keep me logged in",
    "termsOfUse": "Terms of Use",
    "reset_password": "Reset Password",
    "username": "Username",
    "username_required": "Username field is required",
    "forgot_password": "Forgot Password?",
    "new_to_vuestic": "New to Vuestic?",
    "welcome_back": "Welcome back! Please log in to your account.",
    "create_account": "Create Account",
    "success_message": "Authentication successful",
    "login_error": "Login failed, please try again.",
    "have_account": "Already have an account?",
    "repeat_password": "Repeat Password",
    "repeat_password_required": "Repeat password is required",
    "passwords_do_not_match": "Passwords do not match",
    "admin_created_success": "Admin created successfully",
    "create_admin_failed": "Failed to create admin",
    "password_required": "Password field is required",
    "password_validation": "Password must be at least 8 characters long and contain one uppercase letter and one special character",
    "errors": {
      "password_not_valid": "Password is not valid.",
      "login_not_found": "Login not found."
    },
    "forgot_password_title": "Forgot your password?",
    "forgot_password_description": "If you forgot your password, don't worry. Just enter your email address below and we will send you an email with a temporary password. Recovering access to your account has never been easier.",
    "email_required": "Email field is required",
    "enter_email": "Enter your email",
    "email_valid": "Email should be valid",
    "send_password": "Send Password",
    "logout": "Logout",
  "session_ended": "Session Ended",
  "agent_session_ended": "Agent Session Ended",
  "admin_still_logged_in": "The administrator is still logged in on their tab",
  "window_closing_auto": "This window will close automatically...",
  "closing": "Closing...",
    "go_back": "Go Back",
    "demo": {
      "got_questions": "Got questions?",
      "request_demo_desc": "Request a free demo and let experts answer all your questions.",
      "request_demo_button": "Request Demo",
      "request_free_demo": "Request Free Demo",
      "claim_spot": "Book your spot now and ignite innovation with our superior software solutions",
      "email_label": "Email",
      "email_valid": "Email should be valid",
      "demo_submitted": "Demo request submitted!",
      "expert_contact": "An expert will contact you soon"
    }
  },
  "404": {
    "title": "404 Page",
    "text": "If you feel this is incorrect, please send us a message",
    "back_button": "Back to Dashboard"
  },
  "typography": {
    "primary": "Primary Text Style",
    "secondary": "Secondary Text Style"
  },
  "versions": {
    "title": "Version Management",
    "description": "Application version management page",
    "editVersion": "Edit Version",
    "linkTitle": "Version Link",
    "totalLinks": "Total Links",
    "addLink": "Add Link",
    "editLink": "Edit Link",
    "noLinks": "No links yet",
    "addFirstLink": "Add your first version link",
    "selectVersion": "Select Version",
    "uploadFile": "Upload File",
    "dragAndDropFile": "Drag and drop files here",
    "linkCopied": "Link copied to clipboard",
    "failedToCopyLink": "Failed to copy link",
    "deleteLink": "Delete Link",
    "deleteLinkConfirm": "Are you sure you want to delete version link \"{name}\" for version \"{version}\"?",
    "deleteLinkWarning": "This action cannot be undone.",
    "name": "Name",
    "url": "URL",
    "create": "Create",
    "update": "Update",
    "addNewVersion": "Add New Version",
    "versionNumber": "Version",
    "dateRelease": "Release Date",
    "versionDescription": "Description",
    "uploadAndroidFile": "Upload Android File",
    "uploadIosFile": "Upload iOS File",
    "otherIosFile": "Other iOS File",
    "notAvailable": "Not available",
    "noVersionsFound": "No versions found",
    "androidApk": "Android APK",
    "iosIpaZip": "iOS IPA/ZIP",
    "otherIosFileLabel": "Other iOS File",
    "cancel": "Cancel",
    "uploading": "Uploading...",
    "updateVersion": "Update Version",
    "createVersion": "Created",
    "totalVersions": "Total Versions",
    "latestVersion": "Latest Version",
    "lastRelease": "Last Release",
    "searchVersions": "Search versions...",
    "addVersion": "Add Version",
    "loadingVersions": "Loading versions...",
    "noVersionsYet": "No versions yet",
    "createFirstVersion": "Create your first app version to get started",
    "createFirstVersionButton": "Create First Version",
    "adjustSearchCriteria": "Try adjusting your search criteria",
    "clearSearch": "Clear Search",
    "id": "ID",
    "releaseDate": "Release Date",
    "android": "Android",
    "ios": "iOS",
    "ismultiple": "Multiple",
    "forceInstall": "Force install",
    "actions": "Actions",
    "edit": "Edit",
    "delete": "Delete",
    "deleteVersion": "Version deleted successfully",
    "deleteVersionConfirm": "Delete version {version}?",
    "versionPlaceholder": "e.g.: 1.0.0",
    "datePlaceholder": "YYYY-MM-DD",
    "descriptionPlaceholder": "Enter version description...",
    "fillRequiredFields": "Please fill in all required fields",
    "versionFormatError": "Version number format must be X.Y or X.Y.Z",
    "versionFormatErrorDetailed": "Version number must be in format Major.Minor.Patch. Ex: 1.1.0",
    "missingRequiredFields": "Missing required fields: {fields}",
    "versionNumberRequired": "Version number is required",
    "releaseDateRequired": "Release date is required",
    "descriptionRequired": "Description is required",
    "uploadAtLeastOneFile": "Please upload at least one file: Android or iOS",
    "failedToLoadVersions": "Failed to load versions",
    "failedToSubmitVersion": "Failed to submit version",
    "failedToDeleteVersion": "Failed to delete version",
    "widgets": {
      "counterWidget": {
        "title": "Management Widget",
        "onlineUsers": "Online Users",
        "refresh": "Refresh",
        "total": "Total",
        "web": "Web",
        "android": "Android",
        "ios": "iOS",
        "refreshing": "Refreshing...",
        "refreshNow": "Refresh Now",
        "refreshInterval": "Refresh Interval:",
        "seconds30": "30 seconds",
        "updatedSecondsAgo": "Updated {diff} seconds ago",
        "updatedMinutesAgo": "Updated {diff} minutes ago",
        "updatedAt": "Updated at {time}"
      },
      "installWidget": {
        "title": "Install Widget",
        "installManagement": "Install Management",
        "refresh": "Refresh",
        "android": "Android",
        "ios": "iOS",
        "refreshing": "Refreshing...",
        "refreshNow": "Refresh Now",
        "refreshInterval": "Refresh Interval:",
        "seconds30": "30 seconds",
        "updatedSecondsAgo": "Updated {diff} seconds ago",
        "updatedMinutesAgo": "Updated {diff} minutes ago",
        "updatedAt": "Updated at {time}"
      }
    }
  },
  "dashboard": {
    "title": "Dashboard",
    "dataSection": {
      "openInvoices": "Open Invoices",
      "ongoingProjects": "Ongoing Projects",
      "employees": "Employees",
      "newProfit": "New Profit",
      "sinceLastMonth": "Since last month"
    },
    "orderOverview": {
      "today": "Today",
      "allTime": "All Time",
      "yesterday": "Yesterday",
      "totalOrders": "Total Orders",
      "orders": "Orders",
      "title": "Order Overview",
      "subtitle": "Order Overview",
      "count": "Count",
      "amount": "Amount"
    },
    "monthlyOrder": {
      "thisMonth": "This Month",
      "lastMonth": "Last Month",
      "title": "Monthly Order",
      "allTime": "All Time",
      "subtitle": "Monthly Order Overview",
      "count": "Count",
      "amount": "Amount"
    },
    "deductionOverview": {
      "thisMonth": "This Month",
      "lastMonth": "Last Month",
      "title": "Deduction Overview",
      "subtitle": "Deduction Overview",
      "count": "Count",
      "amount": "Amount",
      "today": "Today",
      "yesterday": "Yesterday"
    },
    "monthlyDeduction": {
      "thisMonth": "This Month",
      "lastMonth": "Last Month",
      "title": "Monthly Deduction",
      "subtitle": "Monthly Deduction Overview",
      "count": "Count",
      "amount": "Amount"
    },
    "reserved": {
      "title": "Reserved Widget",
      "subtitle": "This is a reserved widget for future use",
      "ofTotal": "of total"
    },
    "reserved_other": {
      "title": "Reserved Widget"
    },
    "agentSalesRankingWidget": {
      "yesterdayTitle": "Agent Sales Ranking (Yesterday)",
      "yesterdaySubtitle": "Agent Sales Ranking (Yesterday)",
      "todayTitle": "Agent Sales Ranking (Today)",
      "todaySubtitle": "Agent Sales Ranking (Today)",
      "loading": "Loading rankings...",
      "noData": "No ranking data",
      "columns": {
        "rank": "Rank",
        "agent": "Agent",
        "sales": "Sales",
        "revenue": "Revenue",
        "orders": "Orders"
      }
    },
    "visitStatWidget": {
      "overview": "Overview",
      "realtime": "Realtime",
      "today": "Today",
      "yesterday": "Yesterday",
      "allTime": "All Time",
      "totalVisits": "Total Visits",
      "avgTime": "Total Duration",
      "newUsers": "New Users",
      "online": "Online",
      "onlineRecently": "Online Recently",
      "returningUsers": "Returning Users",
      "downloads": "Downloads (including downloaded but not installed)",
      "installations": "Installations",
      "newUsers7Days": "New Users (7 days)",
      "videoClicks": "Video Clicks",
      "postClicks": "Post Clicks",
      "resourceClickDetails": "Resource Click Details",
      "resourceClickSubtitle": "Showing today's Top 20 by default",
      "allTypes": "All Types",
      "allPlatforms": "All Platforms",
      "title": "Title",
      "type": "Type",
      "resourceId": "Resource ID",
      "total": "Total Clicks",
      "sources": "Sources",
      "emptyResourceClicks": "No click data",
      "previous": "Previous",
      "next": "Next",
      "sourceVideoPage": "Video Page",
      "sourcePostList": "Post List",
      "sourceSearchVideo": "Search Video",
      "sourceSearchPost": "Search Post",
      "avgDurationAnalysis": "Average Duration Analysis",
      "platformPerformanceAnalysis": "Platform Performance Analysis",
      "range0to1Min": "0-1 min",
      "range1to3Min": "1-3 min",
      "range3to10Min": "3-10 min",
      "range10PlusMin": "10+ min",
      "byPlatform": "By Platform",
      "globalAvgDuration": "Global Average Duration",
      "allDevices": "All Devices",
      "platformComparison": "Platform Comparison",
      "web": "Web",
      "android": "Android",
      "ios": "iOS",
      "unknown": "Unknown",
      "users": "Users",
      "leadingPlatform": "Leading Platform",
      "totalTime": "Total Time",
      "engagement": "Engagement",
      "sessionDurationDistribution": "Session Duration Distribution",
      "distribution": "Distribution",
      "usersByRange": "Users by Range",
      "deviceStats": "Device Statistics",
      "globalDistribution": "Global Distribution",
      "vsYesterday": " Yesterday",
      "vsDayBefore": " Day Before",
      "vsAverage": " Average",
      "live": "Live",
      "onlineModeApi": "API",
      "timeUnits": {
        "years": "y",
        "months": "mo",
        "days": "d",
        "hours": "h",
        "minutes": "min",
        "seconds": "s"
      }
    },
    "trafficDashboard": {
      "title": "Traffic Analytics",
      "subtitle": "Real-time traffic monitoring and analysis",
      "visits7Days": "Visits - Last 7 days",
      "weeklyTrend": "Weekly Trend",
      "todayYesterday": "Today vs Yesterday",
      "today": "Today",
      "yesterday": "Yesterday",
      "visits30Days": "Visits - Last 30 Days",
      "monthlyEvolution": "Monthly Evolution",
      "visits24Hours": "Visits - Last 24 Hours",
      "byHour": "By Hour",
      "visits60Minutes": "Visits - Last 60 Minutes",
      "realTime": "Real-time",
      "loading": "Loading...",
      "total": "Total",
      "visits": "Visits",
      "noData": "No data available",
      "noDataSubtitle": "There are no visit records to display for this period",
      "purchases": "purchase(s)",
      "purchases24Hours": "Purchases - Last 24 Hours"
    },
    "announcements": {
      "title": "Announcements",
      "subtitle": "Manage and broadcast your communications",
      "tableTitle": "Announcement List",
      "newAnnouncement": "New Announcement",
      "emptyState": {
        "title": "No announcements yet",
        "create": "Click the add button to create a new announcement"
      },
      "filters": {
        "from": "From",
        "to": "To",
        "agent_name": "Agent Name",
        "date": "Date",
        "all": "All",
        "active": "Active",
        "scheduled": "Scheduled",
        "inactive": "Inactive",
        "archived": "Archived"
      },
      "search": "Search announcements...",
      "status": {
        "active": "Active",
        "scheduled": "Scheduled",
        "confirmation": "Confirmation"
      },
      "actions": {
        "activate": "Activate",
        "deactivate": "Deactivate",
        "edit": "Edit",
        "delete": "Delete"
      },
      "stats": {
        "total": "Total",
        "active": "Active",
        "scheduled": "Scheduled"
      },
      "itemsPerPage": "Items per page",
      "table": {
        "status": "Status",
        "title": "Title",
        "content": "Content",
        "date": "Date",
        "recipients": "Recipients",
        "progress": "Progress",
        "actions": "Actions"
      },
      "pagination": {
        "info": "Showing {start} to {end} of {total} announcements",
        "jump": "Page:",
        "jumpButton": "Go"
      },
      "modal": {
        "newTitle": "New Announcement",
        "createTitle": "New Announcement",
        "editTitle": "Edit Announcement",
        "title": "Title *",
        "titleLabel": "Title *",
        "titlePlaceholder": "Enter announcement title...",
        "content": "Content *",
        "contentLabel": "Content *",
        "contentPlaceholder": "Write your announcement...",
        "targetType": "Target",
        "targetAll": "All Agents",
        "targetSpecific": "Specific Agents",
        "selectAgents": "Select Agents",
        "agentsSelected": "{count} agents selected",
        "recipients": "Recipients",
        "recipientsAll": "All Agents",
        "recipientsSpecific": "Specific Agents",
        "selectRecipients": "Select Recipients",
        "recipientsSelected": "{count} agents selected",
        "recipientsAllInfo": "All agents will receive this announcement",
        "recipientsAllInfoText": "{count} agents will receive this announcement",
        "publishing": "Publishing",
        "publish": "Publish",
        "publishNow": "Publish Now",
        "publishLater": "Publish Later",
        "schedule": "Schedule",
        "scheduleAt": "Schedule At",
        "publishDate": "Publish Date",
        "forceConfirmation": "Force Confirmation",
        "forceConfirm": "Force Confirmation",
        "forceConfirmationDesc": "Agents must click \"I understand\" to close",
        "forceConfirmDesc": "Agents must click \"I understand\" to close",
        "cancel": "Cancel",
        "confirm": "Confirm ({count})",
        "save": "Save",
        "sending": "Sending...",
        "bold": "Bold",
        "italic": "Italic",
        "underline": "Underline",
        "list": "List",
        "numberedList": "Numbered List"
      },
      "agentSelector": {
        "title": "Select Agents",
        "search": "Search agents...",
        "selectAll": "Select All",
        "deselectAll": "Deselect All",
        "selected": "Selected",
        "noResults": "No agents found",
        "cancel": "Cancel",
        "confirm": "Confirm"
      },
      "progressModal": {
        "title": "Sending Announcement",
        "sent": "Sent",
        "total": "Total",
        "success": "Sent successfully!",
        "done": "Done"
      },
      "messages": {
        "error": "Error",
        "success": "Success",
        "titleRequired": "Title is required",
        "contentRequired": "Content is required",
        "publishDateRequired": "Publish date is required",
        "selectAtLeastOneAgent": "Please select at least one agent",
        "invalidDate": "Invalid date",
        "dateInPast": "Publish date cannot be in the past.",
        "dateInFuture": "Publish date cannot be more than one month in the future.",
        "loadingAgents": "Unable to load agent list",
        "loadingAnnouncements": "Unable to load announcements",
        "confirmAction": "Confirm Action",
        "confirmToggle": "Are you sure you want to {action} this announcement?",
        "confirmDelete": "Confirm Delete",
        "deleteWarning": "This action is irreversible",
        "deleteWarningText": "Are you sure you want to delete this announcement? This action is irreversible.",
        "announcementUpdated": "Updated!",
        "announcementUpdatedMessage": "Announcement has been updated",
        "announcementActivated": "Activated",
        "announcementDeactivated": "Deactivated",
        "deleted": "Deleted!",
        "announcementDeleted": "Deleted!",
        "announcementDeletedMessage": "Announcement has been deleted",
        "sendingInProgress": "Publishing in progress!",
        "sendingMessage": "Announcement is being sent to agents...",
        "sendingComplete": "Sending complete!",
        "sendingCompleteMessage": "All {count} notifications sent successfully",
        "sendingPartial": "Partially sent",
        "sendingPartialMessage": "{current}/{total} agents have received the notification",
        "scheduled": "Scheduled!",
        "scheduledMessage": "{title} will be published on {date}",
        "published": "Published!",
        "publishedMessage": "{title}",
        "buttonText": {
          "activate": "Activate",
          "deactivate": "Deactivate",
          "delete": "Delete",
          "cancel": "Cancel"
        },
        "progressMessages": {
          "preparing": "Preparing to send...",
          "sending": "Sending notifications ({current}/{total})...",
          "complete": "All notifications sent!"
        }
      }
    },
    "cards": {
      "monthlyEarnings": {
        "title": "Monthly Earnings",
        "lastMonth": "Last Month"
      },
      "regionRevenue": {
        "title": "Revenue by Region",
        "export": "Export",
        "topRegion": "Top Region",
        "revenue": "Revenue"
      },
      "revenueByLocation": {
        "title": "Revenue by Location"
      },
      "revenueReport": {
        "title": "Revenue Report",
        "export": "Export",
        "totalEarnings": "Total Earnings",
        "earningsThisMonth": "Earnings This Month"
      },
      "yearlyBreakup": {
        "title": "Yearly Breakdown",
        "lastYear": "Last Year"
      },
      "timeline": {
        "title": "Timeline"
      }
    },
    "versions": "Versions",
    "setupRemoteConnections": "Setup Remote Connections",
    "currentVisitors": "Current Visitors",
    "charts": {
      "trendyTrends": "Trendy Trends",
      "showInMoreDetail": "Show in more detail",
      "showInLessDetail": "Show in less detail",
      "loadingSpeed": "Loading Speed",
      "topContributors": "Top Contributors",
      "showNextFive": "Show next five",
      "commits": "Commits"
    },
    "info": {
      "componentRichTheme": "Component-rich theme",
      "completedPullRequests": "Completed pull requests",
      "users": "Users",
      "points": "Points",
      "units": "Units",
      "exploreGallery": "Explore Gallery",
      "viewLibrary": "View Library",
      "commits": "Commits",
      "components": "Components",
      "teamMembers": "Team Members"
    },
    "tabs": {
      "overview": {
        "title": "Overview",
        "built": "Built with Vue.js framework",
        "free": "Completely free for everyone",
        "fresh": "Fresh and crisp design",
        "mobile": "Responsive and mobile-optimized",
        "components": "Large collection of useful components",
        "nojQuery": "Absolutely no jQuery"
      },
      "billingAddress": {
        "title": "Billing Address",
        "personalInfo": "Personal Info",
        "firstName": "First & Last Name",
        "email": "Email",
        "address": "Address",
        "companyInfo": "Company Info",
        "game_platforms": "Platforms",
        "game_country_mapping": "Country Mapping",
        "game-platform-i18n": "Platform I18n",
        "game-internationalization": "Game Internationalization",
        "addConnection": "Add Connection"
      },
      "bankDetails": {
        "title": "Bank Details",
        "detailsFields": "Details Fields",
        "bankName": "Bank Name",
        "accountName": "Account Name",
        "sortCode": "Sort Code",
        "accountNumber": "Account Number",
        "notes": "Notes",
        "sendDetails": "Send Details"
      }
    },
    "navigationLayout": "Navigation Layout",
    "topBarButton": "Top Bar Button",
    "sideBarButton": "Side Bar Button"
  },
  "language": {
    "brazilian_portuguese": "Portuguese",
    "english": "English",
    "spanish": "Spanish",
    "simplified_chinese": "Simplified Chinese",
    "persian": "Persian"
  },
  "menu": {
    "price": "Agent Price",
    "user-notification": "Notifications",
    "dashboard": "Dashboard",
    "system-settings": "System settings",
    "domain_name_registration": "Domain Name Registration",
    "purchase_history": "Purchase History",
    "withdraw": "Withdraw Management",
    "withdrawAgent": "Withdraw",
    "agents": "Agents",
        "agents-revenue": "Agents Revenue",
    "content": "Content Management",
    "home": "Home",
    "annonce_editor": "Announce Editor",
    "orders": "Orders",
    "coming_soon": "Coming Soon",
    "admins": "Admins",
    "users_tab": "Users",
    "steal_stat": "Steal Stat",
    "movie-price": "Movie Price",
    "agents-list": "Agent List",
    "agents-commission": "Agent Commission",
    "agent-incomes": "Agent Incomes",
    "chat": "Chat",
    "chat_conversations": "Conversations",
    "chat_log": "Log",
    "versions": "Versions",
    "versions-link": "Version Links",
    "videos": "Videos",
    "all-videos": "All Videos",
    "category": "Category",
    "tag": "Tag",
    "post": "Post",
    "all-post": "All Posts",
    "category_p": "Post Category",
    "tag_p": "Post Tag",
    "media": "Promotion",
    "all-emoji": "All Emojis",
    "emoji": "Emoji",
    "banner": "Banner",
    "ads": "Ads",
    "promotions": "Promotions",
    "promotion-platform": "Platform Promotion",
    "promotion-link": "Link Promotion",
    "promotion-tracking": "Tracking Integration",
    "mangas": "Manga",
    "country": "Country",
    "domain": "Domain",
    "domain_management": "Domain Management",
    "domain_surveillance": "Domain Surveillance",
    "domain_mapping": "Domain Mapping",
    "domain_failover": "Domain Failover",
    "domain_api_change_logs": "Domain API Change Logs",
    "domain_resource_change_logs": "Domain Resource Change Logs",
    "config": "Configuration",
    "game_reduce": "Game Reduce",
    "gestion_traduction": "Translation Management",
    "gestion_jeux": "Game Management",
    "game_catalog": "Catalog",
    "game_platforms": "Platforms",
    "game_country_mapping": "Country",
    "game-platform-i18n": "Translation",
    "game-internationalization": "i18n",
    "landing": "Landing Page",
    "landing-page": "Home",
    "landing-management": "Landing Page Management",
    "vip": "VIP & Movie Price",
    "vip-plans": "VIP Plans",
    "vip-setting": "VIP Setting",
    "vip-rights": "VIP Rights",
    "agents-vip": "VIP Agents",
    "users-vip": "VIP Users",
    "wallet_management": "Wallet Management",
    "orders": "Order Management",
    "announcements": "Announcement Management",
    "notice_management": "Notice Management",
    "system_announcements": "System Announcement",
    "exchange": "Exchange",
    "exchange-plans": "Exchange Plans",
    "payment-platforms": "Payment Platforms",
    "payment-channels": "Payment Channels"
  },
  "messages": {
    "all": "View All Messages",
    "new": "New message from {name}",
    "mark_as_read": "Mark as read",
    "settings": "Settings",
    "billing": "Billing",
    "faq": "FAQ",
    "helpAndSupport": "Help & Support",
    "projects": "Projects",
    "account": "Account",
    "explore": "Explore"
  },
  "treeView": {
    "basic": "Basic",
    "icons": "Icons",
    "selectable": "Selectable",
    "editable": "Editable",
    "advanced": "Advanced"
  },
  "chat": {
    "title": "Chat",
    "chatConversation": {
      "header": "Messages",
      "emptyTitle": "No Messages",
      "emptySubtitle": "Select a conversation to start chatting",
      "users": "Users",
      "showMore": "Show more",
      "defaultUser": "User",
      "defaultUserWithId": "User {id}",
      "loadingConversation": "Loading conversation...",
      "Nomessagesyet": "No messages yet",
      "searchPlaceholder": "Search conversations...",
      "startConversation": "Start conversation",
      "noConversations": "No conversations found",
      "conversations": "Conversation",
      "newConversation": "New Conversation",
      "online": "Online",
      "messagePlaceholder": "Write a message...",
      "selectConversation": "Select a conversation to start",
      "contactName": "Contact Name",
      "enterContactName": "Enter the contact name",
      "create": "Create",
      "cancel": "Cancel",
      "timeFormat": {
        "instant": "just now",
        "minutesMarker": "m",
        "hoursMarker": "h",
        "daysMarker": "d"
      },
      "messageStatus": {
        "sending": "Sending...",
        "sent": "Sent",
        "received": "Received",
        "failed": "Send failed"
      },
      "errors": {
        "missingRecipientId": "Error: Missing recipient user ID, unable to send the message."
      },
      "type": {
        "supportAgent": "Support Agent",
        "supportReclamation": "Support Claim",
        "supportVideo": "Support Video",
        "supportGame": "Support Game"
      },
      "sessionInfo": {
        "buttonLabel": "Agent information",
        "modalTitle": "Agent session information",
        "noData": "No session information available.",
        "errorLoad": "Unable to load session information.",
        "yes": "Yes",
        "no": "No",
        "fields": {
          "sessionId": "Session ID",
          "userId": "User ID",
          "chatId": "Chat ID",
          "ip": "IP",
          "country": "Country",
          "region": "Region",
          "city": "City",
          "platform": "Platform",
          "osVersion": "OS Version",
          "sdkInt": "SDK Int",
          "isPhysicalDevice": "Physical Device",
          "brand": "Brand",
          "manufacturer": "Manufacturer",
          "model": "Model",
          "appVersion": "App Version",
          "buildNumber": "Build Number",
          "packageName": "Package Name",
          "flavor": "Flavor",
          "createdAt": "Created At"
        }
      }
    }
  },
  "coming_soon": {
    "title": "Coming Soon"
  },
  "cards": {
    "cards": "Cards",
    "fixed": "Fixed",
    "floating": "Floating",
    "contentText": "Their unique black and white stripes make them one of the most familiar animals.",
    "rowHeight": "Row Height",
    "title": {
      "dark": "Dark Background",
      "bright": "Bright Card",
      "titleOnImageNoOverlay": "Title on Image without Overlay",
      "normal": "Standard Card",
      "overlayAndTextOnImage": "Card with Overlay and Text on Image"
    },
    "button": {
      "main": "Main",
      "cancel": "Cancel",
      "showMore": "Show More",
      "readMore": "Read More",
      "select": {
        "dark": "Dark",
        "light": "Light"
      }
    },
    "link": {
      "edit": "Edit",
      "setAsDefault": "Set as Default",
      "delete": "Delete",
      "traveling": "Traveling",
      "france": "France",
      "review": "Review",
      "feedback": "Feedback",
      "readFull": "Read Full",
      "secondaryAction": "Secondary Action",
      "action1": "Action 1",
      "action2": "Action 2"
    }
  },
  "helpAndSupport": "Help & Support",
  "aboutVuesticAdmin": "About Vuestic Admin",
  "search": {
    "placeholder": "Search..."
  },
  "paymentStats": {
    "title": "Financial Statistics",
    "realtimeOverview": "Real-time Overview",
    "live": "Live",
    "payers": "Payers",
    "totalUsers": "Total Users",
    "vsYesterday": "vs Yesterday",
    "today": "Today",
    "yesterday": "Yesterday",
    "thisMonth": "This Month",
    "lastMonth": "Last Month",
    "orders": "Orders",
    "totalPurchases": "Total Purchases",
    "revenue": "Revenue",
    "totalAmount": "Total Amount",
    "conversionFunnel": "Conversion Funnel",
    "todayPerformance": "Today's Performance",
    "visitToRegistration": "Visit → Registration",
    "registrationToPayment": "Registration → Payment",
    "visits": "Visits",
    "registrations": "Registrations",
    "payments": "Payments",
    "detailsByType": "Details by payment type",
    "breakdownByPaymentType": "Breakdown by payment type",
    "allTime": "All time",
    "noDataForPeriod": "No data for this period"
  },
  "vuestic": {
    "search": "Search",
    "noOptions": "No items found",
    "ok": "OK",
    "cancel": "Cancel",
    "uploadFile": "Upload File",
    "undo": "Undo",
    "dropzone": "Drop files here to upload",
    "fileDeleted": "File deleted",
    "closeAlert": "Close alert",
    "backToTop": "Back to top",
    "toggleDropdown": "Toggle dropdown",
    "carousel": "Carousel",
    "goPreviousSlide": "Previous slide",
    "goNextSlide": "Next slide",
    "goSlide": "Go to slide {index}",
    "slideOf": "Slide {index} of {length}",
    "close": "Close",
    "openColorPicker": "Open color picker",
    "colorSelection": "Color selection",
    "colorName": "Color {color}",
    "decreaseCounter": "Decrease counter",
    "increaseCounter": "Increase counter",
    "selectAllRows": "Select all rows",
    "sortColumnBy": "Sort by {name}",
    "selectRowByIndex": "Select row {index}",
    "resetDate": "Reset date",
    "nextPeriod": "Next period",
    "switchView": "Switch view",
    "previousPeriod": "Previous period",
    "removeFile": "Remove file",
    "reset": "Reset",
    "pagination": "Pagination",
    "goToTheFirstPage": "Go to first page",
    "goToPreviousPage": "Go to previous page",
    "goToSpecificPage": "Go to page {page}",
    "goToSpecificPageInput": "Enter page number to jump",
    "goNextPage": "Go to next page",
    "goLastPage": "Go to last page",
    "currentRating": "Current rating {value} / {max}",
    "voteRating": "Rating {value} / {max}",
    "optionsFilter": "Options filter",
    "splitPanels": "Split panels",
    "movePaginationLeft": "Move pagination left",
    "movePaginationRight": "Move pagination right",
    "resetTime": "Reset time",
    "closeToast": "Close toast",
    "selectedOption": "Selected option",
    "noSelectedOption": "No option selected",
    "breadcrumbs": "Breadcrumbs",
    "counterValue": "Counter value",
    "selectedDate": "Selected date",
    "selectedTime": "Selected time",
    "progressState": "Progress state",
    "color": "Color",
    "next": "Next",
    "back": "Back",
    "finish": "Finish",
    "step": "Step",
    "progress": "Progress",
    "loading": "Loading",
    "sliderValue": "Current slider value is {value}",
    "switch": "Switch",
    "inputField": "Input field",
    "fileTypeIncorrect": "Incorrect file type",
    "select": "Select an option"
  },
  "notifications": {
    "title": "Notifications",
    "markAllAsRead": "Mark all as read",
    "loading": "Loading...",
    "noNotifications": "No notifications",
    "importantNotification": "Important Notification",
    "actionRequired": "Action Required",
    "confirmReading": "Please confirm you have read this notification",
    "cancel": "Cancel",
    "iUnderstand": "I Understand",
    "newNotificationReceived": "New notification received!",
    "atTheInstant": "Just now",
    "minutesAgo": "{count} minutes ago",
    "hoursAgo": "{count} hours ago",
    "yesterday": "Yesterday",
    "daysAgo": "{count} days ago",
    "scheduledNotificationPublished": "Scheduled notification published!",
    "view": "View",
    "viewNotification": "View notification",
    "close": "Close"
  },
  "agentAnnouncements": {
    "title": "Announcements",
    "noAnnouncements": "No announcements found.",
    "loading": "Loading announcements...",
    "markAsRead": "Mark as Read",
    "markAsConfirmed": "Confirmed",
    "date": "Published on",
    "page": "Page",
    "prev": "Previous",
    "next": "Next",
    "new": "NEW"
  },
  "translations": {
    "header": {
      "title": "Translation Management",
      "subtitle": "Manage your multilingual translations with ease",
      "importJson": "Import JSON",
      "newTranslation": "New Translation",
      "translations": "Translations",
      "activeLanguages": "Active Languages",
      "languages": "Languages",
      "configured": "Configured"
    },
    "modal": {
      "title": "New Translation",
      "editTitle": "Edit Translation",
      "keyLabel": "Translation Key",
      "keyPlaceholder": "Enter translation key...",
      "valueLabel": "Translation Value",
      "jsonPlaceholder": "@:example_json",
      "valuePlaceholder": "Enter translation...",
      "languageLabel": "Language",
      "cancel": "Cancel",
      "add": "Add",
      "update": "Update"
    },
    "search": {
      "placeholder": "Search key or value..."
    },
    "pagination": {
      "showing": "Showing",
      "to": "to",
      "of": "of",
      "entries": "entries",
      "first": "First",
      "previous": "Previous",
      "next": "Next",
      "last": "Last",
      "show": "Show"
    },
    "table": {
      "key": "Key",
      "value": "Value",
      "actions": "Actions",
      "edit": "Edit",
      "delete": "Delete",
      "noData": "No translations available"
    },
    "transactionModal": {
      "title": "New Translation",
      "editTitle": "Edit Translation",
      "importJson": "Import JSON",
      "jsonScriptLabel": "JSON Script",
      "jsonPlaceholder": "@:example_json",
      "formatJson": "Format JSON",
      "format": "Format",
      "jsonInvalid": "Invalid JSON format",
      "jsonHelp": "Paste your JSON script here. The text area supports complex JSON objects and arrays.",
      "languageLabel": "Language",
      "cancel": "Cancel",
      "add": "Add",
      "update": "Update"
    },
    "messages": {
      "translationAdded": "Translation added",
      "translationUpdated": "Translation updated",
      "translationDeleted": "Translation deleted",
      "translationsAdded": "translations added",
      "transactionsAdded": "transactions successfully imported",
      "jsonFormatted": "JSON formatted successfully",
      "jsonInvalid": "Invalid JSON format",
      "errorAdd": "Error adding",
      "errorUpdate": "Error updating",
      "errorDelete": "Error deleting",
      "errorImport": "Error importing",
      "jsonNotValid": "JSON invalid (must be an object)",
      "noDataProvided": "No transaction data provided",
      "dataMustBeObject": "Data must be a JSON object"
    },
    "errorMessages": {
      "saveError": "Unable to save announcement",
      "statusError": "Unable to modify status",
      "deleteError": "Unable to delete announcement",
      "fetchError": "Unable to load announcements"
    },
    "toastMessages": {
      "languageLoadError": "Error loading language",
      "noTransactionAvailable": "No transaction available for this language",
      "pleasePasteJsonData": "Please paste JSON data",
      "jsonNotValidObject": "JSON invalid (must be an object)",
      "noDataProvided": "No transaction data provided",
      "dataMustBeObject": "Data must be a JSON object"
    },
    "confirmDelete": "Delete this translation?",
    "importTransactions": {
      "title": "Import Transactions",
      "jsonDataLabel": "JSON data to import",
      "formatButton": "Format",
      "clearButton": "Clear",
      "jsonHelpText": "Paste your JSON object here. Example: key: value, anotherKey: anotherValue",
      "targetLanguage": "Target Language:",
      "cancelButton": "Cancel",
      "importButton": "Import",
      "importing": "Importing..."
    }
  },
  "example_json": "key: value, nested: data: example",
  "posts": {
    "pageTitle": "Posts",
    "editPost": "Edit Post",
    "addPost": "Add Post",
    "openVideo": "Open Video",
    "titleLabel": "Title",
    "contentLabel": "Content",
    "categoryIdLabel": "Category ID",
    "timeJustNow": "just now",
    "timeMinute": "{count} minute ago",
    "timeMinutes": "{count} minutes ago",
    "timeHour": "{count} hour ago",
    "timeHours": "{count} hours ago",
    "timeDay": "{count} day ago",
    "timeDays": "{count} days ago",
    "timeWeek": "{count} week ago",
    "timeWeeks": "{count} weeks ago",
    "timeMonth": "{count} month ago",
    "timeMonths": "{count} months ago",
    "timeYear": "{count} year ago",
    "timeYears": "{count} years ago",
    "priceLabel": "Price",
    "pinnedLabel": "Pinned",
    "featuredLabel": "Featured",
    "statusLabel": "Status",
    "normalStatus": "Normal",
    "deletedStatus": "Deleted",
    "hiddenStatus": "Hidden",
    "cancelButton": "Cancel",
    "saveButton": "Save",
    "postDetails": "Post Details",
    "idLabel": "ID",
    "userIdLabel": "User ID",
    "createdAtLabel": "Created At",
    "viewsLabel": "Views",
    "favoritesLabel": "Favorites",
    "likesLabel": "Likes",
    "notPinned": "Not Pinned",
    "notFeatured": "Not Featured",
    "closeButton": "Close",
    "loadingPosts": "Loading posts...",
    "totalPosts": "Total Posts",
    "totalViews": "Total Views",
    "totalLikes": "Total Likes",
    "totalDislikes": "Total Dislikes",
    "totalComments": "Total Comments",
    "pinnedPosts": "Pinned Posts",
    "featuredPosts": "Featured Posts",
    "engagementRate": "Engagement Rate",
    "normalPosts": "Normal Posts",
    "hiddenPosts": "Hidden Posts",
    "deletedPosts": "Deleted Posts",
    "searchLabel": "Search",
    "searchPlaceholder": "Search by title or content...",
    "addNewPost": "Add New Post",
    "showing": "Showing",
    "of": "of",
    "posts": "posts",
    "filtered": "(filtered)",
    "noPostsFound": "No posts found.",
    "noPostsMatch": "No posts match your search or filter criteria.",
    "userLabel": "User",
    "categoryLabel": "Category",
    "actionsLabel": "Actions",
    "detailsButton": "Details",
    "editButton": "Edit",
    "deleteButton": "Delete",
    "previousButton": "Previous",
    "nextButton": "Next",
    "pageLabel": "Page",
    "titleAndContentRequired": "Title and content are required",
    "categoryIdPositive": "Category ID must be positive",
    "priceZeroOrPositive": "Price must be zero or positive",
    "confirmDelete": "Are you sure you want to delete this post?",
    "errorLoading": "Error loading posts",
    "errorUpdating": "Error updating post",
    "errorDeleting": "Error deleting post",
    "editAllPrices": "Edit All Prices",
    "randomPriceExplanation": "Update prices for all posts with random values between min and max",
    "minPrice": "Minimum Price",
    "maxPrice": "Maximum Price",
    "enterAtLeastOnePrice": "Please enter at least one price",
    "updateBtn": "Update"
  },
  "categoryPost": {
    "pageTitle": "Post Categories",
    "editCategoryPost": "Edit Post Category",
    "addNewCategoryPost": "Add New Post Category",
    "nameLabel": "Name",
    "namePlaceholder": "Post category name",
    "sortOrderLabel": "Sort Order",
    "sortOrderPlaceholder": "0",
    "showOnHomeLabel": "Show on Home",
    "cancelButton": "Cancel",
    "saveButton": "Save",
    "searchPlaceholder": "Search post categories...",
    "addNewCategoryPostButton": "Add New Post Category",
    "loadingCategoryPosts": "Loading post categories... Please wait",
    "noCategoryPostsFound": "No post categories found.",
    "noResultsFound": "No results found.",
    "idLabel": "ID",
    "createdAtLabel": "Created At",
    "actionsLabel": "Actions",
    "nameIsRequired": "Name is required",
    "errorLoadingCategoryPosts": "Error loading post categories",
    "errorSavingCategoryPost": "Error saving post category",
    "errorDeletingCategoryPost": "Error deleting post category",
    "confirmDeleteCategoryPost": "Are you sure you want to delete this post category?",
    "deleteCategoryPost": "Delete Post Category",
    "createFirstCategoryPost": "Create your first post category to get started",
    "tryAdjustingSearch": "Try adjusting your search",
    "clearSearchButton": "Clear Search",
    "updateCategoryPostButton": "Update Post Category",
    "createCategoryPostButton": "Create Post Category",
    "createFirstCategoryPostButton": "Create First Post Category",
    "badges": {
      "home": "Home"
    },
    "stats": {
      "totalCategoryPosts": "Total Categories",
      "thisWeek": "New this week",
      "lastUpdated": "Last Updated"
    }
  },
  "pagination": {
    "pageOf": "Page {current} of {total}",
    "show": "Show"
  },
  "currency": {
    "symbol": "¥"
  },
  "tagPost": {
    "pageTitle": "Post Tag Management",
    "editTag": "Edit Tag",
    "addNewTag": "Add New Tag",
    "tagNameLabel": "Tag Name",
    "tagNamePlaceholder": "e.g.: Breaking News, Featured, Urgent...",
    "cancelButton": "Cancel",
    "createTag": "Create Tag",
    "updateTag": "Update Tag",
    "loadingTags": "Loading tags...",
    "totalTags": "Total Tags",
    "thisWeek": "This Week",
    "lastUpdated": "Last Updated",
    "searchPlaceholder": "Search tags by name...",
    "addTag": "Add Tag",
    "noTagsYet": "No tags yet",
    "createFirstTagDescription": "Create your first post tag to get started",
    "createFirstTag": "Create First Tag",
    "noTagsFound": "No tags found",
    "tryAdjustingSearch": "Try adjusting your search",
    "clearSearch": "Clear Search",
    "idLabel": "ID",
    "tagNameHeader": "Tag Name",
    "createdDate": "Created Date",
    "actionsLabel": "Actions",
    "editTagTitle": "Edit Tag",
    "deleteTagTitle": "Delete Tag",
    "tagNameRequired": "Tag name is required",
    "errorLoadingTags": "Error loading tags",
    "errorSavingTag": "Error saving tag",
    "errorDeletingTag": "Error deleting tag",
    "confirmDeleteTag": "Delete \"{tagName}\"?"
  },
  "emoji": {
    "title": "Emoji Management",
    "addNew": "Add New Emoji",
    "addNewGroup": "Add New Group",
    "updateEmoji": "Update Emoji",
    "confirmDelete": "Confirm Delete",
    "code": "Code",
    "images": "Images (max 100)",
    "single": "Single",
    "multiple": "Multiple",
    "group": "Group",
    "type": "Type",
    "groupName": "Group Name",
    "description": "Description",
    "status": "Status",
    "newImage": "New Image",
    "cancel": "Cancel",
    "addEmojis": "Add {count} Emojis",
    "createGroup": "Create Group",
    "save": "Save",
    "newGroup": "New Group",
    "totalEmojis": "Total Emojis",
    "groups": "Groups",
    "svgEmojis": "SVG Emojis",
    "gifEmojis": "GIF Emojis",
    "jpgEmojis": "JPG Emojis",
    "filterByGroup": "Filter by Group",
    "filterByType": "Filter by Type",
    "allGroups": "All Groups",
    "allTypes": "All Types",
    "reset": "Reset",
    "loading": "Loading emojis...",
    "id": "ID",
    "image": "Image",
    "url": "URL",
    "actions": "Actions",
    "selectAGroup": "Select a group",
    "nameRequired": "Name is required",
    "codeRequired": "Code is required",
    "noGroupFound": "⚠️ No groups found. Please create one first",
    "filesSelected": "{count} files selected",
    "keepCurrentImage": "Keep current image if no file selected",
    "areYouSureDelete": "Are you sure you want to delete this emoji",
    "emojiNumber": "Emoji #{id}",
    "groupDescription": "Group Description",
    "codePlaceholder": "e.g.: smiley_face",
    "groupNamePlaceholder": "e.g.: Emotions",
    "groupCodePlaceholder": "e.g.: emotions",
    "groupDescriptionPlaceholder": "Group description",
    "svg": "SVG",
    "jpg": "JPG",
    "gif": "GIF",
    "imageRequired": "Image required",
    "pleaseSelectImage": "Please select an image",
    "chooseFile": "Choose File",
    "noFileChosen": "No file chosen",
    "previous": "Previous",
    "next": "Next",
    "page": "Page {page}",
    "groupCreated": "Group \"{name}\" created!",
    "pleaseCorrectErrors": "Please correct errors",
    "errorCreatingGroup": "Error creating group",
    "emojiUpdated": "Emoji updated!",
    "errorUpdatingEmoji": "Error updating emoji",
    "emojiDeleted": "Emoji deleted!",
    "errorDeletingEmoji": "Error deleting emoji",
    "emojiCreated": "Emoji created!",
    "errorCreatingEmoji": "Error creating emoji",
    "emojiStatusUpdated": "Emoji status updated!",
    "errorUpdatingEmojiStatus": "Error updating emoji status",
    "onlyOneFileAllowed": "Single file mode allows only one file",
    "maximum100Files": "Maximum 100 files allowed",
    "fileTypeNotSupported": "File type not supported",
    "fileTooLarge": "File too large (max 2MB)",
    "pleaseCreateGroup": "Please create a group first",
    "errorLoadingEmoji": "Error loading emojis",
    "errorLoadingGroups": "Error loading groups",
    "noEmojiSelected": "No emoji selected",
    "fileNotSupported": "File not supported. Please use JPEG, PNG, GIF, WebP or SVG.",
    "fileTooLargeMessage": "File too large. Maximum 2MB.",
    "emojiCreatedSuccess": "{count} emojis created successfully!",
    "activated": "Activated",
    "deactivated": "Deactivated",
    "noEmojiAvailable": "No emojis available",
    "noResultForFilter": "No results found for current filters",
    "createGroupFirst": "Please create a group first",
    "tryModifyFilter": "Try modifying filters",
    "createAGroup": "Create a Group",
    "addEmoji": "Add Emoji",
    "resetFilters": "Reset Filters",
    "edit": "Edit",
    "delete": "Delete",
    "noGroup": "No Group",
    "preview": "Preview"
  },
  "banner": {
    "pageTitle": "Banners",
    "searchPlaceholder": "Search banners...",
    "addBanner": "Add Banner",
    "noImage": "No image",
    "pageOf": "Page {page} of {totalPages}",
    "editBanner": "Edit Banner",
    "addNewBanner": "Add New Banner",
    "nameLabel": "Name *",
    "namePlaceholder": "Enter banner name",
    "descriptionLabel": "Description",
    "descriptionPlaceholder": "Enter banner description",
    "expirationDateLabel": "Expiration Date *",
    "bannerImageLabel": "Banner Image",
    "chooseFile": "Choose File",
    "noFileSelected": "No file selected",
    "cancel": "Cancel",
    "update": "Update",
    "create": "Create",
    "bannerDetails": "Banner Details",
    "name": "Name:",
    "description": "Description:",
    "expirationDate": "Expiration Date:",
    "noBannersTitle": "No Banners",
    "noBannersDescription": "Start by adding your first banner to display",
    "addFirstBanner": "Add First Banner",
    "close": "Close",
    "id": "ID",
    "image": "Image",
    "nameHeader": "Name",
    "descriptionHeader": "Description",
    "expiresAt": "Expires At",
    "actions": "Actions",
    "confirmDelete": "Are you sure you want to delete \"{name}\"?"
  },
  "users": {
    "title": "Users",
    "active": "Active",
    "noData": "No items found.",
    "noFiltered": "No items match the filter criteria.",
    "filterByAgent": "Filter by Agent",
    "createVip": "Create",
    "selectVipPlan": "Please select a VIP plan",
    "vipCreated": "VIP created for {username}",
    "inactive": "Inactive",
    "search": "Search",
    "displayId": "Display ID",
    "addAdmin": "Add Admin",
    "editUser": "Edit User",
    "addUser": "Add User",
    "save": "Save",
    "add": "Add",
    "page": "page",
    "passwordRetrait": "Withdraw password",
    "of": "of",
    "chooseAvatarFile": "Choose an avatar file",
    "phone": "Phone",
    "points": "Points",
    "country": "Country",
    "visitor": "Visitor",
    "verified": "Verified",
    "nickname": "Nickname",
    "update": "Update",
    "createdAt": "Created At",
    "userUpdated": "{username} updated",
    "userCreated": "{username} created",
    "userDeleted": "{username} deleted",
    "unsavedChanges": "The form has unsaved changes. Are you sure you want to close it?",
    "username": "Username",
    "loginId": "Login ID",
    "optionId": "game channel",
    "optionIdPlaceholder": "Enter game channel",
    "password": "Password",
    "confirmPassword": "Confirm Password",
    "changePassword": "Change Password",
    "changePasswordFor": "Change password for {username}",
    "role": "Role",
    "admin": "Admin",
    "agent": "Agent",
    "avatar": "Avatar",
    "payment": "Payment",
    "duration": "Duration",
    "expires": "Expires",
    "results": "Results",
    "resultsPerPage": "Results per page",
    "previousPage": "Previous Page",
    "nextPage": "Next Page",
    "blockUser": "Block User",
    "confirmBlockUser": "Are you sure you want to block {username}?",
    "deleteUser": "Delete User",
    "deleteUserConfirm": "Are you sure you want to delete {username}?",
    "passwordRequired": "Confirm password is required",
    "passwordMismatch": "Passwords do not match",
    "errorMessage": "Error: {error}",
    "usernameExists": "Username '{username}' already exists. Please choose another one.",
    "commissionRate": "Commission Rate",
    "revenue": "Revenue",
    "status": "Status",
    "notAvailable": "Not Available",
    "actions": "Actions",
    "id": "ID",
    "yes": "Yes",
    "no": "No",
    "notVerified": "Not Verified",
    "updateVip": "Update VIP",
    "changeVipPlan": "Change VIP plan",
    "keepCurrentVip": "Keep current VIP",
    "newPassword": "New Password",
    "confirmNewPassword": "Confirm New Password",
    "vipSettings": "VIP Settings",
    "currentVipCard": "Current VIP Card",
    "days": "Days",
    "noVip": "No VIP",
    "vip": "VIP",
    "vipRequired": "VIP*",
    "selectOption": "Choose an option",
    "unlimitedVideos": "Watch all videos unlimited",
    "lifetimeVideos": "Watch all videos lifetime",
    "yearVideos": "Watch all videos for 1 year",
    "monthVideos": "Watch all videos for 1 month",
    "dayVideos": "Watch all videos for 1 day",
    "durationRequired": "Duration*",
    "unit": "Unit*",
    "minutes": "Minutes",
    "hour": "Hour",
    "day": "Day",
    "vipNote": "Note: remove user's previous VIP status",
    "submit": "Submit",
    "vipRenewed": "VIP renewed for {username}",
    "vipRenewalError": "Error during VIP renewal",
    "selectValidityType": "Please select a validity type",
    "fillDurationUnit": "Please fill in duration and unit",
    "enterNewPassword": "Enter a new password",
    "passwordsDoNotMatch": "Passwords do not match",
    "passwordUpdated": "Password updated for {username}",
    "passwordUpdateError": "Error updating password",
    "createError": "Error creating user {username}: {error}",
    "unknownError": "Unknown error",
    "cancel": "Cancel",
    "tableHeaders": {
      "username": "Username",
      "nickname": "Nickname",
      "phone": "Phone",
      "role": "Role",
      "id": "ID",
      "vip": "VIP",
      "points": "Points",
      "country": "Country",
      "agent": "Agent",
      "visitor": "From APP",
      "verified": "Verified",
      "createdAt": "Created At",
      "status": "Status"
    },
    "common": {
      "search": "Search",
      "all": "All",
      "status": "Status",
      "active": "Active",
      "inactive": "Inactive",
      "actions": "Actions",
      "edit": "Edit",
      "delete": "Delete",
      "save": "Save",
      "create": "Create",
      "cancel": "Cancel",
      "close": "Close",
      "add": "Add",
      "update": "Update",
      "loading": "Loading",
      "retry": "Retry",
      "error": "An error occurred",
      "yes": "Yes",
      "no": "No",
      "confirmDelete": "Are you sure you want to delete?",
      "activate": "Activate",
      "deactivate": "Deactivate"
    }
  },
  "country": {
    "title": "Country Language Manager",
    "searchPlaceholder": "Search by country or language code...",
    "addLanguage": "Add Language",
    "id": "ID",
    "country": "Country",
    "languageCode": "Language Code",
    "name": "Name",
    "deleteLanguage": "Delete Language",
    "namePlaceholder": "French, English, Spanish, etc.",
    "lang": "Language (short code)",
    "langPlaceholder": "fr, en, es, etc.",
    "flag": "Flag",
    "version": "Version",
    "actions": "Actions",
    "noFlag": "No flag",
    "addNewLanguage": "Add New Language",
    "countryName": "Country Name",
    "languageCodePlaceholder": "fr-FR, en-US, etc.",
    "flagImage": "Flag Image",
    "chooseFile": "Choose File",
    "noFileSelected": "No file selected",
    "versionDate": "Version Date",
    "updateLanguage": "Update Language",
    "chooseNewFlag": "Choose New Flag",
    "new": "New",
    "currentFlag": "Current Flag",
    "viewCurrentFlag": "View Current Flag",
    "confirmDelete": "Confirm Delete",
    "deleteConfirmMessage": "Are you sure you want to delete {country} ({language})? This action cannot be undone.",
    "loadFailed": "Failed to load languages",
    "requiredFields": "Country name, language code, name, language (short code) and version are required",
    "invalidCountryName": "Country name can only contain letters, spaces, hyphens or apostrophes",
    "countryExists": "Country already exists",
    "countryNameExists": "Another country with this name already exists",
    "createSuccess": "Language created successfully",
    "createFailed": "Failed to create language",
    "updateSuccess": "Language updated successfully",
    "updateFailed": "Failed to update language",
    "deleteSuccess": "Language deleted successfully",
    "deleteFailed": "Failed to delete language",
    "loadingLanguages": "Loading languages...",
    "noLanguagesFound": "No languages found",
    "createFirstLanguage": "Create your first language",
    "createFirstLanguageButton": "Create Language",
    "noLanguagesMatch": "No languages match your search",
    "tryAdjustingSearch": "Try adjusting your search criteria",
    "clearSearchButton": "Clear Search",
    "stats": {
      "totalLanguages": "Total Languages",
      "thisWeek": "New this week",
      "lastUpdated": "Last Updated"
    }
  },
  "systemSettings": {
    "pageTitle": "System settings",
    "sectionJdVideoConfig": "JD Video Configuration",
    "jdVideoConfigUrlLabel": "JD Video Config URL",
    "jsonLabelJdVideoConfig": "JD Video Config (JSON)",
    "sectionApi": "API domain settings",
    "sectionAgentRedirect": "Agent Redirect",
    "agentRedirectHint": "Agent Redirect Hint",
    "agentRedirectLabel": "Agent Redirect",
    "agentRedirectFallback": "Agent Redirect Fallback",
    "sectionVersionUrls": "Version URL Settings",
    "versionUrlsHint": "Edit the latest version download URLs for Android and iOS.",
    "latestVersionBadge": "Latest version:",
    "addVersionButton": "Add Version",
    "versionNumberLabel": "Version Number",
    "versionDateLabel": "Release Date",
    "versionDescriptionLabel": "Description",
    "versionIsMultiLabel": "Multiple",
    "versionForceInstallLabel": "Force install",
    "versionCreateRequired": "Version, release date, description, Android URL and iOS URL are required.",
    "versionCreateInvalid": "Version number must be in format X.Y.Z.",
    "versionCreateSuccess": "Version created successfully.",
    "versionCreateFailed": "Failed to create version.",
    "versionAndroidUrlLabel": "Android URL",
    "versionIosUrlLabel": "iOS URL",
    "versionUrlsRequired": "Android URL and iOS URL are required.",
    "versionMissingId": "Latest version could not be identified.",
    "cancel": "Cancel",
    "create": "Create",
    "sectionLanding": "App landing settings",
    "sectionArchive": "Legacy video domain settings",
    "sectionIos": "iOS bookmark settings",
    "sectionCfDomain": "New library playback domain settings",
    "hintApiDomains": "Editable domains array (keep at least one). JSON and list stay in sync.",
    "addDomain": "Add domain",
    "addDocs": "Add docs",
    "openDocs": "Open docs",
    "delete": "Delete",
    "save": "Save",
    "jsonLabelApi": "JSON (API settings)",
    "jsonLabelLanding": "JSON (app landing)",
    "videoUrl": "Video URL",
    "coverUrl": "Cover URL",
    "jsonLabelArchive": "JSON (legacy video)",
    "iosHint": "Comma-separated plain text (not JSON). At least one non-empty bookmark.",
    "addBookmark": "Add bookmark",
    "iosTextareaLabel": "Bookmark list (comma-separated)",
    "cfDomainLabel": "Playback domain",
    "loading": "Loading from server…",
    "loaded": "Loaded from server.",
    "saving": "Saving…",
    "saved": "Saved to server.",
    "lastUpdated": "Last updated",
    "loadFailed": "Load failed",
    "saveFailed": "Save failed",
    "validationFailed": "Validation failed; not submitted.",
    "invalidJson": "Invalid JSON; not submitted.",
    "remoteInvalid": "Remote data invalid",
    "remoteJsonParse": "Remote JSON could not be parsed.",
    "domainUrlPlaceholder": "Domain URL",
    "errJsonObject": "JSON must be an object.",
    "errDomains": "Missing domains array.",
    "errDomainsMin": "domains must contain at least one item.",
    "errDomainItem": "Each domain entry needs a valid domain string.",
    "errUrl": "Video URL (url) must be a string.",
    "errCover": "Cover URL (cover) must be a string.",
    "errIosMin": "Keep at least one bookmark.",
    "errIosEmpty": "At least one non-empty bookmark URL is required.",
    "errCfDomainEmpty": "Playback domain cannot be empty.",
    "jsonParseFailed": "JSON parse failed.",
    "expandJson": "Expand JSON",
    "collapseJson": "Collapse JSON",
    "exportApiJson": "Export api.json",
    "exportApiJsonSuccess": "api.json downloaded.",
    "exportApiJsonFailed": "Export failed",
    "docsModal": {
      "title": "Add docs - {target}",
      "description": "Choose how you want to attach documentation for this setting.",
      "modeFile": "File",
      "modeFileHint": "Upload a document directly from your device.",
      "modeLink": "Link",
      "modeLinkHint": "Use an external URL for the documentation.",
      "linkLabel": "Documentation link",
      "linkPlaceholder": "https://example.com/docs",
      "fileLabel": "Documentation file",
      "fileEmpty": "No file selected yet.",
      "submit": "Submit",
      "linkRequired": "Documentation link is required.",
      "fileRequired": "Documentation file is required.",
      "success": "Documentation saved successfully.",
      "error": "Failed to save documentation."
    }
  },
  "config": {
    "title": "Configuration Management",
    "editConfig": "Edit Configuration",
    "addNewConfig": "Add New Configuration",
    "configKey": "Config Key",
    "configKeyPlaceholder": "Write anything",
    "type": "Type",
    "typePlaceholder": "Select a type",
    "value": "Value",
    "valuePlaceholder": "Enter text value",
    "valueNumberPlaceholder": "0",
    "valueBool": "Value (1 = true, 0 = false)",
    "uploadFile": "Upload File",
    "imageFile": "Image File",
    "cancel": "Cancel",
    "save": "Save Config",
    "saving": "Saving...",
    "update": "Update",
    "totalConfigs": "Total Configs",
    "boolean": "Boolean",
    "string": "String",
    "number": "Number",
    "image": "Image",
    "files": "Files",
    "searchPlaceholder": "Search configurations...",
    "addConfig": "Add Config",
    "id": "ID",
    "key": "Key",
    "created": "Created",
    "actions": "Actions",
    "true": "True",
    "false": "False",
    "edit": "Edit",
    "delete": "Delete",
    "page": "Page",
    "of": "of",
    "show": "Show",
    "noConfigsFound": "No configurations found",
    "configCreated": "Configuration created successfully",
    "configUpdated": "Configuration updated successfully",
    "configDeleted": "Configuration deleted successfully",
    "createFailed": "Failed to create configuration",
    "updateFailed": "Failed to update configuration",
    "deleteFailed": "Failed to delete configuration",
    "confirmDelete": "Are you sure you want to delete this configuration?",
    "requiredFields": "Key and type are required",
    "invalidKey": "Key can only contain letters, numbers, underscores and hyphens",
    "configExists": "Configuration with this key already exists",
    "notification": {
      "titleLabel": "Notification Title",
      "bodyTitle": "Content (Body)",
      "addBodyLine": "Add line",
      "linksTitle": "Links (LinkList)",
      "addLink": "Add link",
      "linkTextLabel": "Text",
      "linkTextPlaceholder": "Button text",
      "linkUrlLabel": "URL"
    },
    "errors": {
      "unexpected": "Unexpected error",
      "fetchNotification": "Failed to fetch notification configuration",
      "updateNotification": "Failed to update notification configuration",
      "fetchAgentConfigs": "Failed to fetch agent configurations",
      "fetchKeys": "Failed to fetch configuration keys",
      "updateAgentConfigs": "Failed to update agent configurations",
      "updateAgentConfig": "Failed to update agent configuration",
      "loadAgentConfigs": "Failed to load agent configurations",
      "addItem": "Failed to add item",
      "removeItem": "Failed to remove item",
      "addField": "Failed to add field",
      "invalidJsonObject": "JSON must be an object",
      "addBodyItem": "Failed to add body line",
      "removeBodyItem": "Failed to remove body line",
      "addLinkItem": "Failed to add link",
      "removeLinkItem": "Failed to remove link",
      "copyJson": "Failed to copy JSON",
      "keyRequired": "Configuration key is required",
      "typeRequired": "Please select a type",
      "boolValueRequired": "Please set a value (1 or 0)",
      "stringValueRequired": "Please enter a string value",
      "numberValueRequired": "Please enter a number value",
      "fileRequired": "Please upload an image file"
    },
    "json": {
      "editTitle": "Edit JSON Configuration",
      "viewTitle": "View JSON Configuration",
      "addLink": "Add Link",
      "remove": "Remove",
      "addNewField": "Add New Field",
      "text": "Text",
      "url": "URL",
      "linkText": "Link Text",
      "linkUrl": "Link URL",
      "readOnly": "Read Only",
      "view": "View",
      "jsonData": "JSON Data",
      "invalidJson": "Invalid JSON format",
      "failedToSave": "Failed to save JSON configuration",
      "viewContent": "View Current JSON",
      "copyJson": "Copy JSON"
    }
  },
  "announceEditor": {
    "title": "Announce Editor",
    "confirmDeleteBody": "Are you sure you want to delete this body line?",
    "emptyLine": "Empty line",
    "description": "Edit the notification JSON and save the changes to the database.",
    "notificationTitleLabel": "Notification Title",
    "bodySectionTitle": "Content (Body)",
    "addBodyLine": "Add line",
    "linksSectionTitle": "Links (LinkList)",
    "addLink": "Add link",
    "linkTextLabel": "Text",
    "linkTextPlaceholder": "Button text",
    "linkUrlLabel": "URL",
    "invalidJson": "Invalid JSON format",
    "saveFailed": "Failed to update notification configuration",
    "copyFailed": "Failed to copy JSON",
    "loadFailed": "Failed to load notification configuration"
  },
  "agents": {
    "title": "Agents",
    "usernameExists": "Username '{username}' already exists. Please choose another one.",
    "resetAll": "Reset All",
    "resetAllConfirm": "Reset steal settings for all agents?",
    "noAgentsForStealReset": "No agents found to reset.",
    "resetAllSuccess": "Steal settings reset for {count} agents.",
    "resetAllPartial": "Reset completed with {failed} failures out of {total} agents.",
    "resetAllError": "Error resetting steal settings: {error}",
    "tableView": "Table View",
    "hierarchyView": "Hierarchy View",
    "activateAgent": "Agent Status (Inactive = Blocked)",
    "active": "Active",
    "lock": "Lock",
    "number": "Number",
    "edit": "Edit",
    "collapseHierarchy": "Collapse hierarchy",
    "viewHierarchy": "View hierarchy",
    "deactivate": "Deactivate",
    "activate": "Activate",
    "activateSuccess": "{username} activate successfully",
    "deactivateSuccess": "{username} deactivate successfully",
    "advancedSettings": "Deduction Settings N-1",
    "activatehiddendeduction": "Activate Hidden Deduction",
    "agentname": "Agent Name:",
    "lockhiddendeduction": "Lock Hidden Deduction",
    "deductionStartTime": "Deduction Start Time",
    "deductionEndTime": "Deduction end Time",
    "hidevipdeduction": "Hide VIP Deduction",
    "perunitdeduction": "Per Unit Deduction",
    "financialSettings": "Financial Settings",
    "noStealHistory": "No Steal history",
    "stealStats24h": "STEAL STATS (24h)",
    "stealStatistics": "STEAL STATISTICS",
    "stealToday": "STEAL TODAY",
    "stealOperations": "STEAL OPERATIONS",
    "stealAmount": "STEAL AMOUNT",
    "stealYesterday": "STEAL YESTERDAY",
    "stealHistory": "STEAL HISTORY",
    "allStealRecords": "All STEAL Records",
    "updatedAt": "Updated At",
    "inactive": "Inactive",
    "search": "Search",
    "searchPlaceholder": "Search by Login ID, Username or Code...",
    "addAgent": "Add Agent",
    "stealSettings": "Steal Settings",
    "stealSettingsDescription": "用于生成需要写入 agent_configs 的配置键值对（config_key/config_value）。 / Generates config key-value pairs for agent_configs.",
    "globalSteal": "Global Steal",
    "configKeyGlobalSteal": "config_key: global_steal，config_value: 0 或 1",
    "configKeyGlobalStealRobit": "config_key: global_steal_robit，config_value: integer (suggest ≥ 0",
    "globalStealRatio": "Global Steal Ratio",
    "stealStatus": "STEAL STATUS",
    "stealStatusSubLabel": "On / Off",
    "stealLock": "LOCK STEAL",
    "stealRatio": "STEAL RATIO",
    "editUser": "Edit User",
    "addUser": "Add User",
    "save": "Save",
    "chooseAvatarFile": "Choose an avatar file",
    "noAgentsTitle": "No agents",
    "noAgentsDescription": "Start by adding your first agent to manage the team",
    "noHierarchyAvailable": "No hierarchy available",
    "noHierarchyDescription": "Agents are not organized in a hierarchy yet",
    "hierarchyTitle": "Agent hierarchy",
    "add": "Add",
    "userUpdated": "{username} updated",
    "userCreated": "{username} created",
    "userDeleted": "{username} deleted",
    "unsavedChanges": "The form has unsaved changes. Are you sure you want to close it?",
    "avatar": "Avatar",
    "username": "Username",
    "code": "Code",
    "description": "Description",
    "loginId": "Login ID",
    "role": "Role",
    "revenue": "Revenue",
    "estimatedRevenue": "Estimated Revenue",
    "withdrawableAmount": "Withdrawable Amount",
    "selfRevenue": "Self Revenue",
    "totalAgentBalance": "Total Agent Account Balance",
    "totalWithdrawn": "Total Amount Withdrawn by Agents",
    "filter": {
      "agentId": "Agent ID",
      "agentCode": "Agent Code",
      "loginAccount": "Login Account"
    },
    "withdrawingAmount": "Withdrawing Amount",
    "withdrawnAmount": "Withdrawn Amount",
    "status": "Status",
    "visitOverview": "Visit Overview",
    "agentInfo": "Agent Info",
    "visits": "visits",
    "conversion": "conversion",
    "created": "Created",
    "lastActive": "Last Active",
    "actions": "Actions",
    "page": "Page",
    "of": "of",
    "id": "ID",
    "userId": "User ID",
    "roleAdmin": "Admin",
    "adminId": "Admin ID",
    "type": "Type",
    "reason": "Reason",
    "amount": "Amount",
    "createdAt": "Created At",
    "totalRecords": "Total Records",
    "roleAgent": "Agent",
    "results": "Results",
    "resultsPerPage": "Results per page",
    "previousPage": "Previous Page",
    "nextPage": "Next Page",
    "deleteUser": "Delete User",
    "deleteUserConfirm": "Are you sure you want to delete {username}?",
    "confirmDelete": "Confirm Delete",
    "warning": "Warning",
    "hasChildren": "Agent {username} has {count} subordinate agents.\n\nDeleting this agent will not delete its subordinate agents, but they will no longer have a direct parent.\n\nDo you want to continue?",
    "deleteSuccess": "{username} successfully deleted",
    "deleteError": "Error deleting {username}: {error}",
    "updateError": "Error updating {username}: {error}",
    "createError": "Error creating {username}: {error}",
    "usernameExists": "Username '{username}' already exists. Please choose another one.",
    "saveError": "Error saving: {error}",
    "unknownError": "Unknown error",
    "password": "Password",
    "withdrawPassword": "Withdraw Password",
    "optionId": "game channel",
    "optionIdPlaceholder": "Enter game channel",
    "newPassword": "New Password",
    "confirmPassword": "Confirm Password",
    "commissionRate": "Commission Rate",
    "cancel": "Cancel",
    "passwordRequired": "Confirm password is required",
    "passwordMismatch": "Passwords do not match",
    "notAvailable": "N/A",
    "usernamePlaceholder": "Enter username",
    "passwordPlaceholder": "Enter password",
    "newPasswordPlaceholder": "Enter new password (optional)",
    "confirmPasswordPlaceholder": "Confirm password",
    "commissionRatePlaceholder": "Enter commission rate",
    "StealRatioPlaceholder": "Enter steal ratio",
    "parentCommissionInfo": "Parent Agent Commission: {commission}%",
    "commissionLimitError": "Commission cannot exceed {commission}% (parent agent commission)",
    "commission": {
      "title": "Agent Commission",
      "agent": "Agent",
      "subAgents": "Sub-agents",
      "rate": "Rate (%)",
      "total": "Total (€)",
      "month": "This Month (€)",
      "agents": "Number of Agents"
    },
    "children": "Sub-agents",
    "parent": "Parent Agent",
    "vip": {
      "title": "Agents and their VIP Plans",
      "totalAgents": "Total Agents",
      "totalVipPlans": "Total VIP Plans",
      "averagePerAgent": "Average per Agent",
      "searchPlaceholder": "Search agents...",
      "empty": "No agents found",
      "memberSince": "Member since",
      "viewDetails": "View VIP Details",
      "modalTitle": "VIP Details for {username}",
      "stats": {
        "totalPlans": "Total Plans",
        "activePlans": "Active Plans",
        "totalSales": "Total Sales",
        "totalRevenue": "Actual Revenue"
      },
      "plans": "VIP Plans",
      "noPlans": "No VIP Plans",
      "sales": "Sales",
      "errorLoading": "Error loading agents"
    },
    "impersonate": "View as agent",
    "impersonateSuccess": "New tab opened as {username}",
    "impersonateError": "Unable to start impersonation",
    "enterPercentage": "Enter percentage",
    "stealEnabled": "Enable Steal",
    "selectAgents": "Select agents",
    "stealStartDate": "Start Date",
    "selectStartDate": "Select start date",
    "stealSettingsSaved": "Steal settings saved successfully",
    "stealSettingsError": "Error saving steal settings",
    "usernameRequired": "Username is required",
    "usernameMinLength": "Username must be at least 3 characters",
    "usernameMaxLength": "Username cannot exceed 64 characters",
    "passwordRequired": "Password is required",
    "passwordMinLength": "Password must be at least 6 characters",
    "passwordRetraitMinLength": "Withdrawal password must be at least 6 characters",
    "commissionRateNumber": "Commission rate must be a number",
    "commissionRateNegative": "Commission rate cannot be negative",
    "active": "Active"
  },
  "gameManagement": {
    "title": "Title",
    "dashboard": "Dashboard",
    "adminUser": "Admin User",
    "administrator": "Administrator",
    "history": "Game History",
    "titlePlaceholder": "Enter a reduction title",
    "catalog": "Catalog",
    "platforms": "Platforms",
    "countryMapping": "Country Mapping",
    "internationalization": "Internationalization",
    "platformI18n": "Platform I18n",
    "catalogTitle": "Catalog",
    "catalogDescription": "Manage and sync your games",
    "reducerTitle": "Game Reductions",
    "reducerDescription": "Manage scheduled game reductions",
    "addReducer": "Add Reduction",
    "editReducer": "Edit Reduction",
    "uploadImages": "Upload Images",
    "images": "Icon",
    "reductionAmount": "Reduction",
    "time": "Time",
    "createReducer": "Create Reduction",
    "updateReducer": "Update Reduction",
    "deleteReducer": "Delete Reduction",
    "deleteReducerConfirm": "Delete reduction from {start} to {end}?",
    "reducerCreated": "Reduction created successfully",
    "reducerUpdated": "Reduction updated successfully",
    "reducerDeleted": "Reduction deleted successfully",
    "noReducers": "No reductions found",
    "failedToLoadReducers": "Failed to load reductions",
    "failedToSubmitReducer": "Failed to submit reduction",
    "failedToDeleteReducer": "Failed to delete reduction",
    "fillRequiredFields": "Please fill in all required fields",
    "searchGame": "Search games...",
    "addGame": "Add Game",
    "noGamesAvailable": "No games available",
    "startFirstGame": "Start by creating your first game",
    "online": "Online",
    "offline": "Offline",
    "isRecommended": "Recommended",
    "actions": "Actions",
    "edit": "Edit",
    "pause": "Pause",
    "activate": "Activate",
    "activated": "Activated",
    "deactivated": "Deactivated",
    "delete": "Delete",
    "created": "Created",
    "displayName": "Display Name",
    "description": "Description",
    "editTranslation": "Edit Translation",
    "newTranslation": "New Translation",
    "gameCannotBeModified": "Game cannot be modified after creation",
    "languageCannotBeModified": "Language cannot be modified after creation",
    "displayNamePlaceholder": "e.g.: Dragon Fortune",
    "displayNameHint": "Name that will be displayed in this language",
    "descriptionPlaceholder": "e.g.: An exciting slot game",
    "descriptionHint": "Description of the game in this language",
    "iconUrl": "Icon URL",
    "iconUrlPlaceholder": "https://example.com/icon.png",
    "iconUrlHint": "Full URL of the icon image",
    "translationCreated": "Translation created successfully",
    "translationUpdated": "Translation updated successfully",
    "translationDeleted": "Translation deleted successfully",
    "errorLoadingTranslations": "Error loading translations",
    "errorCreatingTranslation": "Error creating translation",
    "errorUpdatingTranslation": "Error updating translation",
    "errorDeletingTranslation": "Error deleting translation",
    "confirmDeleteTranslation": "Are you sure you want to delete translation \"{name}\"?",
    "createGame": "Create New Game",
    "editGame": "Edit Game",
    "gameCode": "Game Code",
    "gameName": "Game Name",
    "gameType": "Game Type",
    "provider": "Provider",
    "platform": "Platform",
    "rtp": "RTP (%)",
    "minBet": "Min Bet",
    "maxBet": "Max Bet",
    "imageUrl": "Image URL",
    "gameUrl": "Game URL",
    "cancel": "Cancel",
    "save": "Save",
    "update": "Update",
    "create": "Create",
    "saving": "Saving...",
    "confirmDelete": "Confirm Delete",
    "deleteGameConfirm": "Are you sure you want to delete game {name}?",
    "irreversibleAction": "This action is irreversible.",
    "deleting": "Deleting...",
    "previous": "← Previous",
    "next": "Next →",
    "page": "Page",
    "gameTypeExample": "SLOT, CASINO...",
    "providerExample": "PG Soft...",
    "minBetExample": "100",
    "codeRequired": "Game code is required",
    "codeMinLength": "Code must contain at least 3 characters",
    "codeMinLength2": "Code must contain at least 2 characters",
    "codeExists": "Code \"{code}\" already exists. Please choose another code.",
    "codeExistsOther": "Code \"{code}\" is already used by another game",
    "gameCreated": "Game created successfully",
    "gameUpdated": "Game updated successfully",
    "gameDeleted": "Game deleted successfully",
    "gameStatusToggled": "Game {status} successfully",
    "errorLoadingGames": "Error loading games",
    "errorLoadingPlatforms": "Error loading platforms",
    "errorCreatingGame": "Error creating game",
    "errorUpdatingGame": "Error updating game",
    "errorDeletingGame": "Error deleting game",
    "errorTogglingStatus": "Error changing status",
    "platformCreated": "Platform created successfully",
    "platformUpdated": "Platform updated successfully",
    "platformDeleted": "Platform deleted successfully",
    "platformStatusToggled": "Platform {status} successfully",
    "platformCodeExists": "Code \"{code}\" is already used by another platform",
    "confirmDeletePlatform": "Are you sure you want to delete \"{name}\"?",
    "errorCreatingPlatform": "Error creating platform",
    "errorUpdatingPlatform": "Error updating platform",
    "errorDeletingPlatform": "Error deleting platform",
    "errorTogglingPlatformStatus": "Error modifying status",
    "filters": "Search Filters",
    "username": "Username",
    "usernamePlaceholder": "Name or ID",
    "all": "All",
    "ngPlatform": "NG Platform",
    "meisheng": "Meisheng",
    "gameTypeFilter": "Game Type",
    "slot": "Slot",
    "casino": "Casino",
    "result": "Result",
    "win": "Win",
    "lose": "Lose",
    "startDate": "Start Date",
    "endDate": "End Date",
    "search": "Search",
    "reset": "Reset",
    "exportExcel": "Export Excel",
    "gameHistoryTitle": "Game History",
    "total": "Total",
    "wins": "Wins",
    "losses": "Losses",
    "showing": "Showing",
    "of": "of",
    "records": "records",
    "platformStatus": "Platform Status",
    "active": "Active",
    "inactive": "Inactive",
    "toggleStatus": "Toggle Status",
    "countryMappingTitle": "Country Mapping",
    "countryMappingDescription": "Manage country restrictions and permissions",
    "addCountryMapping": "Add Country Mapping",
    "country": "Country",
    "game": "Game",
    "restrictionType": "Restriction Type",
    "allow": "Allow",
    "deny": "Deny",
    "internationalizationTitle": "Game Internationalization",
    "internationalizationDescription": "Manage game translations and localization",
    "addTranslation": "Add Translation",
    "language": "Language",
    "translationKey": "Translation Key",
    "translationValue": "Translation Value",
    "platformI18nTitle": "Platform Language Configuration",
    "platformI18nDescription": "Manage platform-specific language settings",
    "addPlatformLanguage": "Add Platform Language",
    "platformLanguage": "Platform Language",
    "isDefault": "Default",
    "yes": "Yes",
    "no": "No",
    "mappingUpdatedSuccess": "Mapping updated successfully",
    "mappingCreatedSuccess": "Mapping created successfully",
    "mappingDeletedSuccess": "Mapping deleted successfully",
    "mappingLoadError": "Error loading mappings",
    "mappingCreationError": "Error creating mapping",
    "mappingUpdateError": "Error updating mapping",
    "mappingDeletionError": "Error deleting mapping",
    "mappingStatusError": "Error modifying status",
    "mappingStatusChanged": "Mapping {status}",
    "setAsDefault": "Set as Default",
    "removedFromDefault": "Removed from default",
    "noDefaultConfigFound": "No default configuration found",
    "confirmDeleteMapping": "Are you sure you want to delete the mapping for \"{country}\"?",
    "updated": "Updated",
    "platformName": "Platform Name",
    "platformCode": "Platform Code",
    "configureLanguage": "Configure Language",
    "platformLanguageConfig": "Platform Language Configuration",
    "manageLanguageSettings": "Manage language settings for different platforms",
    "platformI18nConfig": "Platform I18n configuration will be implemented here.",
    "gameInternationalization": "Game Internationalization",
    "gameInternationalizationDesc": "Manage game translations and display by country/language.",
    "gameTranslations": "Game Translations",
    "totalTranslations": "Total Translations",
    "searchTranslation": "Search...",
    "addNewTranslation": "Add Translation",
    "loadingTranslations": "Loading translations...",
    "noTranslations": "No translations",
    "noResults": "No results",
    "tryAnotherSearch": "Try another search",
    "addFirstTranslation": "Start by adding your first game translation",
    "addTranslationButton": "Add Translation",
    "misAJour": "Updated",
    "searchPlaceholder": "Search...",
    "apiBaseUrl": "API Base URL",
    "callbackUrl": "Callback URL",
    "apiKey": "API Key",
    "apiSecret": "API Secret",
    "signKey": "Sign Key",
    "noConfigsFound": "No configurations found"
  },
  "landingPage": {
    "pageTitle": "Landing Page Requests",
    "user": "User",
    "createNewRequest": "Create New Request",
    "editRequest": "Edit Request",
    "createDescription": "Select template and describe your needs",
    "editDescription": "Edit your request details",
    "editingRequest": "Editing Request #",
    "cancelEdit": "Cancel Edit",
    "currentStatus": "Current Status:",
    "createdOn": "Created on:",
    "step1Title": "1. Select Template",
    "landingPageType": "Landing Page Type *",
    "selectTemplate": "Select Template",
    "step2Title": "2. Project Details",
    "requestTitle": "Title *",
    "titlePlaceholder": "e.g.: My First Page",
    "requestDescription": "Description *",
    "descriptionPlaceholder": "A description",
    "promotionLink": "Promotion Link (Optional)",
    "noPromotionSelected": "No promotion selected",
    "url": "URL: ",
    "reset": "Reset",
    "cancel": "Cancel",
    "update": "Update",
    "sendRequest": "Send Request",
    "sending": "Sending...",
    "updating": "Updating...",
    "yourRecentRequests": "Your Recent Requests",
    "refresh": "Refresh",
    "loadingRequests": "Loading requests...",
    "noRequestsYet": "You haven't created any requests yet",
    "id": "ID",
    "title": "Title",
    "template": "Template",
    "promotionUrl": "Promotion URL",
    "platform": "Platform",
    "status": "Status",
    "date": "Date",
    "actions": "Actions",
    "locked": "Locked",
    "page": "Page",
    "of": "of",
    "confirmDelete": "Confirm Delete",
    "deleteRequest": "Are you sure you want to delete request",
    "deleteWarning": "This action cannot be undone.",
    "requestId": "Request ID:",
    "requestTemplate": "Template:",
    "requestStatus": "Status:",
    "delete": "Delete Permanently",
    "deleting": "Deleting...",
    "requestCreated": "Your request has been successfully recorded. You will be notified after admin verification.",
    "requestUpdated": "Request updated successfully",
    "requestDeleted": "Request deleted successfully",
    "errorCreating": "Failed to create request",
    "errorUpdating": "Failed to update request",
    "errorDeleting": "Failed to delete request",
    "requestExists": "Creation failed or your request already exists",
    "listRefreshed": "List refreshed",
    "congratulations": "Congratulations! Your request",
    "requestCompleted": "has been verified and is now completed.",
    "multipleCompleted": "of your requests have been verified and are now completed!",
    "requestsUpdated": "requests updated",
    "inProduction": "In Production",
    "inReview": "In Review",
    "rejected": "Rejected",
    "statusChanged": "Your request",
    "hasBeen": "has been",
    "completed": "completed",
    "pending": "pending",
    "collectingRequirements": "Collecting Requirements",
    "modified": "modified",
    "simple": "Simple",
    "videoPreview": "Video Preview",
    "multiImages": "Multi-Images",
    "pendingStatus": "Pending",
    "inReviewStatus": "In Review",
    "collectingRequirementsStatus": "Collecting Requirements",
    "inProductionStatus": "In Production",
    "completedStatus": "Completed",
    "rejectedStatus": "Rejected",
    "cancelledStatus": "Cancelled",
    "validatedStatus": "Validated",
    "notApplicable": "Not Applicable"
  },
  "common": {
    "search": "Search",
    "showing": "Showing",
    "clear": "Clear",
    "all": "All",
    "status": "Status",
    "active": "Active",
    "inactive": "Inactive",
    "activate": "Activate",
    "actions": "Actions",
    "edit": "Edit",
    "delete": "Delete",
    "reject": "Reject",
    "save": "Save",
    "create": "Create",
    "cancel": "Cancel",
    "close": "Close",
    "apply": "Apply",
    "add": "Add",
    "update": "Update",
    "loading": "Loading",
    "retry": "Retry",
    "error": "An error occurred",
    "success": "Success",
    "ok": "OK",
    "yes": "Yes",
    "no": "No",
    "page": "Page",
    "of": "of",
    "show": "Show",
    "select": "Select",
    "platform": "Platform",
    "language": "Language",
    "default": "Default",
    "image": "Image",
    "noData": "No data available",
    "lastModification": "Last Modified",
    "by": "by",
    "notConfigured": "Not configured",
    "details": "Details",
    "dates": "Dates",
    "createdAt": "Created At",
    "updatedAt": "Updated At",
    "username": "Username",
    "role": "Role",
    "code": "Code",
    "refresh": "Refresh",
    "copied": "Copied",
    "deactivate": "Deactivate",
    "id": "ID",
    "notVerified": "Not Verified",
    "updateVip": "Update VIP",
    "newPassword": "New Password",
    "confirmNewPassword": "Confirm New Password",
    "vipSettings": "VIP Settings",
    "currentVipCard": "Current VIP Card",
    "noVip": "No VIP",
    "vip": "VIP",
    "vipRequired": "VIP*",
    "selectOption": "Choose an option",
    "unlimitedVideos": "Watch all videos unlimited",
    "lifetimeVideos": "Watch all videos lifetime",
    "yearVideos": "Watch all videos for 1 year",
    "monthVideos": "Watch all videos for 1 month",
    "dayVideos": "Watch all videos for 1 day",
    "durationRequired": "Duration*",
    "unit": "Unit*",
    "minutes": "Minutes",
    "hour": "Hour",
    "day": "Day",
    "vipNote": "Note: remove user's previous VIP status",
    "submit": "Submit",
    "vipRenewed": "VIP renewed for {username}",
    "vipRenewalError": "Error during VIP renewal",
    "selectValidityType": "Please select a validity type",
    "fillDurationUnit": "Please fill in duration and unit",
    "enterNewPassword": "Enter a new password",
    "passwordsDoNotMatch": "Passwords do not match",
    "passwordUpdated": "Password updated for {username}",
    "passwordUpdateError": "Error updating password",
    "createError": "Error creating user {username}: {error}",
    "unknownError": "Unknown error",
    "tableHeaders": {
      "username": "Username",
      "nickname": "Nickname",
      "phone": "Phone",
      "role": "Role",
      "id": "ID",
      "vip": "VIP",
      "points": "Points",
      "country": "Country",
      "agent": "Agent",
      "visitor": "Visitor",
      "verified": "Verified",
      "createdAt": "Created At",
      "status": "Status"
    },
    "confirmDelete": "Are you sure?"
  },
  "announcements": {
    "systemTitle": "System Announcements",
    "systemSubtitle": "Manage and broadcast your communications",
    "newAnnouncement": "New Announcement",
    "editAnnouncement": "Edit Announcement",
    "totalAnnouncements": "Total Announcements",
    "active": "Active",
    "scheduled": "Scheduled",
    "archived": "Archived",
    "all": "All",
    "toutes": "All",
    "searchPlaceholder": "Search announcements...",
    "show": "Show",
    "of": "of",
    "announcements": "announcements",
    "noAnnouncementsFound": "No announcements found",
    "noResultsForSearch": "Your search returned no results",
    "createFirstAnnouncement": "Create your first announcement to get started",
    "status": "Status",
    "title": "Title",
    "content": "Preview",
    "publishDate": "Publish Date",
    "recipients": "Recipients",
    "progress": "Progress",
    "actions": "Actions",
    "scheduledBadge": "Scheduled",
    "confirmationBadge": "Confirmation",
    "allAgents": "All",
    "readsCount": "{read}/{total}",
    "activate": "Activate",
    "deactivate": "Deactivate",
    "modify": "Modify",
    "delete": "Delete",
    "confirmAction": "Confirm Action",
    "confirmActivate": "Are you sure you want to activate this announcement?",
    "confirmDeactivate": "Are you sure you want to deactivate this announcement?",
    "activated": "Activated",
    "deactivated": "Deactivated",
    "confirmDelete": "Confirm Delete",
    "irreversibleAction": "This action is irreversible",
    "deleted": "Deleted",
    "form": {
      "titleLabel": "Announcement Title *",
      "titlePlaceholder": "e.g.: Important System Update",
      "contentLabel": "Content *",
      "contentPlaceholder": "Write your announcement...",
      "recipientsLabel": "Recipients *",
      "allAgents": "All Agents",
      "specificAgents": "Specific Agents",
      "selectAgents": "Select Agents",
      "agentsSelected": "{count} agents selected",
      "forceConfirmation": "Force Confirmation",
      "forceConfirmationDesc": "Agents must click \"I understand\" to close",
      "publishTimeLabel": "Publish Time *",
      "immediatePublish": "Publish Immediately",
      "scheduledPublish": "Scheduled Publish",
      "publishDateLabel": "Publish Date *",
      "dateTimeLabel": "Date and Time",
      "publishNow": "Publish Now",
      "schedule": "Schedule"
    },
    "agentSelector": {
      "title": "Select Agents",
      "searchPlaceholder": "Search agents by name, code...",
      "selectAll": "Select All",
      "deselectAll": "Deselect All",
      "selectedCount": "Selected {selected} / {total}",
      "noAgentsFound": "No agents found",
      "confirm": "Confirm ({count})"
    },
    "pagination": {
      "showing": "Showing",
      "of": "to",
      "announcements": "announcements",
      "page": "Page",
      "goToPage": "Go to page",
      "go": "Go"
    },
    "messages": {
      "confirmAction": "Confirm Action",
      "confirmActivate": "Are you sure you want to activate this announcement?",
      "confirmDeactivate": "Are you sure you want to deactivate this announcement?",
      "confirmDelete": "Are you sure you want to delete this announcement?",
      "published": "Published!",
      "publishedSuccess": "Announcement created successfully",
      "activated": "Activated",
      "deactivated": "Deactivated",
      "deleted": "Deleted",
      "success": "Success!",
      "error": "Error",
      "titleRequired": "Title is required",
      "contentRequired": "Content is required",
      "publishDateRequired": "Publish date is required",
      "selectAtLeastOneAgent": "Please select at least one agent",
      "cannotSave": "Unable to save announcement",
      "cannotToggleStatus": "Unable to modify status",
      "cannotDelete": "Unable to delete announcement",
      "cannotLoadAgents": "Unable to load agent list",
      "cannotLoadAnnouncements": "Unable to load announcements",
      "announcementActivated": "Announcement activated",
      "announcementDeactivated": "Announcement deactivated",
      "announcementDeleted": "Announcement deleted"
    }
  },
  "vip": {
    "setting": {
      "title": "VIP Settings",
      "subtitle": "Create new VIP plans based on existing VIP plans",
      "createNew": "Create New VIP",
      "editVip": "Edit VIP",
      "editing": "Currently editing",
      "updateButton": "Update",
      "updateSuccess": "VIP updated successfully",
      "selectVip": "Select VIP Plan",
      "selectPlaceholder": "Select VIP Plan",
      "selectedVipDetails": "Selected VIP Details",
      "newPrice": "Price",
      "price": "Price",
      "pricePlaceholder": "e.g.: price between min and max price",
      "priceHint": "Enter price for this VIP",
      "createButton": "Create VIP",
      "image": "Image",
      "noData": "No data available",
      "loading": "Creating...",
      "yesdelete": "Yes, delete it!",
      "yescancel": "No, cancel!",
      "missingFields": "Please select VIP and enter price",
      "loadError": "Unable to load VIP",
      "createSuccess": "VIP created successfully",
      "createError": "Error creating VIP",
      "priceRangeHint": "Authorized price",
      "myCreatedPrices": "My configurations",
      "vipName": "VIP",
      "vipFallback": "VIP #{id}",
      "vipLogoAlt": "VIP logo",
      "confirmDelete": "Are you sure?",
      "confirmDeleteText": "Do you really want to delete this VIP \"{name}\"?",
      "deleteSuccess": "Deleted!",
      "deleteSuccessText": "VIP has been successfully deleted.",
      "confirmToggle": "Are you sure you want to {action} this VIP?",
      "confirmToggleText": "You are about to {action} the VIP \"{name}\"",
      "toggleSuccess": "Success!",
      "toggleSuccessText": "VIP has been {action} successfully.",
      "confirmToggleButton": "Yes, {action}!",
      "activateAction": "activate",
      "deactivateAction": "deactivate",
      "minimumLabel": "Minimum",
      "maximumLabel": "Maximum",
      "deleteError": "Error while deleting VIP",
      "toggleError": "Error while changing VIP status",
      "minPriceError": "Price must be at least ${minPrice}",
      "maxPriceError": "Price must be at most ${maxPrice}",
      "editPriceTitle": "Edit Price",
      "editPriceText": "Price for",
      "priceValidation": "Please enter a valid price greater than 0",
      "updateError": "Error while updating VIP"
    },
    "title": "VIP Management",
    "subtitle": "Manage your user VIP subscriptions",
    "add_vip": "Purchase VIP",
    "search_user_id": "Search by User ID...",
    "search_phone": "Search by Phone...",
    "search_button": "Search",
    "stats": {
      "active": "Active VIP",
      "expired": "Inactive VIP",
      "revenue": "Total Revenue"
    },
    "search": "Search...",
    "filters": {
      "all": "All",
      "active": "Active",
      "expired": "Expired"
    },
    "filter": {
      "title": "Filter criteria",
      "reset": "Reset",
      "seller": "Seller",
      "seller_placeholder": "Seller",
      "agent": "Agent",
      "select_option": "Select an option",
      "user_id": "User ID",
      "user_id_placeholder": "",
      "order_type": "Order type",
      "all": "All",
      "new": "New",
      "renewal": "Renewal",
      "upgrade": "Upgrade",
      "order_number": "Order number",
      "order_number_placeholder": "",
      "payment_status": "Payment status",
      "all_m": "All",
      "payment_channel": "Payment channel",
      "order_period": "Order period",
      "order_period_placeholder": "",
      "phone": "Phone",
      "phone_placeholder": "",
      "submit": "Apply",
      "quick_search": "Search"
    },
    "table": {
      "user": "User",
      "phone": "Phone",
      "agent_id": "Agent ID",
      "registration_date": "Registration Date",
      "product": "Product",
      "price": "Price",
      "payment_status": "Payment Status",
      "payment_channel": "Payment Channel",
      "payment_number": "Payment Number",
      "user_id": "User ID",
      "duration": "Duration",
      "purchase_date": "Purchase Date",
      "expiration": "Expiration",
      "status": "Status",
      "actions": "Actions"
    },
    "status": {
      "active": "Active",
      "expired": "Expired",
      "inactive": "Inactive"
    },
    "common": {
      "days": "days"
    },
    "actions": {
      "edit": "Edit",
      "activate": "Activate",
      "deactivate": "Deactivate"
    },
    "modal": {
      "add_title": "Purchase VIP",
      "edit_title": "Edit VIP",
      "user_label": "User *",
      "user_placeholder": "Search user...",
      "plan_label": "VIP Plan *",
      "plan_placeholder": "-- Select --",
      "no_users_found": "No users found",
      "vip_logo_alt": "VIP logo",
      "cancel": "Cancel",
      "save": "Purchase",
      "update": "Update",
      "confirm_purchase_title": "Purchase Confirmation",
      "confirm_update_title": "Modification Confirmation",
      "confirm_purchase_subtitle": "Confirm VIP Purchase",
      "confirm_update_subtitle": "Edit VIP",
      "confirm_purchase_warning": "This action will deduct funds from the user's wallet.",
      "confirm_update_warning": "This action will modify this user's VIP plan.",
      "confirm_purchase_button": "Confirm Purchase",
      "confirm_update_button": "Modify"
    },
    "toggle_modal": {
      "title": "Modification Confirmation",
      "activate_subtitle": "Activate VIP",
      "deactivate_subtitle": "Deactivate VIP",
      "activate_warning": "This action will activate VIP access for the user.",
      "deactivate_warning": "This action will deactivate VIP access for the user.",
      "activate_button": "Activate",
      "deactivate_button": "Deactivate"
    },
    "pagination": {
      "showing": "Showing {start} to {end} of {total} VIP entries",
      "items_per_page": "Items per page:",
      "go_to_page": "Go to page:",
      "go_button": "Go",
      "first_page": "First",
      "prev_page": "Previous",
      "next_page": "Next",
      "last_page": "Last"
    },
    "empty": "No results found",
    "toasts": {
      "success": "Success",
      "error": "Error",
      "purchase_success": "VIP purchase successful!",
      "update_success": "VIP modification successful!",
      "activate_success": "VIP activation successful!",
      "deactivate_success": "VIP deactivation successful!",
      "purchase_error": "Error during purchase",
      "update_error": "Error during modification",
      "toggle_error": "Error modifying VIP status.",
      "insufficient_balance": "User wallet balance insufficient for this VIP purchase.",
      "select_user_plan": "Please select a user and VIP plan.",
      "select_plan": "Please select a VIP plan."
    },
    "payment_status": {
      "completed": "Completed",
      "pending": "Pending",
      "failed": "Failed",
      "cancelled": "Cancelled",
      "unknown": "Unknown"
    },
    "payment_channel": {
      "wallet": "Wallet",
      "credit_card": "Credit Card",
      "paypal": "PayPal",
      "bank_transfer": "Bank Transfer"
    },
    "plans": {
      "title": "VIP Plan Management",
      "subtitle": "Manage available VIP plans",
      "add": "Add VIP Plan",
      "edit": "Edit VIP Plan",
      "name": "Name",
      "image": "Image",
      "status": "Status",
      "save": "Save",
      "loading": "Loading...",
      "validDays": "Valid Days",
      "price": "Price",
      "basePrice": "Base Price",
      "minPrice": "Min Price",
      "maxPrice": "Max Price",
      "order": "Display Order",
      "total": "Total",
      "active": "Active Plans",
      "inactive": "Inactive Plans",
      "recommended": "Recommended",
      "logoUrl": "Logo URL",
      "days": "days",
      "empty": "No VIP plans found",
      "searchPlaceholder": "Search by name...",
      "namePlaceholder": "Enter plan name",
      "validDaysPlaceholder": "Enter days",
      "pricePlaceholder": "Enter price",
      "orderPlaceholder": "Enter display order",
      "markRecommended": "Mark as Recommended",
      "createSuccess": "VIP plan created successfully",
      "updateSuccess": "VIP plan updated successfully",
      "deleteSuccess": "VIP plan deleted successfully",
      "deleteConfirm": "This will delete the VIP plan. Are you sure?",
      "statusUpdated": "VIP plan status updated",
      "manageTranslations": "Manage Translations",
      "translations": "VIP Plan Translations",
      "description": "Description",
      "descriptionPlaceholder": "Enter description",
      "translationAdded": "Translation added successfully",
      "translationUpdated": "Translation updated successfully",
      "translationDeleted": "Translation deleted successfully",
      "translationRequired": "Please add at least one translation",
      "basicInfo": "Basic Information",
      "pricing": "Pricing",
      "originalPrice": "Original Price",
      "vipItems": "VIP Benefits",
      "agentSettings": "Agent Settings",
      "openToAgents": "Open to Agents",
      "minAgentPrice": "Min Agent Price",
      "maxAgentPrice": "Max Agent Price",
      "display": "Display",
      "logo": "Logo",
      "logoRequired": "Logo image is required",
      "selectExistingLogo": "Please select an existing logo.",
      "invalidFileType": "Please select a valid image file",
      "fileTooLarge": "Image must not exceed 5MB",
      "orderPlaceholder": "Enter display order",
      "language": "Language",
      "languagePlaceholder": "fr_FR",
      "shortIntro": "Short Introduction",
      "shortIntroPlaceholder": "Short description",
      "addTranslation": "Add Translation",
      "details": "VIP Plan Details",
      "open": "Open",
      "openAgent": "Open Agent",
      "agent": "Agent",
      "actions": {
        "details": "Details",
        "edit": "Edit",
        "activate": "Activate",
        "deactivate": "Deactivate",
        "delete": "Delete"
      },
      "notify": {
        "agentPlanReadonly": "Administrators cannot modify VIP plans owned by agents.",
        "agentPlanReadonlyTooltip": "Not allowed: agent-owned plan"
      },
      "validation": {
        "basePriceGreaterThanMax": "Base price cannot be greater than maximum price",
        "minPriceGreaterThanBase": "Minimum price cannot be greater than base price",
        "originalPriceBetweenMinAndMax": "Original price must be between minimum price and maximum price"
      },
      "filters": {
        "all": "All",
        "active": "Active",
        "inactive": "Inactive"
      }
    },
    "rights": {
      "title": "VIP Rights Management",
      "titleField": "Title",
      "chooseFile": "Select File",
      "noFileSelected": "No file selected",
      "translations": "Translations",
      "manageTranslations": "Manage Translations",
      "add": "Add VIP Right",
      "edit": "Edit VIP Right",
      "code": "Code",
      "description": "Description",
      "order": "Display Order",
      "logoUrl": "Logo URL",
      "logo": "Logo",
      "dropzoneText": "Drag an image or click",
      "orderPlaceholder": "Enter display order",
      "codePlaceholder": "e.g.: can_download_video",
      "titlePlaceholder": "Enter title",
      "descriptionPlaceholder": "Enter description",
      "codes": {
        "can_download_resources": "Download Resources",
        "can_access_long_free": "Long Videos Free",
        "can_access_short_free": "Short Videos Unlimited",
        "can_access_posts_free": "Posts Access Free",
        "can_access_im_free": "Instant Messaging Free",
        "can_access_audio_free": "Audio Access Free",
        "can_access_manga_free": "Manga Access Free",
        "can_access_novel_free": "Novel Access Free",
        "can_watch_long_videos_free": "Watch Long Videos Free",
        "can_watch_short_videos_unlimited": "Watch Short Videos Unlimited",
        "can_view_posts_free": "View Posts Free",
        "can_use_instant_messaging_free": "Use Instant Messaging Free",
        "can_access_premium_content_free": "Access Premium Content Free"
      },
      "codeDescriptions": {
        "can_download_resources": "Allow downloading of resources (videos, images, etc.)",
        "can_access_long_free": "Grant or deny the right to watch long videos for free",
        "can_access_short_free": "Grant or deny the right to watch short videos with no limits",
        "can_access_posts_free": "Grant or deny the right to view post content for free",
        "can_access_im_free": "Grant or deny the right to use instant messaging (IM) for free",
        "can_access_audio_free": "Grant or deny the right to listen to audio content for free",
        "can_access_manga_free": "Grant or deny the right to read manga for free",
        "can_access_novel_free": "Grant or deny the right to read novels for free",
        "can_watch_long_videos_free": "Grant the right to watch long videos for free",
        "can_watch_short_videos_unlimited": "Grant the right to watch short videos with unlimited duration",
        "can_view_posts_free": "Grant the right to view post content for free",
        "can_use_instant_messaging_free": "Grant the right to use instant messaging (IM) for free",
        "can_access_premium_content_free": "Grant the right to listen to audio, read manga, and access other premium content for free"
      },
      "total": "Total Rights",
      "configured": "Configured",
      "empty": "No VIP rights found",
      "searchPlaceholder": "Search by code or title...",
      "deleteConfirm": "This will delete the VIP right. Are you sure?",
      "codeRequired": "Code is required",
      "createSuccess": "VIP right created successfully",
      "updateSuccess": "VIP rights updated successfully",
      "deleteSuccess": "VIP right deleted successfully",
      "translationAdded": "Translation added successfully",
      "translationUpdated": "Translation updated successfully",
      "translationDeleted": "Translation deleted successfully",
      "updateError": "Failed to update VIP rights"
    }
  },
  "domain": {
    "title": "Domain Management",
    "stats": {
      "total": "Total",
      "active": "Active",
      "inactive": "Inactive"
    },
    "search": {
      "label": "Search",
      "placeholder": "Search by name..."
    },
    "filter": {
      "status": "Status",
      "all": "All"
    },
    "addButton": "Add Domain",
    "loading": "Loading domains...",
    "retry": "Retry",
    "noDomains": "No domains found",
    "table": {
      "headers": {
        "id": "ID",
        "domainName": "Domain",
        "tag": "Tag",
        "platform": "Platform",
        "account": "Account",
        "type": "Type",
        "group": "Group",
        "state": "State",
        "province": "Province",
        "status": "Status",
        "expiration": "Expiration",
        "actions": "Actions"
      },
      "actions": {
        "edit": "Edit",
        "activate": "Activate",
        "deactivate": "Deactivate",
        "delete": "Delete"
      },
      "status": {
        "enabled": "Enabled",
        "disabled": "Disabled"
      }
    },
    "modal": {
      "addTitle": "Add Domain",
      "editTitle": "Edit Domain",
      "fields": {
        "domain": "Domain",
        "domainPlaceholder": "e.g.: https://example.com",
        "tag": "Tag",
        "tagPlaceholder": "e.g.: web, api, video, image",
        "platform": "Platform",
        "platformPlaceholder": "e.g.: AWS, Cloudflare",
        "platformAccount": "Platform Account",
        "platformAccountPlaceholder": "e.g.: aws-prod-001",
        "domainType": "Domain Type",
        "domainTypePlaceholder": "Select type",
        "domainGroup": "Domain Group",
        "domainGroupPlaceholder": "Select group",
        "province": "Province",
        "provincePlaceholder": "Select province",
        "expiration": "Expiration Date",
        "expirationPlaceholder": "e.g.: 2026-12-31T23:59:59Z",
        "status": "Status"
      },
      "buttons": {
        "cancel": "Cancel",
        "save": "Save",
        "add": "Add"
      }
    },
    "options": {
      "status": {
        "active": "Active",
        "inactive": "Inactive"
      },
      "domainType": {
        "long": "Long",
        "short": "Short"
      },
      "domainGroup": {
        "production": "Production",
        "dedicated": "Dedicated",
        "test": "Test"
      },
      "domainTag": {
        "web": "web",
        "landing": "landing",
        "api": "api",
        "video": "video",
        "image": "image",
        "audio": "audio",
        "static": "static",
        "payment": "payment",
        "customer_service": "customer_service",
        "event": "event件"
      }
    },
    "messages": {
      "success": "Success!",
      "error": "Error!",
      "confirmDelete": "Are you sure?",
      "irreversibleAction": "This action is irreversible!",
      "confirmDeleteButton": "Yes, delete",
      "deleted": "Deleted!",
      "domainRequired": "Domain is required",
      "tagRequired": "Tag is required",
      "platformRequired": "Platform is required",
      "domainUpdated": "Domain successfully modified",
      "domainCreated": "Domain successfully created",
      "domainDeleted": "Domain successfully deleted",
      "updateError": "Error during modification",
      "createError": "Error during creation",
      "deleteError": "Error during deletion",
      "loadError": "Unable to load domains"
    }
  },
  "domainSurveillance": {
    "title": "Domain Surveillance",
    "stats": {
      "totalDomains": "Total Domains",
      "activeDomains": "Active Domains",
      "inactiveDomains": "Inactive Domains",
      "checksLast24h": "Checks (24h)"
    },
    "filters": {
      "domain": "Domain",
      "allDomains": "All Domains",
      "checkType": "Check Type",
      "all": "All",
      "status": "Status"
    },
    "actions": {
      "refresh": "Refresh",
      "triggerCheck": "Trigger Check"
    },
    "loading": "Loading surveillance logs...",
    "retry": "Retry",
    "noLogs": "No surveillance logs found",
    "table": {
      "headers": {
        "id": "ID",
        "domain": "Domain",
        "province": "Province",
        "type": "Type",
        "time": "Time",
        "status": "Status",
        "summary": "Summary",
        "duration": "Duration (ms)",
        "actions": "Actions"
      },
      "actions": {
        "viewDetails": "View Details"
      },
      "status": {
        "success": "Success",
        "failed": "Failed"
      }
    },
    "checkTypes": {
      "browser": "Browser",
      "regional_7c": "Regional 7c.cc",
      "regional_itdog": "Regional ITDog"
    },
    "modals": {
      "trigger": {
        "title": "Trigger Check",
        "fields": {
          "domain": "Domain",
          "selectDomain": "Select domain",
          "checkType": "Check Type",
          "checkTypePlaceholder": "Full check"
        },
        "buttons": {
          "cancel": "Cancel",
          "trigger": "Trigger"
        },
        "errors": {
          "selectDomainRequired": "Please select a domain"
        }
      },
      "details": {
        "title": "Surveillance Log Details",
        "fields": {
          "domain": "Domain",
          "checkType": "Check Type",
          "time": "Time",
          "status": "Status",
          "summary": "Summary",
          "duration": "Duration"
        },
        "jsonDetails": "JSON Details",
        "close": "Close"
      }
    },
    "messages": {
      "success": "Success!",
      "error": "Error!",
      "checkTriggered": "Check successfully triggered. Results will appear in a few seconds.",
      "triggerError": "Error during triggering",
      "loadError": "Unable to load logs",
      "apiCredentialsNote": "Note: Backend may not be configured with API credentials"
    }
  },
  "domainMapping": {
    "title": "Short Domain Mapping",
    "search": {
      "label": "Search",
      "placeholder": "Search..."
    },
    "addButton": "Add Mapping",
    "loading": "Loading mappings...",
    "retry": "Retry",
    "noMappings": "No mappings found",
    "table": {
      "headers": {
        "id": "ID",
        "shortDomain": "Short Domain",
        "shortStatus": "Short Domain Status",
        "longDomain": "Long Domain",
        "longStatus": "Long Domain Status",
        "creationDate": "Creation Date",
        "actions": "Actions"
      },
      "actions": {
        "delete": "Delete"
      }
    },
    "modal": {
      "addTitle": "Add Domain Mapping",
      "fields": {
        "shortDomain": "Short Domain",
        "selectShortDomain": "Select short domain",
        "shortDomainNote": "Only domains of type \"short\" are displayed",
        "longDomain": "Long Domain",
        "selectLongDomain": "Select long domain",
        "longDomainNote": "Only domains of type \"long\" are displayed"
      },
      "buttons": {
        "cancel": "Cancel",
        "add": "Add"
      }
    },
    "messages": {
      "success": "Success!",
      "error": "Error!",
      "confirmDelete": "Are you sure?",
      "irreversibleAction": "This action is irreversible!",
      "confirmDeleteButton": "Yes, delete",
      "deleted": "Deleted!",
      "mappingCreated": "Mapping created successfully",
      "mappingDeleted": "Mapping deleted successfully",
      "shortDomainRequired": "Short domain is required",
      "longDomainRequired": "Long domain is required",
      "createError": "Error during creation",
      "deleteError": "Error during deletion",
      "loadError": "Unable to load mappings",
      "mappingAlreadyExists": "Mapping already exists"
    }
  },
  "resourceDomainChangeLogs": {
    "title": "Resource Domain Change Logs",
    "subtitle": "History of resource domain (short) order modifications",
    "filters": {
      "startDate": "Start Date",
      "endDate": "End Date",
      "startDatePlaceholder": "Start Date",
      "endDatePlaceholder": "End Date"
    },
    "actions": {
      "refresh": "Refresh",
      "generateJson": "Generate Resource JSON",
      "viewCurrentJson": "View Current JSON",
      "details": "Details"
    },
    "loading": "Loading logs...",
    "noLogs": "No change logs found",
    "table": {
      "headers": {
        "id": "ID",
        "date": "Date",
        "operator": "Operator",
        "changes": "Changes",
        "mainDomain": "Main Domain",
        "statistics": "Statistics",
        "actions": "Actions"
      },
      "changes": {
        "topDomainChanged": "🔄 Main Domain Changed",
        "statusChanges": "status changes",
        "orderChanges": "order changes"
      },
      "statistics": {
        "total": "Total",
        "normal": "Normal",
        "partial": "Partial",
        "regionBlock": "Region Block"
      }
    },
    "modals": {
      "details": {
        "title": "Log Details",
        "generalInfo": "General Information",
        "fields": {
          "id": "ID",
          "date": "Date",
          "operator": "Operator",
          "reason": "Reason"
        },
        "topDomainChange": {
          "title": "🔄 Main Domain Change",
          "previous": "Previous",
          "current": "Current"
        },
        "statusChanges": {
          "title": "Status Changes",
          "headers": {
            "domain": "Domain",
            "oldStatus": "Old Status",
            "newStatus": "New Status"
          }
        },
        "orderChanges": {
          "title": "Order Changes",
          "headers": {
            "domain": "Domain",
            "oldPosition": "Old Position",
            "newPosition": "New Position"
          }
        },
        "currentJson": {
          "title": "Current JSON",
          "copyJson": "Copy JSON"
        }
      },
      "currentJson": {
        "title": "Current Resource JSON",
        "publicLink": "Public Link",
        "copyLink": "Copy Link",
        "content": "Content",
        "copyJson": "Copy JSON"
      }
    },
    "messages": {
      "generateJson": {
        "title": "Generate Resource JSON?",
        "text": "This will generate a new JSON file for resource domains.",
        "confirmButton": "Yes, generate",
        "cancelButton": "Cancel",
        "success": "Success",
        "successText": "Resource JSON generated successfully",
        "error": "Error"
      },
      "viewCurrentJson": {
        "noJson": "No JSON",
        "noJsonText": "No resource JSON found. Please generate it first.",
        "error": "Error"
      },
      "copy": {
        "jsonCopied": "JSON copied to clipboard",
        "linkCopied": "Link copied to clipboard",
        "copyError": "Unable to copy content",
        "copyLinkError": "Unable to copy link",
        "error": "Error"
      }
    },
    "operator": {
      "system": "System"
    }
  },
  "apiDomainChangeLogs": {
    "title": "API Domain Change Logs",
    "subtitle": "History of API domain (long) order modifications",
    "filters": {
      "startDate": "Start Date",
      "endDate": "End Date",
      "startDatePlaceholder": "Start Date",
      "endDatePlaceholder": "End Date"
    },
    "actions": {
      "refresh": "Refresh",
      "generateJson": "Generate API JSON",
      "viewCurrentJson": "View Current JSON",
      "details": "Details"
    },
    "loading": "Loading logs...",
    "noLogs": "No change logs found",
    "table": {
      "headers": {
        "id": "ID",
        "date": "Date",
        "operator": "Operator",
        "changes": "Changes",
        "mainDomain": "Main Domain",
        "statistics": "Statistics",
        "actions": "Actions"
      },
      "changes": {
        "topDomainChanged": "🔄 Main Domain Changed",
        "statusChanges": "status changes",
        "orderChanges": "order changes"
      },
      "statistics": {
        "total": "Total",
        "normal": "Normal",
        "partial": "Partial",
        "regionBlock": "Region Block"
      }
    },
    "modals": {
      "details": {
        "title": "Log Details",
        "generalInfo": "General Information",
        "fields": {
          "id": "ID",
          "date": "Date",
          "operator": "Operator",
          "reason": "Reason"
        },
        "topDomainChange": {
          "title": "🔄 Main Domain Change",
          "previous": "Previous",
          "current": "Current"
        },
        "statusChanges": {
          "title": "Status Changes",
          "headers": {
            "domain": "Domain",
            "oldStatus": "Old Status",
            "newStatus": "New Status"
          }
        },
        "orderChanges": {
          "title": "Order Changes",
          "headers": {
            "domain": "Domain",
            "oldPosition": "Old Position",
            "newPosition": "New Position"
          }
        },
        "currentJson": {
          "title": "Current JSON",
          "copyJson": "Copy JSON"
        }
      },
      "currentJson": {
        "title": "Current API JSON",
        "publicLink": "Public Link",
        "copyLink": "Copy Link",
        "content": "Content",
        "copyJson": "Copy JSON"
      }
    },
    "messages": {
      "generateJson": {
        "title": "Generate API JSON?",
        "text": "This will generate a new JSON file for API domains.",
        "confirmButton": "Yes, generate",
        "cancelButton": "Cancel",
        "success": "Success",
        "successText": "API JSON generated successfully",
        "error": "Error"
      },
      "viewCurrentJson": {
        "noJson": "No JSON",
        "noJsonText": "No API JSON found. Please generate it first.",
        "error": "Error"
      },
      "copy": {
        "jsonCopied": "JSON copied to clipboard",
        "linkCopied": "Link copied to clipboard",
        "copyError": "Unable to copy content",
        "copyLinkError": "Unable to copy link",
        "error": "Error"
      }
    },
    "operator": {
      "system": "System"
    }
  },
  "failoverLogs": {
    "title": "Failover Logs",
    "filters": {
      "failedDomain": "Failed Domain",
      "startDate": "Start Date",
      "endDate": "End Date",
      "allDomains": "All Domains",
      "startDatePlaceholder": "Start Date",
      "endDatePlaceholder": "End Date"
    },
    "actions": {
      "refresh": "Refresh",
      "updateUrlsJson": "Update URLs JSON",
      "viewUrlsJson": "View URLs JSON",
      "testFailover": "Test Failover",
      "retry": "Retry",
      "previous": "Previous",
      "next": "Next",
      "viewDetails": "View Details",
      "close": "Close",
      "cancel": "Cancel",
      "test": "Test"
    },
    "loading": "Loading failover logs...",
    "noLogs": "No failover logs found.",
    "table": {
      "headers": {
        "id": "ID",
        "failedDomain": "Failed Domain",
        "replacementDomain": "Replacement Domain",
        "province": "Province",
        "operator": "Operator",
        "date": "Date",
        "actions": "Actions"
      },
      "tag": "Tag"
    },
    "pagination": {
      "pageOf": "Page {current} of {total} ({results} results)"
    },
    "modals": {
      "testFailover": {
        "title": "Test Failover",
        "failedDomain": "Failed Domain",
        "selectDomain": "Select domain",
        "operator": "Operator (optional)",
        "operatorPlaceholder": "e.g.: admin, system, etc.",
        "autoFindReplacement": "System will automatically find an active replacement domain",
        "selectFailedDomain": "Please select a failed domain",
        "success": {
          "title": "Success!",
          "replacementFound": "Replacement domain found:"
        },
        "error": "Failover test error"
      },
      "details": {
        "title": "Failover Details",
        "failedDomain": "Failed Domain",
        "replacementDomain": "Replacement Domain",
        "failoverReason": "Failover Reason",
        "operator": "Operator",
        "date": "Date",
        "metadata": "Metadata"
      }
    },
    "messages": {
      "updateUrlsJson": {
        "title": "Update URLs JSON?",
        "text": "This will generate and upload a new urls.json file to R2, containing all active API domains.",
        "confirmButton": "Yes, update",
        "success": {
          "title": "Success!",
          "updated": "URLs JSON updated successfully!",
          "domainsCount": "Number of domains:",
          "url": "URL:"
        },
        "error": "Update error"
      },
      "viewUrlsJson": {
        "noFile": "No file",
        "noFileText": "No urls.json file found in R2. Please update first.",
        "current": "Current URLs JSON",
        "version": "Version:",
        "updated": "Updated:",
        "domains": "Domains:",
        "error": "Retrieval error"
      },
      "loadError": "Unable to load failover logs",
      "domainsLoadError": "Error loading domains:",
      "logsLoadError": "Error loading logs:"
    },
    "operator": {
      "system": "System"
    },
    "no": "No",
    "notConfigured": "Not Configured",
    "lastModification": "Last Modified",
    "by": "by",
    "page": "Page",
    "of": "of",
    "show": "Show"
  },
  "gestionLandingPage": {
    "pageTitle": "Landing Page Requests",
    "status": "Status",
    "agent": "Agent",
    "all": "All",
    "loadingRequests": "Loading requests...",
    "searchPlaceholder": "Search by title...",
    "details": "Details",
    "edit": "Edit",
    "delete": "Delete",
    "template": "Template",
    "createdOn": "Created on:",
    "modifiedOn": "Modified on:",
    "description": "Description",
    "noDescription": "No description",
    "validate": "Validate",
    "reject": "Reject",
    "close": "Close",
    "editRequest": "Edit Request #",
    "title": "Title",
    "titleRequired": "Title is required",
    "descriptionRequired": "Description is required",
    "titlePlaceholder": "Request title",
    "descriptionPlaceholder": "Detailed description",
    "templateRequired": "Template is required",
    "simple": "Simple",
    "videoPreview": "Video Preview",
    "multiImages": "Multi-Images",
    "save": "Save",
    "cancel": "Cancel",
    "saving": "Saving...",
    "page": "Page",
    "of": "of",
    "total": "Total",
    "pending": "Pending",
    "validated": "Validated",
    "rejected": "Rejected",
    "noRequestsFound": "No requests found",
    "requestDeleted": "Request deleted successfully",
    "requestUpdated": "Request updated successfully",
    "requestValidated": "Request validated successfully",
    "requestRejected": "Request rejected successfully",
    "inReview": "In Review",
    "collectingRequirements": "Collecting Requirements",
    "inProduction": "In Production",
    "completed": "Completed",
    "deleted": "Deleted",
    "cancelled": "Cancelled",
    "unknownUser": "Unknown User",
    "confirmDelete": "Are you sure you want to delete this request?",
    "deleteConfirm": "Delete this request?",
    "setToPending": "Set to Pending",
    "setToReview": "Set to In Review",
    "setToProduction": "Set to In Production",
    "setToCompleted": "Set to Completed",
    "stats": {
      "total": "Total",
      "pending": "Pending",
      "validated": "Validated",
      "rejected": "Rejected"
    },
    "notifications": {
      "requestStatusUpdated": "Request {status} successfully",
      "fillRequiredFields": "Please fill in all required fields",
      "requestUpdated": "Request updated successfully",
      "rejectConfirm": "Reject request \"{title}\"?",
      "updateRequestError": "Unable to update request",
      "requestSubmitted": "Your request has been successfully submitted. You will be notified after admin verification.",
      "requestCompleted": "Congratulations! Your request \"{title}\" has been verified and completed.",
      "multipleRequestsCompleted": "{count} requests have been verified and completed!",
      "requestCreationError": "Error during creation or request already exists",
      "requestUpdateSuccess": "Request updated successfully",
      "requestDeleteSuccess": "Request deleted successfully",
      "requestDeleteError": "Error during deletion",
      "listRefreshed": "List refreshed",
      "createRequestError": "Unable to create request",
      "deleteRequestError": "Unable to delete request"
    },
    "templates": {
      "simple": "Simple",
      "videoPreview": "Video Preview",
      "multiImages": "Multi-Images"
    },
    "statusLabels": {
      "pending": "Pending",
      "in_review": "In Review",
      "collecting_requirements": "Collecting Requirements",
      "in_production": "In Production",
      "completed": "Completed",
      "rejected": "Rejected",
      "cancelled": "Cancelled",
      "validated": "Validated"
    }
  },
  "mangas": {
    "mangas": "Manga",
    "titles": "Titles",
    "chapters": "Chapters",
    "episodes": "Episodes",
    "categories": "Categories",
    "subcategories": "Subcategories",
    "tags": "Tags",
    "tagCategories": "Tag Categories",
    "images": "Images"
  },
  "mangasList": {
    "management": "Manga Management",
    "editManga": "Edit Manga",
    "addNewManga": "Add New Manga",
    "reference": "Reference",
    "referencePlaceholder": "Enter unique reference (e.g.: one-piece)",
    "referenceRequired": "Reference is required",
    "referenceExists": "Manga with this reference already exists",
    "userId": "User ID",
    "deleteConfirmMessage": "Are you sure you want to delete this? This action cannot be undone.",
    "userIdRequired": "User ID is required",
    "userNotFound": "User not found",
    "mangaId": "Manga ID",
    "confirmDelete": "Confirm deletion",
    "title": "Title",
    "titlePlaceholder": "Enter manga title",
    "titleRequired": "Title is required",
    "description": "Description",
    "descriptionPlaceholder": "Enter manga description",
    "descriptionRequired": "Description is required",
    "totalChapters": "Total Chapters",
    "totalChaptersPlaceholder": "1200",
    "totalChaptersRequired": "Total chapters is required",
    "totalChaptersNegative": "Total chapters cannot be negative",
    "checkingStatus": "Checking Status",
    "checkingStatusRequired": "Checking status is required",
    "processingStatus": "Processing Status",
    "coverUrl": "Cover URL",
    "coverUrlPlaceholder": "https://example.com/cover.jpg",
    "coverUploadStatus": "Cover Upload Status",
    "coverUploadStatusPlaceholder": "0 or 1",
    "coverUploadStatusRequired": "Cover upload status is required",
    "uploadNegative": "Upload cannot be negative",
    "localCoverPath": "Local Cover Path",
    "localCoverPathPlaceholder": "/tmp/one-piece.jpg",
    "hash": "Hash",
    "hashPlaceholder": "a94a8fe5ccb19ba61c4c0873d391e987",
    "searchPlaceholder": "Search manga...",
    "addManga": "Add Manga",
    "noMangasFound": "No manga found",
    "createFirstManga": "Create first manga",
    "ref": "Reference",
    "chapters": "Chapters",
    "checking": "Checking",
    "processing": "Processing",
    "createdAt": "Created At",
    "waitingForChecking": "Waiting for Check",
    "checked": "Checked",
    "refused": "Refused",
    "null": "Null",
    "working": "Working",
    "done": "Done",
    "loadError": "Failed to load manga",
    "fillRequiredFields": "Please fill in all required fields",
    "saveError": "Failed to save manga",
    "deleteConfirm": "Are you sure?",
    "deleteError": "Failed to delete manga"
  },
  "mangaTitles": {
    "management": "Manga Title Management",
    "editTitle": "Edit Title",
    "addNewTitle": "Add New Title",
    "title": "Title",
    "titlePlaceholder": "Enter title",
    "titleRequired": "Title is required",
    "description": "Description",
    "descriptionPlaceholder": "Enter description",
    "descriptionRequired": "Description is required",
    "mangaId": "Manga ID",
    "mangaIdRequired": "Manga ID is required",
    "mangaIdMin": "Manga ID must be >= 1",
    "language": "Language",
    "languageRequired": "Language is required",
    "searchPlaceholder": "Search titles...",
    "addTitle": "Add Title",
    "noTitlesFound": "No titles found",
    "createFirstTitle": "Create first title",
    "createdAt": "Created At",
    "confirmDelete": "Confirm Delete",
    "deleteConfirmMessage": "Are you sure you want to delete this title?",
    "french": "French",
    "english": "English",
    "spanish": "Spanish",
    "german": "German",
    "italian": "Italian",
    "portuguese": "Portuguese",
    "japanese": "Japanese",
    "chinese": "Chinese",
    "loadError": "Failed to load titles",
    "fillRequiredFields": "Please fill in all required fields",
    "saveError": "Failed to save title",
    "deleteError": "Failed to delete title",
    "deleteConfirm": "Are you sure?"
  },
  "deleteModal": {
    "confirmDelete": "Confirm Delete",
    "deleteConfirmMessage": "Are you sure you want to delete this item?"
  },
  "mangaChapters": {
    "management": "Manga Chapter Management",
    "editChapter": "Edit Chapter",
    "addNewChapter": "Add New Chapter",
    "chapterTitle": "Chapter Title",
    "titleRequired": "Title is required",
    "chapterNumber": "Chapter Number",
    "chapterNumberRequired": "Chapter number is required",
    "chapterNumberNegative": "Chapter number cannot be negative",
    "mangaIdRequired": "Manga ID is required",
    "mangaIdNegative": "Manga ID cannot be negative",
    "pagesRequired": "Number of pages is required",
    "pagesNegative": "Number of pages cannot be negative",
    "searchPlaceholder": "Search chapters...",
    "addChapter": "Add Chapter",
    "noChaptersFound": "No chapters found",
    "title": "Title",
    "description": "Description",
    "number": "Number",
    "mangaId": "Manga ID",
    "pages": "Pages",
    "confirmDelete": "Confirm Delete",
    "deleteConfirmMessage": "Are you sure you want to delete this chapter?",
    "validationRequired": "Title, chapter number and manga ID are required",
    "duplicateNumberError": "A chapter with this number already exists for this manga",
    "duplicateTitleError": "A chapter with this title already exists for this manga",
    "loadError": "Failed to load chapters",
    "saveError": "Failed to save chapter",
    "deleteError": "Failed to delete chapter"
  },
  "mangaEpisodes": {
    "management": "Manga Episode Management",
    "editEpisode": "Edit Episode",
    "addNewEpisode": "Add New Episode",
    "episodeName": "Episode Name",
    "episodeNamePlaceholder": "e.g.: Episode 1 - The Beginning",
    "nameRequired": "Name is required",
    "episodeNumber": "Episode Number",
    "episodeNumberPlaceholder": "1",
    "episodeNumberRequired": "Episode number is required",
    "episodeNumberNegative": "Episode number cannot be negative",
    "chapterId": "Chapter ID",
    "chapterIdRequired": "Chapter ID is required",
    "chapterIdNegative": "Chapter ID cannot be negative",
    "description": "Description",
    "descriptionPlaceholder": "Enter description",
    "descriptionRequired": "Description is required",
    "duration": "Duration",
    "durationPlaceholder": "e.g.: 10 minutes or 600",
    "durationRequired": "Duration is required",
    "durationNegative": "Duration cannot be negative",
    "quality": "Quality",
    "qualityPlaceholder": "e.g.: HD",
    "qualityRequired": "Quality is required",
    "searchPlaceholder": "Search episodes...",
    "addEpisode": "Add Episode",
    "noEpisodesFound": "No episodes found",
    "createFirstEpisode": "Create first episode",
    "number": "Number",
    "images": "Images",
    "createdAt": "Created At",
    "confirmDelete": "Confirm Delete",
    "deleteConfirmMessage": "Are you sure you want to delete this episode?",
    "fillRequiredFields": "Please fill in all required fields correctly",
    "loadError": "Failed to load episodes",
    "saveError": "Failed to save episode",
    "deleteError": "Failed to delete episode"
  },
  "mangaCategories": {
    "management": "Manga Category Management",
    "editCategory": "Edit Category",
    "addNewCategory": "Add New Category",
    "name": "Name",
    "namePlaceholder": "Enter category name",
    "nameRequired": "Name is required",
    "description": "Description",
    "descriptionPlaceholder": "Enter description",
    "descriptionRequired": "Description is required",
    "searchPlaceholder": "Search categories...",
    "addCategory": "Add Category",
    "noCategoriesFound": "No categories found",
    "createFirstCategory": "Create first category",
    "createdAt": "Created At",
    "confirmDelete": "Confirm Delete",
    "deleteConfirmMessage": "Are you sure you want to delete this category?",
    "fillRequiredFields": "Please fill in all required fields",
    "loadError": "Failed to load categories",
    "saveError": "Failed to save category",
    "deleteError": "Failed to delete category"
  },
  "mangaSubCategories": {
    "management": "Manga Subcategory Management",
    "editSubCategory": "Edit Subcategory",
    "addNewSubCategory": "Add New Subcategory",
    "name": "Name",
    "namePlaceholder": "Enter subcategory name",
    "nameRequired": "Name is required",
    "categoryId": "Category ID",
    "categoryIdRequired": "Category ID is required",
    "categoryIdNegative": "Category ID cannot be negative",
    "categoryIdValidation": "Category ID must be provided and cannot be negative",
    "description": "Description",
    "descriptionPlaceholder": "Enter description",
    "descriptionRequired": "Description is required",
    "searchPlaceholder": "Search subcategories...",
    "addSubCategory": "Add Subcategory",
    "noSubCategoriesFound": "No subcategories found",
    "createFirstSubCategory": "Create first subcategory",
    "category": "Category",
    "createdAt": "Created At",
    "confirmDelete": "Confirm Delete",
    "deleteConfirmMessage": "Are you sure you want to delete this subcategory?",
    "deleteConfirm": "Are you sure?",
    "fillRequiredFields": "Please fill in all required fields",
    "loadError": "Failed to load subcategories",
    "saveError": "Failed to save subcategory",
    "deleteError": "Failed to delete subcategory"
  },
  "mangaTags": {
    "management": "Manga Tag Management",
    "editTag": "Edit Tag",
    "addNewTag": "Add New Tag",
    "userId": "User ID",
    "userIdPlaceholder": "Enter user ID",
    "userIdRequired": "User ID is required",
    "userNotFound": "User not found",
    "mangaId": "Manga ID",
    "mangaIdPlaceholder": "Enter manga ID",
    "mangaIdRequired": "Manga ID is required",
    "tagCategoryId": "Tag Category ID",
    "tagCategoryIdPlaceholder": "Enter tag category ID",
    "tagCategoryIdRequired": "Tag category ID is required",
    "searchPlaceholder": "Search tags...",
    "addTag": "Add Tag",
    "noTagsFound": "No tags found",
    "createFirstTag": "Create first tag",
    "confirmDelete": "Confirm Delete",
    "deleteConfirmMessage": "Are you sure you want to delete this tag?",
    "fillRequiredFields": "Please fill in all required fields",
    "loadError": "Failed to load tags",
    "saveError": "Failed to save tag",
    "deleteError": "Failed to delete tag"
  },
  "mangaTagCategories": {
    "management": "Manga Tag Category Management",
    "editTagCategory": "Edit Tag Category",
    "addNewTagCategory": "Add New Tag Category",
    "name": "Name",
    "namePlaceholder": "Enter category name",
    "nameRequired": "Name is required",
    "color": "Color",
    "colorPlaceholder": "Choose color",
    "colorRequired": "Color is required",
    "searchPlaceholder": "Search tag categories...",
    "addTagCategory": "Add Tag Category",
    "noTagCategoriesFound": "No tag categories found",
    "createFirstTagCategory": "Create first tag category",
    "createdAt": "Created At",
    "confirmDelete": "Confirm Delete",
    "deleteConfirmMessage": "Are you sure you want to delete this tag category?",
    "deleteConfirm": "Are you sure?",
    "fillRequiredFields": "Please fill in all required fields",
    "loadError": "Failed to load tag categories",
    "saveError": "Failed to save tag category",
    "deleteError": "Failed to delete tag category"
  },
  "mangaImages": {
    "management": "Manga Image Management",
    "editImage": "Edit Image",
    "addNewImage": "Add New Image",
    "episodeId": "Episode ID",
    "episodeIdRequired": "Episode ID is required",
    "episodeIdMinValidation": "Episode ID must be >= 1",
    "image": "Image",
    "acceptedFormats": "Accepted formats: JPG, PNG, GIF, WebP (max 5MB)",
    "imageUrlAlternative": "Image URL (alternative)",
    "imageUrlPlaceholder": "https://example.com/image.jpg",
    "searchPlaceholder": "Search by episode ID...",
    "addImage": "Add Image",
    "noImagesFound": "No images found",
    "addFirstImage": "Add first image",
    "imagePreview": "Image Preview",
    "status": "Status",
    "createdAt": "Created At",
    "actions": "Actions",
    "uploaded": "Uploaded",
    "pending": "Pending",
    "confirmDelete": "Confirm Delete",
    "deleteConfirmMessage": "Are you sure you want to delete this image?",
    "fileOrUrlRequired": "Please select a file or provide an image URL",
    "loadError": "Failed to load images",
    "saveError": "Failed to save image",
    "deleteError": "Failed to delete image"
  },
  "promotionPage": {
    "title": "Multilingual Promotion",
    "delete": "Delete Promotion",
    "description": "Description",
    "copied": "Copied",
    "selectDomainType": "Select Domain Type",
    "entrance": "Entrance",
    "deleteSuccess": "Promotion deleted successfully",
    "summaryAll": "All",
    "summaryActive": "Active",
    "summaryInactive": "Inactive",
    "summaryLongAndShort": "Long + Short",
    "filterConditions": "Filter Conditions",
    "resetFilters": "Reset",
    "statusAll": "All",
    "confirmFilters": "Confirm",
    "activeFilters": "Active Filters",
    "statusTag": "Status",
    "domainTypeTag": "Type",
    "platformTag": "Platform",
    "domainType": "Domain Type",
    "isUsed": "Used",
    "domainTypeAll": "All Types",
    "short": "Short",
    "long": "Long",
    "searchPlaceholder": "Search...",
    "domainColumn": "Domain",
    "onlineColumn": "Online",
    "generalColumn": "General",
    "domainTypeColumn": "Domain Type",
    "platformColumn": "Platform",
    "createdAtColumn": "Created At",
    "visitsColumn": "Visits",
    "noDataFound": "No data found.",
    "allPlatform": "All Platforms",
    "promotionPlatform": "Promotion Platform",
    "createDomainPromotion": "Create Domain Promotion",
    "promotionLink": "Promotion Link",
    "noLinkAvailable": "No link available",
    "copyLink": "Copy Link",
    "copiedSuccessfully": "✓ Copied successfully!",
    "createPromotion": "Create Promotion",
    "codeQR": "QR Code",
    "selectPlatform": "Select Platform",
    "promotionList": "Promotion List",
    "id": "ID",
    "platform": "Platform",
    "link": "Link",
    "status": "Status",
    "actions": "Actions",
    "enable": "Enable",
    "disable": "Disable",
    "toggleError": "Failed to change promotion status",
    "markUsed": "Mark Used",
    "unmarkUsed": "Unmark Used",
    "toggleUsedError": "Failed to change used status",
    "copyUrl": "Copy Link",
    "confirmDelete": "Are you sure you want to delete this promotion?",
    "deleteError": "Error during deletion"
  },
  "domainPromotion": {
    "title": "Create Domain Promotion",
    "domainSection": "Domain Information",
    "domain": "Domain",
    "descriptionPlaceholder": "Please enter a description",
    "domainPlaceholder": "e.g., api5.example.com",
    "tag": "Tag",
    "tagPlaceholder": "e.g., web",
    "platform": "Platform",
    "platformPlaceholder": "e.g., AWS",
    "platformAccount": "Platform Account",
    "platformAccountPlaceholder": "e.g., aws-prod-001",
    "domainType": "Domain Type",
    "selectDomainType": "Select Domain Type",
    "short": "Short",
    "long": "Long",
    "domainGroup": "Domain Group",
    "selectDomainGroup": "Select Domain Group",
    "production": "Production",
    "dedicated": "Dedicated",
    "test": "Test",
    "province": "Province",
    "provincePlaceholder": "e.g., Beijing",
    "expireAt": "Expire At",
    "active": "Active",
    "inactive": "Inactive",
    "promotionLinkSection": "Promotion Link",
    "promotionPlatform": "Platform",
    "selectPlatform": "Select a platform",
    "enable": "Enable",
    "disable": "Disable",
    "domainRequired": "Domain is required",
    "platformRequired": "Platform is required",
    "createSuccess": "Domain promotion created successfully",
    "createError": "Failed to create promotion",
    "save": "Save",
    "saveAndCreate": "Save & Create"
  },
  "createPromotion": {
    "title": "Create Promotion",
    "backToPromotions": "Back to Promotions",
    "loadingData": "Loading data...",
    "promotionDetails": "Promotion Details",
    "domain": "Domain",
    "platform": "Platform",
    "required": "Required",
    "selectDomain": "Select Domain",
    "selectPlatform": "Select Platform",
    "noDomainsAvailable": "No domains available. Please create domains first.",
    "noPlatformsAvailable": "No platforms available. Please create platforms first.",
    "publishingOptions": "Publishing Options",
    "create": "Create Promotion",
    "creating": "Creating...",
    "cancel": "Cancel",
    "fillRequiredFields": "Please fill in all required fields",
    "loginAgain": "Please log in again",
    "failedToLoadData": "Failed to load data",
    "noPermission": "You do not have permission to create promotions",
    "contactAdmin": "Contact an administrator if you need access.",
    "creationFailed": "Creation failed"
  },
  "promotionLink": {
    "title": "Promotion Links",
    "description": "All promotion URLs",
    "totalLinks": "Total Links",
    "activeLinks": "Active Links",
    "users": "Users",
    "platforms": "Platforms",
    "loading": "Loading promotion links...",
    "retry": "Retry",
    "noLinksFound": "No promotion links found",
    "noLinksDescription": "No promotion links have been created yet",
    "createFirstLink": "Create first link",
    "id": "ID",
    "promotionUrl": "Promotion URL",
    "user": "User",
    "platform": "Platform",
    "domain": "Domain",
    "created": "Created",
    "actions": "Actions",
    "copyUrl": "Copy URL",
    "qrCode": "QR Code",
    "active": "Active",
    "inactive": "Inactive",
    "enable": "Enable",
    "disable": "Disable",
    "delete": "Delete",
    "showing": "Showing",
    "of": "of",
    "links": "links",
    "editLink": "Edit Promotion Link",
    "createNewLink": "Create New Promotion Link",
    "platformRequired": "Platform",
    "domainRequired": "Domain",
    "status": "Status",
    "selectPlatform": "Select Platform",
    "selectDomain": "Select Domain",
    "selected": "Selected",
    "preview": "Preview",
    "promotionUrlLabel": "Promotion URL:",
    "cancel": "Cancel",
    "saving": "Saving...",
    "update": "Update",
    "create": "Create",
    "qrCodeTitle": "QR Code",
    "noPromotionUrl": "No promotion URL available for this link",
    "copyUrlSuccess": "Promotion URL copied to clipboard!",
    "noUrlToCopy": "No promotion URL to copy",
    "confirmEnable": "Are you sure you want to enable this link?",
    "confirmDisable": "Are you sure you want to disable this link?",
    "confirmDelete": "Are you sure you want to delete this promotion link? This action cannot be undone.",
    "linkEnabled": "Link successfully enabled!",
    "linkDisabled": "Link successfully disabled!",
    "linkCreated": "Promotion link created successfully!",
    "linkUpdated": "Promotion link updated successfully!",
    "linkDeleted": "Promotion link deleted successfully!",
    "failedToCreate": "Failed to create promotion link",
    "failedToUpdate": "Failed to update promotion link",
    "failedToDelete": "Failed to delete promotion link",
    "failedToUpdateStatus": "Failed to update status",
    "linkAlreadyExists": "A promotion link with these parameters already exists",
    "fillRequiredFields": "Please fill in the following required fields",
    "failedToLoadData": "Failed to load data"
  },
  "promotionPlatform": {
    "title": "Promotion Platforms",
    "subtitle": "Manage your promotion platforms and their details",
    "addPlatform": "Add Platform",
    "totalPlatforms": "Total Platforms",
    "active": "Active",
    "platformsList": "Platforms List",
    "platform": "Platform",
    "description": "Description",
    "actions": "Actions",
    "edit": "Edit",
    "delete": "Delete",
    "noPlatformsFound": "No platforms found",
    "addFirstPlatform": "Add your first platform to get started",
    "addNewPlatform": "Add New Platform",
    "editPlatform": "Edit Platform",
    "platformName": "Platform Name",
    "platformNamePlaceholder": "Enter platform name",
    "nameRequired": "Name is required",
    "descriptionOptional": "Description (optional)",
    "descriptionPlaceholder": "Enter platform description",
    "cancel": "Cancel",
    "createPlatform": "Create Platform",
    "saveChanges": "Save Changes",
    "noDescriptionProvided": "No description provided",
    "confirmDelete": "Are you sure you want to delete this platform?",
    "confirmDeleteWithName": "Are you sure you want to delete \"{name}\"?",
    "nameIsRequired": "Name is required",
    "saveFailed": "Save failed",
    "loadingError": "Loading error"
  },
  "promotionTracking": {
    "title": "Tracking Integration",
    "subtitle": "Configure Binom and MaxConv conversion callbacks for the current account without touching legacy promotion links.",
    "addBinding": "Add Binding",
    "platforms": "Built-in Platform Mapping",
    "platformsHint": "Only platform notes and official docs are shown here. If your landing parameter names differ from the defaults, adjust them with the capture override JSON in the binding.",
    "noPlatforms": "No platform data",
    "bindings": "My Bindings",
    "bindingsHint": "Each account can bind only one tracking platform. Edit the existing binding if you need to switch platform or callback URL.",
    "noBindings": "No bindings yet",
    "logs": "Recent Callback Logs",
    "logsHint": "Only recent callback results for the current account are shown here.",
    "noLogs": "No callback logs",
    "platform": "Platform",
    "owner": "Owner",
    "callbackUrl": "Callback URL",
    "displayName": "Display Name",
    "overrideJson": "Capture Override JSON",
    "status": "Status",
    "actions": "Actions",
    "edit": "Edit",
    "delete": "Delete",
    "enable": "Enable",
    "disable": "Disable",
    "enabled": "Enabled",
    "disabled": "Disabled",
    "createdAt": "Created At",
    "orderNo": "Order No",
    "userId": "User ID",
    "detail": "Detail",
    "docs": "Docs",
    "readonlyMapping": "Platform Notes",
    "captureRule": "Default Capture",
    "callbackRule": "Default Callback",
    "note": "Note",
    "noOverride": "No override",
    "enableLabel": "Enable this binding",
    "createTitle": "Create Tracking Binding",
    "editTitle": "Edit Tracking Binding",
    "save": "Save",
    "cancel": "Cancel",
    "saveSuccess": "Saved successfully",
    "deleteSuccess": "Deleted successfully",
    "toggleSuccess": "Status updated",
    "saveFailed": "Save failed",
    "loadFailed": "Load failed",
    "refresh": "Refresh",
    "filterAccount": "Filter Account",
    "allAccounts": "All Accounts",
    "invalidJson": "Invalid override JSON format",
    "formInvalid": "Platform, display name and callback URL are required",
    "ownerRequired": "Please select an owner",
    "platformRequired": "Please select a platform",
    "displayNameRequired": "Please enter a display name",
    "callbackUrlRequired": "Please enter a callback URL",
    "overridePlaceholder": "Example:\nclick_id: sub1, clickid\ngclid: gclid",
    "deleteConfirm": "Delete binding {name}?",
    "platformDetails": {
      "binom": {
        "capture": "By default, read clickid from the first-touch query params as click_id.",
        "callback": "On successful payment, send cnv_id, payout, cnv_currency, and fixed cnv_status=sale.",
        "note": "If your Binom landing parameter is not clickid, use the capture override JSON to switch to a custom field such as sub1."
      },
      "maxconv": {
        "capture": "By default, prefer mclid and also support gclid.",
        "callback": "On successful payment, send clid or gclid, payout, currency, txid, timestamp, and available user identity fields.",
        "note": "If your landing parameter names differ from mclid or gclid, use the capture override JSON to provide the candidate keys."
      },
      "default": {
        "capture": "Read first-touch tracking params using the built-in platform rule.",
        "callback": "Build the conversion callback payload using the built-in platform rule.",
        "note": "Use the capture override JSON if you need to support custom landing parameter names."
      }
    },
    "logStatus": {
      "success": "Success",
      "skipped": "Skipped",
      "failed": "Failed",
      "pending": "Pending",
      "error": "Error"
    }
  },
  "videos": {
    "editAllPricesHomeLabel": "Home(Short Video)",
    "editPricesVideoLabel": "Video(Long Video)",
    "editPricesPostLabel": "Post",
    "typeLabel": "Type",
    "typePlaceholder": "Choose type...",
    "confirmDelete": "Are you sure you want to delete video \"{title}\"?",
    "pageTitle": "Video Management",
    "addVideoBtn": "Add Video",
    "addNewVideo": "Add New Video",
    "editVideo": "Edit Video",
    "updateVideo": "Update Video",
    "deleteVideo": "Delete Video",
    "videoDetails": "Video Details",
    "searchLabel": "Search",
    "searchPlaceholder": "Search by title or description...",
    "loadingText": "Loading videos...",
    "price": "Price",
    "noVideosFound": "No videos found",
    "getStartedText": "Start by adding a new video",
    "addFirstVideoBtn": "Add Your First Video",
    "noVideosMatchFilters": "No videos match your filter criteria",
    "tryAdjustingSearch": "Try adjusting your search criteria",
    "clearFiltersBtn": "Clear Filters",
    "showingText": "Showing",
    "ofText": "of",
    "videosText": "videos",
    "pageText": "Page",
    "ofPagesText": "of",
    "previousBtn": "Previous",
    "nextBtn": "Next",
    "cancelBtn": "Cancel",
    "submitBtn": "Submit",
    "updateBtn": "Update",
    "filterByCategoryBtn": "Filter by Category",
    "applyFilter": "Apply filter",
    "editAllPricesBtn": "Edit all prices",
    "editAllPricesTitle": "Edit prices for all videos",
    "editAllPricesDesc": "Enter the new price ranges (min and max). Videos without a price will be updated with these values.",
    "filterByCategory": "Filter Videos by Category",
    "selectCategory": "Select a Category",
    "chooseCategoryPlaceholder": "Choose a category",
    "userNameLabel": "Creator name",
    "userNamePlaceholder": "Enter username...",
    "noCategoryVideos": "No videos found for this category",
    "closeBtn": "Close",
    "untitledText": "Untitled",
    "featuredBadge": "Featured",
    "vipBadge": "VIP",
    "freeBadge": "Free",
    "price": "Price",
    "pinBtn": "Pin",
    "manageBtn": "Manage",
    "topPopularTitle": "Top 10 Popular Today",
    "communityTitle": "Community",
    "tableRank": "Rank",
    "tableTitle": "Title",
    "viewTodayCol": "Views Today",
    "loadingSuccessRateCol": "Load Success Rate",
    "tableStatusCol": "Status",
    "creatorCol": "Creator",
    "categoryCol": "Category (Level 1)",
    "rankingLevelCol": "Ranking Level (Level 2)",
    "actionsCol": "Actions",
    "basicInfo": "Basic Information",
    "media": "Media",
    "classification": "Classification",
    "features": "Features",
    "featuredVideo": "Featured Video",
    "featuredVideoDesc": "Highlight this video",
    "vipAccess": "VIP Access",
    "vipAccessDesc": "Reserved for VIP members only",
    "location": "Location",
    "totalVideos": "Total Videos",
    "activeVideos": "Active",
    "pendingVideos": "Pending",
    "vipVideos": "VIP Videos",
    "quickSearch": "Quick Search",
    "searchPressEnter": "Press Enter to search \"{query}\"",
    "quickFilters": "Quick Filters",
    "active": "Active",
    "pending": "Pending",
    "featured": "Featured",
    "resetFilters": "Reset Filters",
    "view": "View",
    "showingResults": "Showing",
    "totalText": "Total",
    "form": {
      "titleLabel": "Title",
      "titlePlaceholder": "Enter video title",
      "titleRequired": "Title is required",
      "descriptionLabel": "Description",
      "descriptionPlaceholder": "Enter video description",
      "typeLabel": "Type",
      "price": "Price",
      "typePlaceholder": "Select type",
      "typeRequired": "Type is required",
      "priceMinLabel": "Minimum Price (min 3)",
      "priceMinLabelAdmin": "Minimum Price",
      "priceMinPlaceholder": "ex: 8",
      "priceMaxLabel": "Maximum Price (max 20)",
      "priceMaxLabelAdmin": "Maximum Price",
      "priceMaxPlaceholder": "ex: 15",
      "priceValidation": "Price must be zero or positive",
      "priceRangeValidation": "Price must be between 3 and 20",
      "videoUrlLabel": "Video URL",
      "videoUrlPlaceholder": "https://example.com/video.mp4",
      "videoUrlRequired": "Video URL is required",
      "durationLabel": "Duration (seconds)",
      "durationValidation": "Duration must be > 0",
      "statusLabel": "Status",
      "featuredLabel": "Featured",
      "vipLabel": "VIP",
      "coverImageUrlLabel": "Cover Image URL",
      "coverImageUrlPlaceholder": "https://example.com/cover.jpg",
      "provinceLabel": "Province",
      "provincePlaceholder": "Enter province",
      "cityLabel": "City",
      "cityPlaceholder": "Enter city"
    },
    "types": {
      "long": "Long",
      "short": "Short",
      "unknown": "Unknown"
    },
    "statusLabels": {
      "pending": "Pending Review",
      "validated": "Validated",
      "rejected": "Rejected",
      "unknown": "Unknown"
    },
    "messages": {
      "deleteConfirm": "Are you sure you want to delete video \"{title}\"?",
      "loadFailed": "Failed to load videos. Please try again later.",
      "deleteFailed": "Failed to delete video. Please try again later.",
      "toggleStatusFailed": "Failed to toggle status.",
      "validationError": "Please fix validation errors before submitting.",
      "updateFailed": "Failed to update video. Please try again later.",
      "addFailed": "Failed to add video. Please try again later.",
      "unexpectedDataFormat": "Unexpected data format received from server",
      "updatePricesFailed": "Failed to update prices. Please try again later.",
      "pricesUpdatedSuccessfully": "Prices updated successfully!",
      "enterAtLeastOnePrice": "Please enter at least one price (min or max)."
    },
    "detailsModal": {
      "title": "Video Details",
      "videoPlay": "Video Play",
      "coverImage": "Cover Image",
      "duration": "Duration",
      "creator": "Creator",
      "price": "Price",
      "status": "Status",
      "description": "Description",
      "videoDetails": "Video Details",
      "location": "Location",
      "type": "Type",
      "vipAccess": "VIP Access",
      "required": "Required",
      "public": "Public",
      "featured": "Featured",
      "yes": "Yes",
      "no": "No",
      "createdOn": "Created On",
      "lastUpdated": "Last Updated",
      "videoId": "Video ID",
      "close": "Close",
      "browserNotSupported": "Your browser does not support the video tag."
    },
    "category": {
      "title": "Category",
      "name": "Name",
      "type": "Type",
      "sort": "Sort",
      "createdAt": "Created At",
      "actions": "Actions"
    },
    "actions": {
      "edit": "Edit",
      "delete": "Delete"
    }
  },
  "category": {
    "title": "Category Management",
    "addNewCategory": "Add New Category",
    "editCategory": "Edit Category",
    "stats": {
      "totalCategories": "Total Categories",
      "thisWeek": "New this week",
      "lastUpdated": "Last Updated"
    },
    "form": {
      "name": "Category Name",
      "namePlaceholder": "Enter category name",
      "type": "Type",
      "typePlaceholder": "Select type",
      "sortOrder": "Sort Order",
      "sortPlaceholder": "Enter sort number",
      "showOnHome": "Show on Home"
    },
    "buttons": {
      "cancel": "Cancel",
      "save": "Save",
      "addNewCategory": "Add Category",
      "updateCategory": "Update Category",
      "createCategory": "Create Category",
      "createFirstCategory": "Create First Category",
      "clearSearch": "Clear Search"
    },
    "search": {
      "placeholder": "Search categories..."
    },
    "messages": {
      "loading": "Loading...",
      "noCategoriesFound": "No categories found",
      "createFirstCategory": "Create a first category ",
      "noCategoriesMatch": "No matching categories",
      "loadError": "Error loading categories",
      "saveError": "Error saving category",
      "deleteError": "Error deleting category",
      "deleteConfirm": "Are you sure you want to delete this category?",
      "nameAndTypeRequired": "Category name and type are required"
    },
    "table": {
      "headers": {
        "id": "ID",
        "name": "Name",
        "type": "Type",
        "sort": "Sort",
        "createdAt": "Created Date",
        "actions": "Actions"
      },
      "actions": {
        "edit": "Edit",
        "delete": "Delete"
      }
    },
    "badges": {
      "home": "Home"
    },
    "types": {
      "Long": "Long",
      "Short": "Short",
      "unknown": "Unknown Type {type}"
    }
  },
  "tag": {
    "title": "Tag Management",
    "description": "Tag management page",
    "search": {
      "placeholder": "Search tags by name..."
    },
    "form": {
      "name": "Tag Name",
      "namePlaceholder": "e.g.: News, Featured, Urgent..."
    },
    "buttons": {
      "cancel": "Cancel",
      "save": "Save",
      "addTag": "Add Tag",
      "createFirstTag": "Create First Tag",
      "clearSearch": "Clear Search",
      "updateTag": "Update Tag",
      "createTag": "Create Tag"
    },
    "messages": {
      "createFirstTag": "Create First Tag",
      "loading": "Loading tags...",
      "noTags": "No tags found",
      "noTagsFound": "No matching tags found",
      "nameRequired": "Tag name is required",
      "loadError": "Error loading tags",
      "saveError": "Error saving tag",
      "deleteError": "Error deleting tag",
      "deleteConfirm": "Are you sure you want to delete tag \"{name}\"?",
      "tryAdjustingSearch": "Please try adjusting search criteria"
    },
    "stats": {
      "totalTags": "Total Tags",
      "thisWeek": "New this week",
      "lastUpdated": "Last Updated"
    },
    "table": {
      "headers": {
        "id": "ID",
        "name": "Tag Name",
        "createdAt": "Created Date",
        "actions": "Actions"
      },
      "actions": {
        "edit": "Edit",
        "delete": "Delete"
      }
    },
    "modal": {
      "addTitle": "Add New Tag",
      "editTitle": "Edit Tag"
    }
  },
  "preferences": {
    "title": "Profile",
    "withdrawPassword": "Withdraw Password",
    "resetWithdrawPassword": "Reset Withdraw Password",
    "createWithdrawPassword": "Create Withdraw Password",
    "createWithdrawPasswordModal": {
      "title": "Create Withdraw Password",
      "createWithdrawPassword": "Create Password",
      "successMessage": "Withdraw password created successfully"
    },
    "resetWithdrawPasswordModal": {
      "title": "Reset Withdraw Password",
      "oldWithdrawPasswordLabel": "Old Withdraw Password",
      "oldWithdrawPasswordPlaceholder": "Enter old PIN",
      "newWithdrawPasswordLabel": "New Withdraw Password",
      "newWithdrawPasswordPlaceholder": "Enter new PIN",
      "repeatNewWithdrawPasswordLabel": "Confirm New Withdraw Password",
      "repeatNewWithdrawPasswordPlaceholder": "Repeat new PIN",
      "cancel": "Cancel",
      "updateWithdrawPassword": "Update",
      "successMessage": "Withdraw password updated successfully",
      "errorMessage": "An error occurred while updating the withdraw password",
      "validation": {
        "min4Chars": "Must be at least 4 characters",
        "min3UniqueChars": "Must contain at least 3 unique characters",
        "min3UniqueDigits": "Minimum 3 unique digits",
        "oldWithdrawPasswordRequired": "Old withdraw password is required",
        "newWithdrawPasswordRequired": "New withdraw password is required",
        "repeatWithdrawPasswordRequired": "Please confirm the new withdraw password",
        "newWithdrawPasswordMinLength": "Must be at least 4 digits",
        "newWithdrawPasswordUniqueDigits": "Must contain at least 3 unique digits",
        "newWithdrawPasswordUniqueChars": "Must contain at least 3 unique characters",
        "newWithdrawPasswordDifferent": "New withdraw password cannot be the same as the old one",
        "repeatWithdrawPasswordMatch": "Confirm password does not match new withdraw password"
      }
    },
    "memberSince": "Member since:",
    "name": "Name",
    "password": "Password",
    "edit": "Edit",
    "resetPassword": "Reset Password",
    "editNameModal": {
      "title": "Change Username",
      "nameLabel": "Name",
      "namePlaceholder": "Name",
      "cancel": "Cancel",
      "save": "Save",
      "successMessage": "You have successfully changed your name"
    },
    "avatar": {
      "modal": {
        "title": "Change Avatar",
        "currentAvatar": "Current Avatar",
        "uploadImage": "Upload New Avatar",
        "supportedFormats": "Supported formats: JPG, PNG, GIF, WebP (max 5MB)",
        "uploadSuccess": "Avatar uploaded successfully"
      }
    },
    "resetPasswordModal": {
      "title": "Reset Password",
      "redirectMessage": "You will be redirected to the login page in {seconds} seconds...",
      "oldPasswordLabel": "Old Password",
      "oldPasswordPlaceholder": "Old Password",
      "newPasswordLabel": "New Password",
      "newPasswordPlaceholder": "New Password",
      "repeatNewPasswordLabel": "Repeat New Password",
      "repeatNewPasswordPlaceholder": "Repeat New Password",
      "cancel": "Cancel",
      "updatePassword": "Update Password",
      "successMessage": "You have successfully changed your password",
      "validation": {
        "min8Chars": "Must be at least 8 characters long",
        "min6UniqueChars": "Must contain at least 6 unique characters",
        "oldPasswordRequired": "Old password field is required",
        "newPasswordRequired": "New password field is required",
        "newPasswordMinLength": "Must be at least 8 characters long",
        "newPasswordUniqueChars": "Must contain at least 6 unique characters",
        "newPasswordDifferent": "New password cannot be the same",
        "repeatPasswordRequired": "Repeat password field is required",
        "repeatPasswordMatch": "Confirm password does not match new password"
      }
    }
  },
  "settings": {
    "title": "Settings",
    "theme": "Theme",
    "generalPreferences": "General Preferences"
  },
  "exchangePage": {
    "title": "Exchange Rate Management",
    "subtitle": "Manage your conversion exchange rates",
    "statistics": {
      "totalRates": "Number of Rates",
      "withSource": "With Source"
    },
    "modal": {
      "editTitle": "Modify Exchange Rate",
      "addTitle": "Add Exchange Rate",
      "sourceCurrency": "Source Currency",
      "targetCurrency": "Target Currency",
      "rate": "Exchange Rate",
      "ratePlaceholder": "0.0000",
      "source": "Source",
      "sourceOptional": "Source (optional)",
      "sourcePlaceholder": "e.g.: API, Manual...",
      "cancel": "Cancel",
      "edit": "Modify",
      "add": "Add"
    },
    "deleteModal": {
      "title": "Confirm Delete",
      "message": "Are you sure you want to delete this exchange rate?",
      "cancel": "Cancel",
      "delete": "Delete"
    },
    "updateModal": {
      "title": "Exchange Rate Exists",
      "message": "This exchange rate already exists. Do you want to update it?",
      "no": "No",
      "yes": "Yes, update"
    },
    "search": {
      "placeholder": "Search currencies...",
      "addButton": "Add Exchange Rate"
    },
    "loading": "Loading exchange rates...",
    "noRates": "No exchange rates found.",
    "noResults": "No results found.",
    "table": {
      "headers": {
        "sourceCurrency": "Source Currency",
        "targetCurrency": "Target Currency",
        "rate": "Exchange Rate",
        "source": "Source",
        "actions": "Actions"
      }
    },
    "messages": {
      "loadError": "Unable to load exchange rates",
      "submitError": "Error during save",
      "deleteError": "Unable to delete exchange rate",
      "updateError": "Error during update",
      "requiredFields": "Please fill in all required fields: source currency, target currency and rate",
      "positiveRate": "Exchange rate must be positive",
      "success": {
        "created": "Exchange rate created successfully",
        "updated": "Exchange rate updated successfully",
        "deleted": "Exchange rate deleted successfully",
        "modified": "Exchange rate modified successfully"
      }
    }
  },
  "paymentPlatformsPage": {
    "title": "Payment Platforms",
    "subtitle": "Payment Platforms",
    "addPlatform": "Add Platform",
    "loading": "Loading platforms...",
    "loadingChannels": "Loading channels...",
    "noPlatforms": "No payment platforms found.",
    "noChannels": "No channels found for this platform.",
    "search": {
      "placeholder": "Search payment platform..."
    },
    "actions": {
      "view": "View",
      "edit": "Edit",
      "delete": "Delete"
    },
    "table": {
      "headers": {
        "name": "Name",
        "code": "Code",
        "status": "Status",
        "actions": "Actions"
      },
      "channels": {
        "headers": {
          "name": "Name",
          "code": "Code",
          "currency": "Currency",
          "amountRange": "Amount Range",
          "status": "Status",
          "actions": "Actions"
        },
        "title": "Channels ({count})"
      }
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive",
      "maintenance": "Maintenance"
    },
    "modals": {
      "platformDetails": {
        "title": "Platform Details",
        "basicInfo": "Basic Information",
        "apiConfig": "API Configuration",
        "securityKeys": "Security Keys",
        "urls": "URLs",
        "additionalInfo": "Additional Information",
        "timestamps": "Timestamps",
        "fields": {
          "id": "ID",
          "name": "Name",
          "code": "Code",
          "description": "Description",
          "status": "Status",
          "apiBaseUrl": "API Base URL",
          "merchantId": "Merchant ID",
          "sort": "Sort",
          "publicKey": "Public Key",
          "privateKey": "Private Key",
          "secretKey": "Secret Key",
          "callbackUrl": "Callback URL",
          "returnUrl": "Return URL",
          "i18nKey": "I18n Key",
          "sandboxMode": "Sandbox Mode",
          "createdAt": "Created At",
          "updatedAt": "Updated At"
        },
        "sandbox": {
          "enabled": "Enabled",
          "disabled": "Disabled"
        },
        "close": "Close",
        "edit": "Edit"
      },
      "channelDetails": {
        "title": "Channel Details",
        "basicInfo": "Basic Information",
        "transactionConfig": "Transaction Configuration",
        "additionalInfo": "Additional Information",
        "timestamps": "Timestamps",
        "fields": {
          "id": "ID",
          "name": "Name",
          "channelCode": "Channel Code",
          "platformId": "Platform ID",
          "status": "Status",
          "sort": "Sort",
          "currency": "Currency",
          "countries": "Countries",
          "minAmount": "Min Amount",
          "maxAmount": "Max Amount",
          "i18nKey": "I18n Key",
          "icon": "Icon",
          "sandboxMode": "Sandbox Mode",
          "createdAt": "Created At",
          "updatedAt": "Updated At"
        },
        "sandbox": {
          "enabled": "Enabled",
          "disabled": "Disabled"
        },
        "close": "Close"
      },
      "deletePlatform": {
        "title": "Delete Platform",
        "message": "Are you sure you want to delete this payment platform? This action cannot be undone."
      },
      "platform": {
        "title": "Payment Platform",
        "platformName": "Platform Name",
        "fields": {
          "name": "Name",
          "code": "Code",
          "description": "Description",
          "status": "Status"
        },
        "description": "Description",
        "status": "Status",
        "statusPlaceholder": "Select status",
        "cancel": "Cancel",
        "save": "Save"
      }
    },
    "messages": {
      "fillRequiredFields": "Please fill in all required fields",
      "platformUpdated": "Platform updated successfully",
      "platformCreated": "Platform created successfully",
      "platformDeleted": "Platform deleted successfully",
      "errorSavingPlatform": "Error saving platform",
      "errorDeletingPlatform": "Error deleting platform"
    },
    "channelTypes": {
      "bankCard": "Bank Card",
      "alipayH5": "Alipay H5",
      "wechatH5": "WeChat H5",
      "alipayQr": "Alipay QR",
      "wechatQr": "WeChat QR",
      "usdt": "USDT",
      "crypto": "Cryptocurrency",
      "beifang_online": "Beifang Online",
      "0000倒贴": "Subsidized Payment",
      "微信H5 003": "WeChat H5 003",
      "huitong": "Huitong",
      "g63 online": "G63 Online"
    }
  },
  "paymentChannelsPage": {
    "title": "Payment Channels",
    "subtitle": "Payment Channels",
    "addChannel": "Add Channel",
    "loading": "Loading channels...",
    "loadingStats": "Loading statistics...",
    "noChannels": "No payment channels found.",
    "noChannelsHint": "Add a new payment channel to get started.",
    "stats": {
      "totalChannels": "Total Channels",
      "activeChannels": "Active",
      "inactiveChannels": "Inactive",
      "maintenanceChannels": "Maintenance"
    },
    "search": {
      "placeholder": "Search channels...",
      "filterByStatus": "Filter by status"
    },
    "actions": {
      "view": "View",
      "edit": "Edit",
      "delete": "Delete"
    },
    "table": {
      "headers": {
        "businessType": "Business Type",
        "enabled": "Enabled",
        "dataStats": "Data Statistics",
        "dataStatsPercent": "Stats (%)",
        "merchantId": "Merchant ID",
        "paymentGateway": "Payment Gateway",
        "sortWeight": "Sort Weight",
        "minAmount": "Min Amount",
        "maxAmount": "Max Amount",
        "extendedParams": "Extended Parameters",
        "amountRange": "Amount Range",
        "description": "Description",
        "bizType": "Biz Type",
        "status": "Status",
        "currency": "Currency",
        "actions": "Actions"
      }
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive",
      "maintenance": "Maintenance"
    },
    "statistics": {
      "title": "Payment Statistics",
      "todayAmount": "Today Amount",
      "todaySuccessRate": "Today Success Rate",
      "yesterdayAmount": "Yesterday Amount",
      "yesterdaySuccessRate": "Yesterday Success Rate",
      "totalAmount": "Total Amount",
      "totalSuccessRate": "Total Success Rate",
      "totalRevenue": "Total Revenue",
      "totalOrders": "Total Orders",
      "successRate": "Success Rate",
      "todayLabel": "Today",
      "yesterdayLabel": "Yesterday",
      "totalLabel": "All Time",
      "amount": "Amount",
      "orders": "Orders"
    },
    "modals": {
      "channelDetails": {
        "title": "Channel Details",
        "basicInfo": "Basic Information",
        "transactionConfig": "Transaction Configuration",
        "additionalInfo": "Additional Information",
        "timestamps": "Timestamps",
        "fields": {
          "id": "ID",
          "name": "Name",
          "channelCode": "Channel Code",
          "platformId": "Platform ID",
          "status": "Status",
          "sort": "Sort",
          "currency": "Currency",
          "countries": "Countries",
          "minAmount": "Min Amount",
          "maxAmount": "Max Amount",
          "i18nKey": "I18n Key",
          "icon": "Icon",
          "sandboxMode": "Sandbox Mode",
          "createdAt": "Created At",
          "updatedAt": "Updated At"
        },
        "sandbox": {
          "enabled": "Enabled",
          "disabled": "Disabled"
        },
        "close": "Close",
        "edit": "Edit"
      },
      "deleteChannel": {
        "title": "Delete Channel",
        "message": "Are you sure you want to delete this payment channel? This action cannot be undone."
      },
      "channel": {
        "title": "Payment Channel",
        "channelName": "Channel Name",
        "channelCode": "Channel Code",
        "titleEdit": "Edit Payment Channel",
        "platform": "Platform",
        "channelType": "Channel Type",
        "status": "Status",
        "statusPlaceholder": "Select status",
        "typePlaceholder": "Select channel type",
        "minAmount": "Min Amount",
        "maxAmount": "Max Amount",
        "currency": "Currency",
        "sort": "Sort Order",
        "icon": "Icon",
        "i18nKey": "I18n Key",
        "activityType": "Activity Type",
        "activityTypePlaceholder": "Select activity type",
        "sandboxMode": "Sandbox Mode",
        "description": "Description",
        "bizType": "Business Type",
        "bizTypePlaceholder": "Select business type",
        "sortOrder": "Sort Order",
        "numericFields": "Numeric Fields",
        "statusHint": "Control whether this payment channel is active or inactive",
        "iconUpload": "Icon Upload",
        "selectIcon": "Select Icon",
        "suggestedIcons": "Suggested Icons",
        "chooseFile": "Choose File",
        "iconFileHint": "Upload an icon image for this payment channel. Supported formats: JPG, PNG, GIF. Max size: 5MB.",
        "cancel": "Cancel",
        "save": "Save"
      }
    },
    "channelTypes": {
      "bankCard": "Bank Card",
      "alipayH5": "Alipay H5",
      "wechatH5": "WeChat H5",
      "alipayQr": "Alipay QR",
      "wechatQr": "WeChat QR",
      "usdt": "USDT",
      "crypto": "Cryptocurrency",
      "beifang_online": "Beifang Online",
      "0000倒贴": "Subsidized Payment",
      "微信H5 003": "WeChat H5 003",
      "huitong": "Huitong",
      "Alipay - Beifang": "Alipay - Beifang",
      "QQ双端": "QQ Dual",
      "guanzi online": "Guanzi Online",
      "支付宝原生009": "Alipay Native 009",
      "银联扫码": "UnionPay QR",
      "支付宝BC大额": "Alipay BC Large",
      "纯视频微信扫码": "Pure Video WeChat QR",
      "支付宝纯视频原生H5": "Alipay Pure Video Native H5",
      "g63 online": "G63 Online",
      "微信H5内付原生": "WeChat H5 Internal Native",
      "支付宝H5抗投黄油": "Alipay H5 Anti-Butter",
      "微信扫码黄油专用": "WeChat QR Butter Special",
      "微信话费H5": "WeChat Phone Bill H5",
      "数字人民币": "Digital RMB",
      "微信IOS原生": "WeChat iOS Native",
      "视频专用原生": "Video Special Native",
      "微信扫码BC专用": "WeChat QR BC Special",
      "支付宝金条原生": "Alipay Gold Bar Native",
      "BC微信原生": "BC WeChat Native",
      "支付宝 VPN": "Alipay VPN",
      "BC支付宝原生": "BC Alipay Native",
      "微信视频打赏原生": "WeChat Video Reward Native",
      "微信打赏原生": "WeChat Reward Native",
      "微信 VPN": "WeChat VPN",
      "微信小额IOS": "WeChat Small Amount iOS",
      "霸王专用": "Overlord Special",
      "支付宝打赏专用": "Alipay Reward Special",
      "支付宝凤楼原生": "Alipay Phoenix Building Native",
      "支付宝原生（白天开）": "Alipay Native (Daytime Open)",
      "wxpay微信": "Wxpay WeChat",
      "momo单片视频": "Momo Single Video",
      "0077纯视频zz": "0077 Pure Video ZZ",
      "ABCD单片视频打赏": "ABCD Single Video Reward",
      "6600支付宝企业V": "6600 Alipay Enterprise V",
      "7700支付宝视频抗投": "7700 Alipay Video Anti-Butter",
      "9898抗投黄游": "9898 Anti-Butter Yellow Game",
      "4433微信h5": "4433 WeChat H5",
      "3333黄游王炸": "3333 Yellow Game King Bomb",
      "3344微信纯打赏": "3344 WeChat Pure Reward",
      "9123微信纯视频": "9123 WeChat Pure Video",
      "1010微信vpn": "1010 WeChat VPN",
      "5566微信扫码": "5566 WeChat QR",
      "9900支付宝vpn": "9900 Alipay VPN",
      "0506微信黄游h5": "0506 WeChat Yellow Game H5",
      "0102支付宝": "0102 Alipay",
      "0304微信短剧": "0304 WeChat Short Drama",
      "8800支付宝原生": "8800 Alipay Native",
      "打赏专属通道": "Reward Exclusive Channel",
      "支付宝10-500": "Alipay 10-500",
      "支付宝VPN": "Alipay VPN",
      "支付宝视频量": "Alipay Video Volume",
      "VPN，视频，游戏": "VPN, Video, Game",
      "支付宝内高层": "Alipay Internal High Level",
      "支付宝小额50起": "Alipay Small Amount 50+",
      "支付宝资金原生": "Alipay Fund Native",
      "支付宝纯原生": "Alipay Pure Native",
      "支付宝固额100": "Alipay Fixed Amount 100",
      "云闪付100-200": "UnionPay Quick Pass 100-200",
      "微信扫码前期": "WeChat QR Early Stage",
      "全层H5转账红包100-5000": "All Layer H5 Transfer Red Packet 100-5000",
      "支付宝小钱袋前期": "Alipay Small Money Bag Early Stage",
      "支付宝前期": "Alipay Early Stage",
      "小钱袋": "Small Money Bag",
      "支付宝话费": "Alipay Phone Bill",
      "技术测试": "Technical Test",
      "1188话费商城": "1188 Phone Bill Mall",
      "8000支付宝燃气": "8000 Alipay Gas",
      "8123": "8123",
      "A1127楼凤炮台": "A1127 Phoenix Tower",
      "2244微信qq": "2244 WeChat QQ",
      "V2480资金原生": "V2480 Fund Native",
      "2480资金原生": "2480 Fund Native",
      "8321微信原生": "8321 WeChat Native",
      "6606数字": "6606 Digital",
      "4443微信快手": "4443 WeChat Kuaishou",
      "2225微信扫码": "2225 WeChat QR",
      "7766大额原生": "7766 Large Amount Native",
      "2221内层5000 100-500": "2221 Inner Layer 5000 100-500",
      "5555腾讯点卷": "5555 Tencent Points",
      "4444微信": "4444 WeChat",
      "1112内层": "1112 Inner Layer",
      "0990wx视频pc端": "0990 WX Video PC",
      "8989微信h5黄游": "8989 WeChat H5 Yellow Game",
      "0708微信语聊": "0708 WeChat Voice Chat",
      "8585微信红包": "8585 WeChat Red Packet",
      "8889小额金条": "8889 Small Amount Gold Bar",
      "8009支付宝原生": "8009 Alipay Native",
      "9955微信游戏私服": "9955 WeChat Game Private Server",
      "2222微信双端原生": "2222 WeChat Dual Native",
      "9998支付宝Ai": "9998 Alipay AI",
      "7733支付宝抗投游戏私服": "7733 Alipay Anti-Butter Game Private Server",
      "6667宝转卡": "6667 Treasure Transfer Card",
      "7777小额UID": "7777 Small Amount UID",
      "8888金条原生": "8888 Gold Bar Native",
      "8811支付宝纯原生": "8811 Alipay Pure Native",
      "9999纯黄播": "9999 Pure Yellow Broadcast",
      "微信支付": "WeChat Pay",
      "支付宝": "Alipay",
      "微信扫码畅游": "WeChat QR Smooth Game",
      "名片小额100": "Card Small Amount 100",
      "微信完美6-200": "WeChat Perfect 6-200",
      "转账红包大额": "Transfer Red Packet Large Amount",
      "微信内高层": "WeChat Internal High Level",
      "代付原生": "Proxy Pay Native",
      "固定金额": "Fixed Amount",
      "小额100-200H5复制转账": "Small Amount 100-200 H5 Copy Transfer",
      "支付宝原生100-500": "Alipay Native 100-500",
      "纯原生小额8021": "Pure Native Small Amount 8021",
      "8020内高层3万加": "8020 Internal High Level 30k+",
      "8019支付宝综合": "8019 Alipay Comprehensive",
      "微信YY": "WeChat YY",
      "微信内付": "WeChat Internal Pay"
    },
    "messages": {
      "channelUpdated": "Channel updated successfully",
      "channelCreated": "Channel created successfully",
      "channelDeleted": "Channel deleted successfully",
      "statusUpdated": "Channel status updated successfully",
      "errorLoadingChannels": "Error loading channels",
      "errorLoadingPlatforms": "Error loading platforms",
      "errorSavingChannel": "Error saving channel",
      "errorUpdatingStatus": "Error updating channel status",
      "errorDeletingChannel": "Error deleting channel",
      "channelAlreadyExists": "A channel with this name or code already exists"
    },
    "bizTypes": {
      "recharge": "Recharge",
      "resource": "Resource",
      "vip": "VIP",
      "timePackage": "Time Package"
    }
  },
  "pay": {
    "channel": {
      "huitong_online": "Huitong Online"
    }
  },
  "paymentStatistics": {
    "title": "Payment Statistics",
    "subtitle": "Real-time payment performance metrics",
    "totalTransactions": "Total Transactions",
    "totalRevenue": "Total Revenue",
    "successRate": "Success Rate",
    "activeChannels": "Active Channels",
    "revenueChart": "Revenue Over Time",
    "transactionStatus": "Transaction Status",
    "completed": "Completed",
    "pending": "Pending",
    "failed": "Failed",
    "chartPlaceholder": "Chart visualization will appear here",
    "errorLoading": "Error loading payment statistics"
  },
  "user": {
    "account": "Account",
    "profile": "Profile",
    "settings": "Settings",
    "logout": "Logout"
  },
  "ads": {
    "title": "Ad Management",
    "tabs": {
      "ads": "Ads",
      "video_ads": "Video Ads",
      "video_durations": "Video Durations",
      "video_logs": "Video Logs",
      "activities": "Campaigns",
      "collections": "Collections",
      "placements": "Placements",
      "switches": "Switches",
      "triggers": "Triggers",
      "trigger_history": "Trigger History",
      "settings": "Settings",
      "tracking": "Tracking",
      "statistics": "Statistics",
      "targeting": "Targeting",
      "agents": "Agents"
    },
    "activities": {
      "title": "Campaign Management",
      "subtitle": "Create and manage campaigns with associated ads",
      "showOnAppLaunch": "Displayed when the app launches during activity",
      "showAsPopup": "Displayed as a popup during activity",
      "list": {
        "search_placeholder": "Search campaigns...",
        "filter_status": "All Status",
        "add_button": "New Campaign",
        "no_data": "No campaigns found",
        "columns": {
          "code": "Code",
          "name": "Name",
          "status": "Status",
          "start": "Start",
          "end": "End",
          "linked_ads": "Linked Ads",
          "actions": "Actions"
        }
      },
      "form": {
        "create_title": "Create New Campaign",
        "edit_title": "Edit Campaign",
        "view_title": "Campaign Details",
        "basic_info": "Basic Information",
        "period_status": "Period and Status",
        "fields": {
          "activity_code": "Campaign Code",
          "activity_code_placeholder": "e.g.: SUMMER_PROMO_2024",
          "activity_code_required": "Code required",
          "activity_name": "Campaign Name",
          "activity_name_placeholder": "e.g.: Summer Promo 2024",
          "activity_name_required": "Name required",
          "description": "Description",
          "description_placeholder": "Describe the campaign...",
          "start_time": "Start Date",
          "end_time": "End Date",
          "status": "Status",
          "status_placeholder": "Select status",
          "open_screen_ad": "Open Screen Ad",
          "open_screen_ad_short": "Open",
          "popup_ad": "Popup Ad",
          "popup_ad_short": "Popup"
        },
        "display_on_launch": "Displayed when the app launches during activity",
        "display_on_popup": "Displayed as a popup during activity",
        "actions": {
          "cancel": "Cancel",
          "create": "Create",
          "update": "Update",
          "save": "Save"
        }
      },
      "display_order": {
        "title": "Scheduled Display Order",
        "step_launch": "1. App Launch",
        "step_normal_open": "2. → Normal Open Screen Ad (if enabled)",
        "step_activity_open": "{step}. → Campaign Open Screen Ad",
        "step_enter": "{step}. Enter App",
        "step_normal_popup": "{step}. → Normal Popup (if enabled)",
        "step_activity_popup": "{step}. → Campaign Popup"
      },
      "preview_info": {
        "open_screen_title": "Open Screen Ad",
        "open_screen_desc": "Displayed when app launches during campaign period",
        "popup_title": "Popup Ad",
        "popup_desc": "Displayed as popup during campaign period"
      },
      "status": {
        "draft": "Draft",
        "active": "Active",
        "paused": "Paused",
        "expired": "Expired"
      },
      "messages": {
        "load_error": "Failed to load campaigns",
        "create_success": "Campaign created successfully",
        "update_success": "Campaign updated successfully",
        "delete_success": "Campaign deleted successfully",
        "delete_confirm": "Are you sure you want to delete this campaign?",
        "validation": {
          "code_required": "Code required",
          "code_invalid": "Campaign code can only contain uppercase letters, numbers, underscores and hyphens",
          "name_required": "Name required",
          "name_invalid": "Campaign name contains invalid characters",
          "date_invalid": "End date must be after start date"
        }
      }
    },
    "video_ads": {
      "modal": {
        "createVideoAd": "Create Video Ad",
        "editVideoAd": "Edit Video Ad"
      },
      "button": {
        "addVideoAd": "Add Video Ad",
        "createAd": "Create Advertisement",
        "saveChanges": "Save Changes",
        "cancel": "Cancel",
        "openVideo": "Open Video",
        "close": "Close",
        "apply": "Apply",
        "create": "Create"
      },
      "form": {
        "triggerMoment": "Trigger Moment *",
        "internalTitle": "Internal Title",
        "internalTitlePlaceholder": "Name to identify the ad",
        "videoFile": "Video File",
        "dragVideo": "Drag video here",
        "currentUrl": "Current URL :",
        "coverImage": "Cover Image",
        "dragImage": "Drag image here",
        "rewardApiUrl": "Reward API URL",
        "rewardApiUrlPlaceholder": "e.g.: /api/game/reward",
        "rewardApiHint": "Called automatically after watching",
        "redirectUrl": "Redirect URL",
        "redirectUrlPlaceholder": "e.g.: https://...",
        "redirectHint": "Open when clicking the ad",
        "displayOrder": "Display Order",
        "activeAd": "Active Advertisement",
        "forcePlay": "Forced Play (Non-skippable)",
        "orientation": "Orientation",
        "portrait": "Portrait",
        "landscape": "Landscape",
        "all": "All",
        "skipConfig": "Skip Config",
        "skipAfter": "Skip after (s)",
        "skipTextFr": "Text (FR)",
        "skipTextEn": "Text (EN)",
        "start": "Start",
        "end": "End"
      },
      "messages": {
        "uploadVideo": "Please upload a video before creating the ad",
        "uploadCover": "Please upload a cover image before creating the ad"
      },
      "details": {
        "title": "Video Ad Details",
        "titleLabel": "Title",
        "videoDuration": "Video Duration",
        "configuration": "Configuration",
        "trigger": "Trigger",
        "status": "Status",
        "playMode": "Playback",
        "rewardUrl": "Reward URL",
        "targetUrl": "Target URL",
        "videoPlay": "Video Playback",
        "coverImage": "Cover Image",
        "adDetails": "Advertisement Details",
        "urls": "URLs",
        "duration": "Duration",
        "type": "Type",
        "sortOrder": "Order",
        "orientation": "Orientation"
      },
      "orientation": {
        "portrait": "Portrait",
        "landscape": "Landscape",
        "all": "All"
      },
      "batch": {
        "orientation": {
          "title": "Update Orientation",
          "setForVideos": "Set orientation for {count} video(s):",
          "newOrientation": "New Orientation"
        },
        "skipConfig": {
          "title": "Skip Button Configuration",
          "applyForVideos": "Apply configuration to {count} video(s):",
          "enableSkip": "Enable Skip",
          "skipAfterSeconds": "Skip after (seconds)",
          "textFr": "Text (FR)",
          "textEn": "Text (EN)"
        }
      },
      "status": {
        "active": "Active",
        "inactive": "Inactive"
      },
      "play": {
        "force": "Forced",
        "skippable": "Skippable"
      },
      "common": {
        "required": "required"
      }
    },
    "durationConfig": {
      "modal": {
        "create": "Create Configuration",
        "edit": "Edit Configuration"
      },
      "form": {
        "durationSeconds": "Duration (seconds) *",
        "description": "Description",
        "descriptionPlaceholder": "Example: Display after 3 minutes",
        "sortOrder": "Sort Order",
        "active": "Active"
      },
      "validation": {
        "durationPositive": "Duration must be greater than 0"
      },
      "common": {
        "cancel": "Cancel",
        "create": "Create",
        "update": "Update"
      }
    },
    "collections": {
      "title": "Ad Collection Management",
      "subtitle": "Manage collection display configurations in grid or sequence mode",
      "noData": "No items found.",
      "noFiltered": "No items match the filter criteria.",
      "list": {
        "search_placeholder": "Search collections...",
        "filter_mode": "All Modes",
        "add_button": "New Collection",
        "columns": {
          "code": "Code",
          "name": "Name",
          "mode": "Mode",
          "config": "Config",
          "ads": "Ads",
          "status": "Status",
          "actions": "Actions"
        },
        "config_grid": "{count} columns",
        "config_sequence": "{delay}s delay",
        "ads_count": "{count} ads"
      },
      "status": {
        "draft": "Draft",
        "active": "Active",
        "paused": "Paused",
        "expired": "Expired"
      },
      "form": {
        "create_title": "Create New Collection",
        "edit_title": "Edit Collection",
        "view_title": "Collection Details",
        "basic_info": "Basic Information",
        "display_mode": "Display Mode",
        "member_ads": "Associated Ads",
        "status": "Status",
        "fields": {
          "code": "Collection Code",
          "code_placeholder": "e.g.: SUMMER_GRID_1",
          "name": "Collection Name",
          "name_placeholder": "e.g.: Summer 2024 Collection",
          "description": "Description",
          "description_placeholder": "Describe the collection...",
          "mode": "Display Mode",
          "grid_columns": "Number of Columns",
          "grid_column": "{count} column",
          "grid_columns_many": "{count} columns",
          "sequence_delay": "Ad Switch Delay (seconds)",
          "sequence_delay_placeholder": "e.g.: 3",
          "seconds": "seconds"
        },
        "modes": {
          "grid": "Grid",
          "grid_desc": "Ads displayed simultaneously in grid layout",
          "sequence": "Sequence",
          "sequence_desc": "Ads displayed one by one with configurable delay",
          "grid_full": "Grid - Display simultaneously in grid",
          "sequence_full": "Sequence - Display one by one with delay"
        },
        "selection": {
          "title": "Select Ads",
          "search_placeholder": "Search ads...",
          "no_data": "No ads found",
          "add_button": "Add Ad",
          "instruction": "Select ads to include in this collection. They will be displayed in grid layout/list order.",
          "none_selected": "No ads selected. Please add ads to this collection.",
          "format": "Format: {format}",
          "cancel": "Cancel",
          "close": "Close"
        },
        "actions": {
          "cancel": "Cancel",
          "create": "Create",
          "update": "Update"
        }
      },
      "messages": {
        "load_error": "Failed to load collections",
        "save_success": "Collection saved successfully",
        "create_success": "Collection created successfully",
        "update_success": "Collection updated successfully",
        "save_error": "Failed to save collection",
        "delete_confirm": "Are you sure you want to delete collection \"{name}\"?",
        "delete_success": "Collection deleted.",
        "delete_error": "Failed to delete collection",
        "validation": {
          "code_required": "Code required",
          "code_invalid": "Collection code can only contain uppercase letters, numbers, underscores and hyphens",
          "name_required": "Name required",
          "name_min_length": "Name must be at least 2 characters",
          "name_invalid": "Collection name contains invalid characters",
          "mode_required": "Please select display mode",
          "columns_required": "Please select number of columns",
          "delay_required": "Please fill in delay time",
          "ads_required": "Please select at least one ad"
        }
      }
    },
    "placements_management": {
      "title": "Placement Management",
      "subtitle": "Manage ad placements and their display configurations",
      "noData": "No items found.",
      "noFiltered": "No items match the filter criteria.",
      "list": {
        "search_placeholder": "Search placements...",
        "category_filter": "All Categories",
        "add_button": "Add Placement",
        "insertion_frequency_text": "1 ad every {count} items",
        "columns": {
          "name": "Placement",
          "category": "Category",
          "type": "Type",
          "enabled": "Enabled",
          "platforms": "Platforms",
          "status": "Status",
          "actions": "Actions"
        }
      },
      "batch": {
        "selected_count": "{count} placements selected",
        "activate": "Activate",
        "deactivate": "Deactivate",
        "orientation": "Screen Orientation",
        "close_button": "Close Button",
        "delete": "Delete",
        "cancel": "Cancel"
      },
      "form": {
        "create_title": "Create New Placement",
        "edit_title": "Edit Placement",
        "view_title": "Placement Details",
        "basic_info": "Basic Information",
        "scene_classification": "Scene Classification",
        "display_config": "Display Configuration",
        "platform_control": "Platform Control & Screen Orientation",
        "close_button_section": "Close Button",
        "allowed_formats": "Allowed Ad Formats",
        "fields": {
          "code": "Placement Code",
          "name": "Placement Name",
          "description": "Description",
          "description_placeholder": "Describe this placement...",
          "scene_type": "Scene Type / Category",
          "video_type": "Video Placement Type",
          "community_type": "Community Placement Type",
          "chat_type": "Chat Placement Type",
          "system_type": "System Placement Type",
          "open_screen_type": "Open Screen Type",
          "activity_type": "Activity Type",
          "search_type": "Search Type",
          "trigger_time": "Trigger Time (seconds)",
          "trigger_percent": "Trigger Percentage (%)",
          "insertion_frequency": "Insertion Frequency",
          "insertion_placeholder": "1 ad every N items",
          "frequency_cap": "Frequency Cap",
          "frequency_placeholder": "Maximum display count",
          "frequency_unit": "Frequency Unit",
          "display_interval": "Minimum Display Interval (seconds)",
          "interval_placeholder": "Minimum interval between ads",
          "devices": "Allowed Devices",
          "devices_placeholder": "Select devices",
          "orientation": "Allowed Screen Orientations",
          "show_close_button": "Show Button",
          "close_button_after": "Show After Delay (seconds)",
          "close_button_position": "Button Position",
          "status": "Status",
          "is_enabled": "Enabled Status (Switch)",
          "activation_hint": "Status must be \"Active\" to enable"
        }
      },
      "categories": {
        "video": "Video",
        "feed": "Feed",
        "chat": "Chat",
        "status": "Status (System)",
        "open_screen": "Open Screen",
        "activity": "Activity",
        "search": "Search",
        "popup_daily": "Daily Popup",
        "popup_after_views": "Post-View Popup",
        "popup_marketing": "Marketing Popup",
        "popup_exit": "Exit Popup",
        "popup_redirect": "Redirect Popup",
        "loading": "Loading",
        "network_error": "Network Error",
        "offline": "Offline",
        "app_promotion": "App Promotion",
        "rewarded_redirect": "Rewarded Redirect",
        "offerwall": "Offerwall",
        "video_pause": "Video Pause",
        "video_preroll": "Video Preroll",
        "video_midroll": "Video Midroll",
        "video_postroll": "Video Postroll",
        "fixed_placement": "Fixed Placement",
        "popup": "Popup",
        "trigger_based": "Behavior Trigger",
        "redirect": "Redirect"
      },
      "detailed_types": {
        "video_feed_banner": "Video Feed Banner",
        "video_pause_fullscreen": "Video Pause Ad (Fullscreen)",
        "video_bottom_banner": "Video Bottom Banner",
        "community_feed_inline": "Community Feed Inline",
        "community_top_banner": "Top Banner",
        "community_native_small": "Native Inline (Small)",
        "community_large_newsfeed": "Large Image Ad (Newsfeed)",
        "chat_top_banner": "Chat Top Banner",
        "chat_bubble_system": "Chat Bubble (System/AI)",
        "chat_bottom_cta": "Bottom CTA Button",
        "chat_list_inline": "Chat List Inline",
        "chat_input_recommendation": "Input Area Recommendation",
        "system_loading": "Loading",
        "system_network_error": "Network Error",
        "system_offline": "Offline",
        "open_screen_fullscreen": "Fullscreen Open Screen",
        "open_screen_secondary": "Secondary Screen (Light)",
        "activity_banner": "Activity Banner",
        "activity_popup": "Activity Popup",
        "activity_inline": "Inline Activity",
        "search_top_banner": "Search Top Banner",
        "search_bottom_banner": "Search Bottom Banner",
        "search_inline": "In Search Results",
        "search_sidebar": "Search Sidebar",
        "popup_daily_first": "Daily Initial Popup",
        "popup_after_n_videos": "After N Views",
        "popup_redirect_app": "App Redirect",
        "redirect_app_download": "App Download",
        "redirect_rewarded": "Rewarded Redirect",
        "redirect_offerwall": "Offerwall",
        "video_preroll": "Preroll Ad",
        "video_midroll": "Midroll Ad"
      },
      "orientation": {
        "all": "All",
        "portrait": "Portrait",
        "landscape": "Landscape"
      },
      "close_button": {
        "top_right": "Top Right",
        "top_left": "Top Left",
        "bottom_right": "Bottom Right",
        "bottom_left": "Bottom Left"
      },
      "formats": {
        "fullscreen_image": "Fullscreen Image",
        "fullscreen_video": "Fullscreen Video",
        "halfscreen": "Half-screen",
        "collection": "Collection"
      },
      "units": {
        "per_day": "Per Day",
        "per_hour": "Per Hour",
        "per_session": "Per Session",
        "per_user_lifetime": "Per User Lifetime"
      },
      "messages": {
        "load_error": "Failed to load placements",
        "save_success": "Placement saved successfully",
        "update_success": "Placement updated successfully",
        "create_success": "Placement created successfully",
        "save_error": "Save failed",
        "delete_confirm": "Delete placement \"{name}\"?",
        "delete_success": "Placement deleted",
        "delete_error": "Delete failed",
        "deleteVersion": "Version deleted successfully",
        "deleteLink": "Delete Link",
        "deleteLinkConfirm": "Are you sure you want to delete version link \"{name}\" for version \"{version}\"?",
        "deleteLinkWarning": "This action cannot be undone.",
        "dragAndDropFile": "Drag and drop files here",
        "linkCopied": "Link copied to clipboard",
        "failedToCopyLink": "Failed to copy link",
        "batch_activate_confirm": "Activate selected {count} placements?",
        "batch_activate_success": "{count} placements activated successfully",
        "batch_deactivate_confirm": "Deactivate selected {count} placements?",
        "batch_deactivate_success": "{count} placements deactivated successfully",
        "batch_delete_confirm": "Warning: Permanently delete selected {count} placements?\n\nThis action is irreversible!",
        "batch_delete_success": "{count} placements deleted successfully",
        "batch_update_success": "{count} placements updated successfully",
        "validation": {
          "code_required": "Code required",
          "code_invalid": "Placement code can only contain uppercase letters, numbers, underscores and hyphens",
          "name_required": "Name required",
          "name_min_length": "Name must contain at least 2 characters",
          "name_invalid": "Placement name contains invalid characters",
          "scene_type_required": "Scene type required"
        }
      }
    },
    "button": {
      "addVideoAd": "Add Video Ad",
      "addDurationSetting": "Add Duration Setting"
    },
    "commun": {
      "status": {
        "active": "Active",
        "inactive": "Inactive",
        "paused": "Paused",
        "expired": "Expired"
      }
    },
    "list": {
      "search_placeholder": "Search ads...",
      "searchConfiguration": "Search Configurations...",
      "searchVideoAds": "Search Video Ads...",
      "filter_duration": "Filter by Duration",
      "filter_status": "Filter by Status",
      "add_button": "Add Ad",
      "no_image": "No image",
      "noData": "No items found.",
      "noFiltered": "No items match the filter criteria.",
      "columns": {
        "image": "Image",
        "code": "Code",
        "name": "Name",
        "status": "Status",
        "placements": "Placements",
        "triggers": "Triggers",
        "priority": "Priority",
        "start_time": "Start Time",
        "end_time": "End Time",
        "actions": "Actions",
        "video": "VIDEO",
        "duree": "DURATION",
        "type": "Type",
        "order": "Order",
        "second": "Second",
        "description": "Description",
        "action": "Action"
      },
      "actions": {
        "view": "View Details",
        "manage_placements": "Manage Placements",
        "manage_triggers": "Manage Triggers",
        "edit": "Edit",
        "delete": "Delete"
      },
      "pagination": {
        "page_info": "Page {current} of {total}"
      }
    },
    "form": {
      "create_title": "Create New Ad",
      "edit_title": "Edit Ad",
      "fields": {
        "ad_code": "Ad Code",
        "ad_code_placeholder": "e.g.: SUMMER_PROMO_2024",
        "ad_code_required": "Code required",
        "ad_code_invalid": "Invalid code (uppercase letters, numbers, underscores, hyphens only)",
        "ad_name": "Ad Name",
        "ad_name_placeholder": "e.g.: Summer Promo 2024",
        "ad_name_required": "Name required",
        "ad_name_invalid": "Invalid characters",
        "multilingual_content": "Multilingual Content",
        "title": "Title",
        "title_placeholder": "Enter title...",
        "description": "Description",
        "description_placeholder": "Enter description...",
        "target_type": "Target Type",
        "target_type_placeholder": "Select type",
        "target_url": "Target URL",
        "target_url_placeholder": "Enter URL",
        "display_format": "Display Format",
        "display_format_placeholder": "Select format",
        "ad_position": "Video Position",
        "ad_position_placeholder": "Select position",
        "cta_text": "CTA Text",
        "cta_text_placeholder": "Enter call-to-action text",
        "priority": "Priority",
        "priority_placeholder": "0",
        "weight": "Weight",
        "weight_placeholder": "1",
        "status": "Status",
        "status_placeholder": "Select status",
        "start_time": "Start Time",
        "start_time_required": "Start time required",
        "start_time_validation": "Must be before or equal to end time",
        "end_time": "End Time",
        "end_time_required": "End time required",
        "end_time_validation": "Must be after or equal to start time",
        "image": "Ad Image",
        "image_info": "System will automatically generate 3 optimized sizes (small, medium, large) from this image",
        "crop_image": "Crop and Adjust Image",
        "video": "Video File",
        "video_cover": "Video Cover",
        "video_duration": "Video Duration (seconds)",
        "display_config": "Display Configuration",
        "is_skippable": "Skippable",
        "skip_countdown": "Skip Countdown (seconds)",
        "min_watch": "Minimum Watch Time (seconds)",
        "close_button_delay": "Close Button Delay (seconds)",
        "time_slots": "Allowed Time Slots",
        "time_slots_optional": "(Optional)",
        "time_slots_info": "Define time periods when this ad can be displayed. If no time slots are defined, ad will display anytime.",
        "start_hour": "Start Hour",
        "end_hour": "End Hour",
        "days": "Days",
        "all_days": "All Days",
        "add_time_slot": "Add Time Slot"
      },
      "target_types": {
        "url": "URL",
        "deeplink": "Deep Link",
        "page": "Page",
        "app": "App",
        "none": "None"
      },
      "display_formats": {
        "fullscreen_image": "Fullscreen Image",
        "fullscreen_video": "Fullscreen Video",
        "halfscreen": "Half-screen",
        "collection": "Collection"
      },
      "ad_positions": {
        "not_applicable": "Not Applicable",
        "preroll": "Preroll (before video)",
        "midroll": "Midroll (during video)",
        "postroll": "Postroll (after video)",
        "pause": "Pause (when video paused)"
      },
      "days_of_week": {
        "1": "Monday",
        "2": "Tuesday",
        "3": "Wednesday",
        "4": "Thursday",
        "5": "Friday",
        "6": "Saturday",
        "0": "Sunday"
      },
      "actions": {
        "cancel": "Cancel",
        "create": "Create",
        "update": "Update",
        "save": "Save"
      }
    },
    "crop_modal": {
      "title": "Advanced Image Editor",
      "zoom_in": "Zoom In +",
      "zoom_out": "Zoom Out -",
      "rotate_left": "Rotate Left ←",
      "rotate_right": "Rotate Right →",
      "aspect_ratio": "16:9",
      "aspect_ratio_square": "1:1",
      "aspect_ratio_free": "Free",
      "flip_horizontal": "Flip Horizontal H",
      "flip_vertical": "Flip Vertical V",
      "crop_info": "Interactive crop enabled - move and adjust selection area",
      "cancel": "Cancel",
      "apply": "Apply Crop"
    },
    "details": {
      "title": "Ad Details",
      "ad_code": "Ad Code",
      "ad_name": "Ad Name",
      "status": "Status",
      "priority": "Priority",
      "description": "Description",
      "start_time": "Start Time",
      "end_time": "End Time",
      "placements": "Associated Placements ({count})",
      "triggers": "Associated Triggers ({count})",
      "no_placements": "No associated placements",
      "no_triggers": "No associated triggers",
      "close": "Close"
    },
    "placements": {
      "title": "Manage Placements",
      "info": "Select where this ad should appear.",
      "search_placeholder": "Search placements...",
      "selected": "Selected Placements: {count}",
      "no_selected": "No placements selected",
      "priority": "Priority",
      "weight": "Weight",
      "code_label": "Code",
      "category_label": "Category",
      "actions": {
        "cancel": "Cancel",
        "save": "Save"
      }
    },
    "triggers": {
      "title": "Trigger Rules",
      "subtitle": "Create simple or combined rules to automatically trigger ad displays",
      "info": "Manage triggers",
      "search_placeholder": "Search triggers...",
      "selected": "Selected Triggers",
      "no_selected": "No triggers selected",
      "filters": {
        "search": "Search rules...",
        "all_types": "All Types"
      },
      "buttons": {
        "new_rule": "New Rule",
        "cancel": "Cancel",
        "save": "Save",
        "create": "Create",
        "update": "Update",
        "close": "Close",
        "test": "Run Test",
        "add_condition": "Add Condition",
        "delete": "Delete",
        "yes_delete": "Yes, delete!"
      },
      "table": {
        "code": "Code",
        "name": "Name",
        "type": "Type",
        "accumulation": "Accumulation",
        "active": "Active",
        "status": "Status",
        "actions": "Actions",
        "global": "Global",
        "session": "Session"
      },
      "code_label": "Code",
      "type_label": "Type",
      "threshold_label": "Threshold",
      "modal": {
        "create_title": "Create New Rule",
        "edit_title": "Edit Rule",
        "view_title": "Rule Details",
        "test_title": "Test Trigger Rule",
        "basic_info": "Basic Information",
        "simple_config": "Simple Configuration",
        "combined_config": "Combined Rule Configuration",
        "advanced_params": "Advanced Settings",
        "test_description": "Simulate user behavior to test if the rule triggers correctly.",
        "logic_preview": "Logic Preview"
      },
      "form": {
        "rule_code": "Rule Code *",
        "rule_name": "Rule Name *",
        "trigger_type": "Trigger Type *",
        "threshold": "Trigger Threshold *",
        "time_window": "Time Window (optional)",
        "resource_type": "Applicable Resource Type (optional)",
        "accumulation_mode": "Accumulation Mode",
        "reset_after": "Reset After Trigger",
        "status": "Status",
        "enabled": "Rule Enabled",
        "logical_operator": "Logical Operator *",
        "condition_type": "Condition Type",
        "wait_time": "Wait Time (optional)",
        "simulation_value": "Simulation Value"
      },
      "placeholders": {
        "rule_code": "e.g.: TRIGGER_SCROLL_3",
        "rule_name": "e.g.: Trigger after 3 scrolls",
        "all_resources": "All Resources",
        "seconds": "seconds",
        "wait_seconds": "seconds",
        "choose": "Choose...",
        "operator_and": "AND - All conditions must be met",
        "operator_or": "OR - At least one condition must be met",
        "hours": "hours",
        "time_window": "e.g.: 3600 for 1 hour",
        "threshold_example": "e.g.: 3",
        "browse_example": "e.g.: 3 scrolls",
        "watch_example": "e.g.: 5 videos",
        "stay_example": "e.g.: 60 seconds",
        "like_example": "e.g.: 10 likes",
        "comment_example": "e.g.: 5 comments",
        "share_example": "e.g.: 3 shares",
        "visit_example": "e.g.: 2 visits",
        "chat_example": "e.g.: 3 interactions"
      },
      "trigger_types": {
        "browse_count": "Scroll",
        "watch_count": "Watch",
        "stay_duration": "Stay Duration",
        "like_count": "Like",
        "comment_count": "Comment",
        "share_count": "Share",
        "page_visit_count": "Visit",
        "ai_chat_count": "AI Chat",
        "custom_combination": "Combination",
        "exit_intent": "Exit",
        "app_background": "Background",
        "network_error": "Network Error",
        "loading_complete": "Loading",
        "scroll_depth": "Depth",
        "browse_count_desc": "Scroll - After N scrolls",
        "watch_count_desc": "Watch - After M videos",
        "stay_duration_desc": "Stay Duration - After T seconds on page",
        "like_count_desc": "Like - After X likes",
        "comment_count_desc": "Comment - After Y comments",
        "share_count_desc": "Share - After Z shares",
        "page_visit_count_desc": "Visit - After N page visits",
        "ai_chat_count_desc": "AI Chat - After N interactions",
        "custom_combination_desc": "Custom Combination (AND/OR)",
        "exit_intent_desc": "Exit Intent - When user wants to leave",
        "app_background_desc": "Background - When app goes to background",
        "network_error_desc": "Network Error - When connection error occurs",
        "loading_complete_desc": "Loading Complete - After initial load",
        "scroll_depth_desc": "Scroll Depth - After scrolling N%"
      },
      "accumulation_modes": {
        "global": "Global - Continuous accumulation",
        "session": "Session - Reset each session",
        "daily": "Daily - Reset daily"
      },
      "statuses": {
        "draft": "Draft",
        "active": "Active",
        "paused": "Paused",
        "expired": "Expired",
        "inactive": "Inactive"
      },
      "units": {
        "times": "times",
        "videos": "videos",
        "likes": "likes",
        "comments": "comments",
        "shares": "shares",
        "visits": "visits",
        "interactions": "interactions",
        "seconds_short": "sec",
        "seconds": "seconds"
      },
      "messages": {
        "load_error": "Failed to load rules",
        "save_success": "Rule saved successfully",
        "update_success": "Rule updated successfully",
        "save_error": "Failed to save rule",
        "delete_confirm_title": "Are you sure?",
        "delete_confirm_text": "Do you want to delete rule \"{name}\"?",
        "delete_success": "Rule deleted.",
        "delete_error": "Failed to delete rule",
        "toggle_success": "Rule {status}",
        "toggle_error": "Failed to change status",
        "test_triggered": "✓ Rule triggered!",
        "test_not_triggered": "✗ Rule not triggered",
        "no_condition": "No condition",
        "threshold_reached": "Threshold {threshold} reached, current value {value}",
        "threshold_not_reached": "Threshold {threshold} not reached (current: {value})",
        "combined_test_sim": "Simulating test for combined rule with {count} conditions",
        "activated": "Activated",
        "deactivated": "Deactivated",
        "required": "Required",
        "yes": "Yes",
        "no": "No",
        "example": "Example",
        "success_title": "Success",
        "error_title": "Error",
        "delete_success_title": "Deleted!"
      },
      "resource_types": {
        "video": "Video",
        "image": "Image",
        "audio": "Audio",
        "article": "Article"
      },
      "combined": {
        "description": "Create complex rules by combining multiple conditions with AND/OR logic.",
        "and_description": "All conditions must be met",
        "or_description": "At least one condition must be met",
        "and_operator": "AND",
        "or_operator": "OR"
      },
      "examples": {
        "browse_count": "User scrolls 3 times in list → Trigger ad",
        "watch_count": "User watches 5 videos → Trigger ad",
        "stay_duration": "User stays on page for 60 seconds → Trigger ad",
        "like_count": "User likes 10 content → Trigger ad",
        "comment_count": "User comments 5 times → Trigger ad",
        "share_count": "User shares 3 times → Trigger ad",
        "page_visit_count": "User visits page 2 times → Trigger ad",
        "ai_chat_count": "User interacts with AI chat 3 times → Trigger ad"
      },
      "test": {
        "rule": "Rule",
        "simulation_placeholder": "Enter test value"
      },
      "view": {
        "general_info": "General Information",
        "conditions": "Conditions",
        "wait": "Wait",
        "description": "Description",
        "rule": "Rule",
        "enter_test_value": "Enter test value"
      },
      "operators": {
        "and": "AND",
        "or": "OR"
      },
      "threshold": "Threshold",
      "seconds": "seconds",
      "actions": {
        "cancel": "Cancel",
        "save": "Save"
      }
    },
    "settings": {
      "title": "Global Settings",
      "subtitle": "Configure global parameters for the ad system. To enable/disable the system, use the \"Switch Controls\" tab.",
      "sections": {
        "frequency": "Global Frequency Limits",
        "priority": "Display Priority",
        "advanced": "Advanced Parameters",
        "analytics": "Analytics Settings",
        "skip": "\"Skip\" Configuration",
        "close_button": "Global Close Button",
        "breakpoints": "Responsive Breakpoints"
      },
      "frequency": {
        "description": "Control maximum ad display frequency for all users",
        "global_cap": "Global Frequency Cap",
        "time_unit": "Time Unit",
        "max_per_session": "Max Ads Per Session",
        "min_interval": "Minimum Interval Between Ads",
        "ads_unit": "ads",
        "seconds_unit": "seconds"
      },
      "frequency_units": {
        "per_hour": "Per Hour",
        "per_day": "Per Day",
        "per_week": "Per Week",
        "per_session": "Per Session"
      },
      "priority": {
        "description": "Define display priority for each ad type (1 = highest priority)",
        "open_screen": "Open Screen",
        "popup": "Popup",
        "activity": "Activity",
        "video": "Video",
        "trigger_based": "Trigger-based",
        "redirect": "Redirect"
      },
      "advanced": {
        "counter_accumulation": "Enable Accumulation Counter",
        "counter_accumulation_desc": "Allow accumulation of impressions across multiple periods",
        "accumulation_mode": "Accumulation Mode",
        "auto_refresh": "Allow Auto-refresh",
        "auto_refresh_desc": "Automatically update ad collections",
        "refresh_interval": "Refresh Interval (seconds)",
        "debug_mode": "Debug Mode",
        "debug_mode_desc": "Enable detailed logs for debugging",
        "test_banners": "Display Test Banners",
        "test_banners_desc": "Display ads in test mode with visual indicators"
      },
      "accumulation_modes": {
        "rolling": "Rolling Window",
        "reset": "Periodic Reset",
        "lifetime": "Total Lifetime"
      },
      "analytics": {
        "impression_tracking": "Enable Impression Tracking",
        "impression_tracking_desc": "Record all ad impressions",
        "click_tracking": "Enable Click Tracking",
        "click_tracking_desc": "Record all ad clicks",
        "conversion_tracking": "Enable Conversion Tracking",
        "conversion_tracking_desc": "Track conversions after ad interactions",
        "retention_days": "Analytics Data Retention (days)"
      },
      "skip": {
        "enable_skip": "Enable Skip Option",
        "enable_skip_desc": "Allow users to skip ads after delay",
        "skip_after": "Skip After Delay (seconds)",
        "show_button": "Show Button:",
        "button_text_fr": "Button Text (French)",
        "button_text_en": "Button Text (English)",
        "button_text_es": "Button Text (Spanish)"
      },
      "close_button": {
        "show_button": "Show Close Button",
        "show_button_desc": "Display close X on ads",
        "show_after": "Show After Delay (seconds)",
        "show_after_placeholder": "0 for immediate display",
        "position": "Button Position"
      },
      "positions": {
        "top_right": "Top Right",
        "top_left": "Top Left",
        "bottom_right": "Bottom Right",
        "bottom_left": "Bottom Left"
      },
      "breakpoints": {
        "description": "Define screen widths for device targeting (pixels)",
        "mobile": "Mobile (max width)",
        "tablet": "Tablet (max width)",
        "desktop": "Desktop (min width)"
      },
      "buttons": {
        "reset": "Reset",
        "save": "Save Settings"
      },
      "messages": {
        "load_error": "Failed to load settings",
        "save_success": "Settings saved successfully",
        "save_error": "Failed to save settings",
        "reset_success": "Settings reset"
      }
    },
    "tracking": {
      "description": "View ad tracking data: impressions, clicks, conversions",
      "filters": {
        "title": "Filters",
        "ad": "Ad",
        "all_ads": "All Ads",
        "date_range": "Date Range"
      },
      "buttons": {
        "search": "Search",
        "reset": "Reset"
      },
      "stats": {
        "impressions": "Impressions",
        "clicks": "Clicks",
        "conversions": "Conversions",
        "video_plays": "Video Plays"
      },
      "metrics": {
        "ctr": "Click-Through Rate (CTR)",
        "ctr_desc": "Clicks / Impressions",
        "conversion_rate": "Conversion Rate",
        "conversion_rate_desc": "Conversions / Clicks"
      },
      "tabs": {
        "impressions": "Impressions",
        "clicks": "Clicks",
        "conversions": "Conversions",
        "video_plays": "Video Plays"
      },
      "columns": {
        "ad": "Ad",
        "placement": "Placement",
        "user_id": "User ID",
        "device": "Device",
        "datetime": "Date/Time",
        "type": "Type",
        "value": "Value",
        "duration": "Duration",
        "completion_rate": "Completion Rate"
      }
    },
    "statistics": {
      "description": "Ad statistics dashboard with performance metrics, comparative analysis and detailed data.",
      "noData": "No items found.",
      "noFiltered": "No items match the filter criteria.",
      "overview": {
        "total_ads": "Total Ads",
        "active": "Active",
        "total_impressions": "Total Impressions",
        "total_clicks": "Total Clicks",
        "total_conversions": "Total Conversions",
        "vs_last": "vs last period"
      },
      "metrics": {
        "avg_ctr": "Average CTR",
        "clicks_impressions": "Clicks / Impressions",
        "avg_conversion_rate": "Average Conversion Rate",
        "conversions_clicks": "Conversions / Clicks",
        "performance_score": "Overall Performance Score",
        "performance_desc": "Based on CTR, conversion rate and engagement"
      },
      "sections": {
        "top_ads": "Top Performing Ads",
        "by_placement": "By Placement",
        "trends": "Time Trends"
      },
      "limits": {
        "top_5": "Top 5",
        "top_10": "Top 10",
        "top_20": "Top 20"
      },
      "placeholders": {
        "all_ads": "All Ads",
        "all_placements": "All Placements"
      },
      "columns": {
        "ad": "Ad",
        "impressions": "Impressions",
        "clicks": "Clicks",
        "conversions": "Conversions",
        "ctr": "CTR",
        "conv_rate": "Conv. Rate",
        "placement": "Placement"
      },
      "trends": {
        "description": "Performance visualization for selected time period. Data shows evolution of impressions, clicks and conversions over time.",
        "impressions_growth": "Impressions Growth",
        "clicks_growth": "Clicks Growth",
        "conversions_growth": "Conversions Growth"
      }
    },
    "status": {
      "draft": "Draft",
      "active": "Active",
      "paused": "Paused",
      "expired": "Expired"
    },
    "scene_categories": {
      "video": "Video",
      "community": "Community",
      "chat": "Chat",
      "system": "System",
      "open_screen": "Open Screen",
      "popup": "Popup",
      "activity": "Activity",
      "status": "Status",
      "search": "Search",
      "feed": "Feed"
    },
    "trigger_types": {
      "browse_count": "Browse",
      "watch_count": "Watch",
      "stay_duration": "Stay Duration",
      "like_count": "Like",
      "comment_count": "Comment",
      "share_count": "Share",
      "page_visit_count": "Page Visit",
      "ai_chat_count": "AI Chat",
      "custom_combination": "Combination"
    },
    "messages": {
      "error_title": "Error",
      "warning_title": "Warning",
      "save_failed": "Failed to save ad",
      "delete_failed": "Failed to delete ad",
      "placements_update_failed": "Failed to update placements",
      "triggers_update_failed": "Failed to update triggers",
      "load_error": "Failed to load ads",
      "create_success": "Ad created successfully",
      "update_success": "Ad updated successfully",
      "delete_confirm": "Do you want to delete ad \"{name}\"?",
      "delete_success": "Ad deleted",
      "placements_updated": "Placements updated successfully",
      "triggers_updated": "Triggers updated successfully",
      "validation": {
        "code_invalid": "Ad code can only contain uppercase letters, numbers, underscores and hyphens",
        "name_min_length": "Ad name must be at least 2 characters",
        "name_invalid_chars": "Name cannot contain characters: &lt; &gt; \" ' &amp;",
        "date_range": "End time must be greater than or equal to start time"
      },
      "video": {
        "transcoded": "Video transcoded",
        "transcoded_success": "Video transcoded successfully",
        "transcode_error": "Transcode error"
      },
      "crop": {
        "success": "Image cropped successfully",
        "error": "Crop failed: {message}",
        "crop_error": "Unable to crop image"
      },
      "actions": {
        "save": "Save",
        "cancel": "Cancel"
      }
    },
    "switches": {
      "title": "Switch Controls",
      "subtitle": "Manage hierarchical switches to control ad display (Global → Category → Placement → Platform)",
      "global_switch": {
        "title": "Global Switch",
        "description": "Complete Ad System",
        "help_text": "Enable or disable the entire ad system with one click (emergency)",
        "enabled": "Enabled",
        "disabled": "Disabled"
      },
      "category_switches": {
        "title": "Category Switches",
        "subtitle": "Control ad activation by scene category",
        "status_format": "{active}/{total} enabled"
      },
      "placement_switches": {
        "title": "Switches by Placement and Platform",
        "subtitle": "Control each ad placement individually by platform (H5, iOS, Android, Web)",
        "search_placeholder": "Search placements...",
        "all_categories": "All Categories",
        "columns": {
          "placement": "Placement",
          "category": "Category",
          "enabled": "Enabled",
          "platforms": "Platforms"
        }
      },
      "categories": {
        "video": "Video Ads",
        "video_desc": "Video ads throughout the app",
        "feed": "Feed",
        "feed_desc": "Ads in feed streams",
        "chat": "Chat",
        "chat_desc": "Ads in conversations",
        "status": "Status",
        "status_desc": "Ads in status/stories",
        "open_screen": "Open Screen Ads",
        "open_screen_desc": "Ads when launching app",
        "activity": "Activity",
        "activity_desc": "Ads related to marketing campaigns"
      },
      "messages": {
        "global_success": "Ad system successfully {status}",
        "global_error": "Error toggling global switch",
        "category_success": "Category \"{label}\" {status}",
        "category_error": "Error toggling category",
        "placement_success": "Placement {status} successfully",
        "placement_error": "Error toggling placement",
        "platform_success": "Platform {platform} updated",
        "platform_error": "Error toggling platform",
        "activated": "Enabled",
        "deactivated": "Disabled",
        "activated_m": "Enabled",
        "deactivated_m": "Disabled"
      }
    },
    "targeting": {
      "info_alert": "Configure geographic, device and platform targeting for ads. Please select an ad to manage its targeting.",
      "select_ad_card": "Select Ad",
      "ad_label": "Ad",
      "ad_placeholder": "Select an ad",
      "countries": {
        "title": "Countries",
        "search_placeholder": "Search...",
        "loading": "Loading...",
        "no_results": "No results",
        "clear": "Clear",
        "selected_count": "{count} selected"
      },
      "devices": {
        "title": "Devices",
        "empty_selection_hint": "None selected = allow all devices",
        "types": {
          "android": "Android",
          "android_desc": "Android devices",
          "ios": "iOS",
          "ios_desc": "iPhone and iPad",
          "h5": "Mobile Web (H5)",
          "h5_desc": "Mobile browsers",
          "all": "All Devices",
          "all_desc": "Universal delivery"
        }
      },
      "platforms": {
        "title": "Platforms",
        "empty_selection_hint": "None selected = allow all platforms",
        "types": {
          "ios": "iOS",
          "ios_desc": "iPhone and iPad",
          "android": "Android",
          "android_desc": "Android devices",
          "web": "Web",
          "web_desc": "Web browsers",
          "windows": "Windows",
          "windows_desc": "Windows computers",
          "macos": "macOS",
          "macos_desc": "Mac computers"
        }
      },
      "actions": {
        "reset": "Reset",
        "save": "Save Targeting"
      },
      "empty_state": {
        "title": "Please select an ad",
        "description": "Select an ad above to configure its geographic, device and platform targeting."
      },
      "messages": {
        "save_success": "Targeting saved successfully",
        "save_error": "Failed to save targeting",
        "fetch_countries_error": "Failed to load country list",
        "success_title": "Success",
        "error_title": "Error"
      }
    },
    "videoAds": {
      "title": "Video Ads",
      "new": "New Video Ad",
      "noTitle": "No Title",
      "edit": "Edit Video Ad",
      "create": "Create",
      "update": "Update",
      "noVideo": "No video selected",
      "saveChanges": "Save Changes",
      "createAd": "Create Advertisement",
      "openVideo": "Open Video",
      "selectedVideos": "video(s) selected",
      "confirmDelete": "Are you sure you want to delete this video ad \"{title}\"?",
      "status": {
        "active": "Active",
        "inactive": "Inactive"
      },
      "type": {
        "forced": "Forced",
        "skippable": "Skippable"
      },
      "noData": "No items found.",
      "noFiltered": "No items match the filter criteria.",
      "videoAdsTable": {
        "columns": {
          "id": "ID",
          "video": "Video",
          "duration": "Duration",
          "trigger": "Trigger",
          "status": "Status",
          "type": "Type",
          "order": "Order",
          "actions": "Actions"
        }
      },
      "detailsModal": {
        "title": "Video Ad Details",
        "id": "ID:",
        "title": "Title:",
        "duration": "Video Duration:",
        "configuration": "Configuration",
        "trigger": "Trigger:",
        "status": "Status:",
        "playback": "Playback:",
        "rewardUrl": "Reward URL:",
        "targetUrl": "Target URL:"
      },
      "batch": {
        "orientation": "Orientation",
        "skipConfig": "Skip Config",
        "orientationModalTitle": "Update Orientation",
        "orientationPrompt": "Set orientation for {count} video(s):",
        "newOrientation": "New Orientation",
        "portrait": "Portrait",
        "landscape": "Landscape",
        "all": "All",
        "skipConfigModalTitle": "Skip Button Configuration",
        "skipConfigPrompt": "Apply configuration to {count} video(s):",
        "enableSkip": "Enable Skip",
        "skipAfter": "Skip after (seconds)",
        "textFr": "Text (FR)",
        "textEn": "Text (EN)"
      },
      "error": {
        "load": "Failed to load video ads"
      },
      "placeholders": {
        "filterDuration": "Filter by duration",
        "search": "Search video ads..."
      },
      "form": {
        "triggerMoment": "Trigger moment",
        "required": "Required",
        "targetType": "Target types",
        "targetType_none": "None",
        "targetType_url": "URL",
        "targetType_deeplink": "Deep Link",
        "targetType_page": "Page",
        "targetType_app": "App",
        "internalTitle": "Internal title",
        "titlePlaceholder": "Name to identify the ad",
        "videoFile": "Video file",
        "dragVideo": "Drag video here",
        "currentUrl": "Current URL",
        "coverImage": "Cover image",
        "dragImage": "Drag image here",
        "rewardApiUrl": "Reward API URL",
        "rewardHint": "Automatically called after viewing",
        "redirectUrl": "Redirect URL",
        "redirectHint": "Open when clicking the ad",
        "displayOrder": "Display order",
        "activeAd": "Active advertisement",
        "forcedPlayback": "Forced playback (non-skippable)",
        "orientation": "Orientation",
        "portrait": "Portrait",
        "landscape": "Landscape",
        "all": "All",
        "skipConfig": "Skip configuration",
        "skipAfter": "Skip after (s)",
        "start": "Start",
        "end": "End",
        "textFR": "Text (FR)",
        "textEN": "Text (EN)"
      },
      "messages": {
        "coverUploaded": "Cover image uploaded successfully!",
        "deleteSuccess": "Video ad deleted successfully",
        "deleteError": "Failed to delete video ad",
        "selectVideo": "Please select a video",
        "preparingUpload": "Preparing upload...",
        "uploadingVideoCover": "Uploading video and cover...",
        "uploadingVideo": "Uploading video...",
        "uploadInProgress": "Upload in progress... {percent}%",
        "uploadTranscoding": "Upload complete. Transcoding on server... (Please wait a few seconds)",
        "uploadSuccess": "Upload completed successfully!",
        "uploadSuccessHLS": "Video uploaded successfully (Encrypted HLS Format)!",
        "uploadSuccessRegular": "Video uploaded successfully!",
        "uploadFailed": "Upload failed",
        "uploadError": "Upload error",
        "uploadVideoError": "Failed to upload video",
        "selectImage": "Please select an image",
        "uploadImageSuccess": "Cover image uploaded successfully!",
        "uploadImageError": "Failed to upload image",
        "uploadBeforeCreate": "Please upload a video before creating the ad",
        "updateSuccess": "Video ad updated successfully",
        "createSuccess": "Video ad created successfully",
        "submitError": "Error during {action} of video ad",
        "batchUpdateSuccess": "{count} video(s) updated successfully",
        "batchUpdateError": "Update failed: {error}",
        "loadError": "Failed to load video ads",
        "serverProcessing": "Processing on server..."
      }
    },
    "triggerHistory": {
      "noData": "No items found.",
      "noFiltered": "No items match the filter criteria."
    },
    "adAgents": {
      "info_alert": "Manage associations between ads and agents/publishers. Control which agents can display which ads.",
      "noData": "No items found.",
      "noFiltered": "No items match the filter criteria.",
      "select_ad_card": {
        "title": "Select Ad",
        "label": "Ad",
        "placeholder": "Select an ad"
      },
      "agents_list": {
        "title": "👥 Global Agent List",
        "search_placeholder": "Search agents...",
        "columns": {
          "association": "Association",
          "username": "Agent",
          "code": "Code",
          "role": "Role"
        },
        "already_assigned": "Already assigned"
      },
      "active_ad_card": {
        "title": "Active Ad",
        "targeting_for": "Targeting for:",
        "bulk_actions": "Bulk Actions",
        "import_ids": "Import ID List",
        "remove_all": "Remove All Agents",
        "stats": {
          "assigned": "Assigned",
          "available": "Available"
        }
      },
      "no_ad_selected": {
        "title": "No Ad Selected",
        "description": "Select an ad to associate or remove agents via checkboxes."
      },
      "bulk_add_modal": {
        "title": "Bulk Add Agents",
        "select_agents": {
          "title": "Select Agents",
          "label": "Select agents from list",
          "placeholder": "Search or select..."
        },
        "manual_input": {
          "title": "Manual Input or Quick Import",
          "import_file": "Import File",
          "ids_label": "List of Identifiers (IDs)",
          "ids_placeholder": "Paste your IDs here, separated by commas, spaces or one per line",
          "formats_info": "Formats: comma, space, semicolon, newline",
          "clear_input": "Clear Input"
        },
        "preview": {
          "title": "Preview of Agents to Add",
          "agent_count": "{count} agents",
          "warning_large": "You are about to add more than 100 agents. This may take a few seconds.",
          "all_already_assigned": "All specified agents are already associated with this ad.",
          "id_prefix": "ID:",
          "more_count": "... and {count} more"
        },
        "footer": {
          "ready_to_add": "Ready to add {count} agents",
          "cancel": "Cancel",
          "add_button": "Add {count} Agents"
        }
      },
      "messages": {
        "error": "Error",
        "modification_failed": "Modification failed",
        "attention": "Attention",
        "bulk_add_confirm": "You are about to add {count} agents.\nThis operation may take time. Continue?",
        "yes_continue": "Yes, continue",
        "cancel_button": "Cancel",
        "adding_progress": "Adding...",
        "adding_progress_text": "Adding {count} agents.\nPlease wait...",
        "success": "Success!",
        "agents_added": "{count} agents added successfully",
        "add_failed": "Failed to add agents",
        "remove_confirm": "Are you sure?",
        "remove_text": "Do you want to remove this agent?",
        "yes_remove": "Yes, remove!",
        "removed": "Removed!",
        "agent_removed": "Agent removed successfully.",
        "remove_failed": "Remove failed",
        "clear_all_confirm": "Are you sure?",
        "clear_all_text": "Do you want to remove all {count} agents?",
        "yes_remove_all": "Yes, remove all!",
        "all_removed": "Removed!",
        "all_agents_removed": "All agents have been removed.",
        "file_imported": "File imported",
        "file_imported_text": "Detected {count} agents in file"
      }
    }
  },
  "videoDurations": {
    "noData": "No items found.",
    "noFiltered": "No items match the filter criteria.",
    "buttons": {
      "add": "Add"
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "validation": {
      "durationPositive": "Duration must be a positive number"
    },
    "messages": {
      "success": "Success",
      "error": "An error occurred while processing the video duration"
    },
    "modal": {
      "titleEdit": "Edit title",
      "titleCreate": "Create title"
    },
    "form": {
      "durationLabel": "Duration",
      "durationPositive": "Duration must be positive",
      "sortOrderLabel": "Sort Order",
      "activeLabel": "Active",
      "descriptionLabel": "Description",
      "descriptionPlaceholder": "Description for this duration"
    },
    "search": {
      "placeholder": "Search"
    },
    "columns": {
      "id": "ID",
      "seconds": "Seconds",
      "description": "Description",
      "order": "Order",
      "status": "Status",
      "actions": "Actions"
    }
  },
  "wallet": {
    "title": "Wallet Management",
    "subtitle": "Manage user balances and accounts",
    "add_balance": "Create Wallet",
    "add_title": "Create Wallet",
    "edit_title": "Edit Wallet",
    "stats": {
      "total_balance": "Total Balance",
      "total_users": "Total Users",
      "avg_balance": "Average Balance"
    },
    "search": "Search wallets...",
    "filters": {
      "all": "All",
      "active": "Active",
      "frozen": "Frozen",
      "closed": "Closed"
    },
    "pagination": {
      "items_per_page": "Items per page"
    },
    "table": {
      "user": "User",
      "balance": "Balance",
      "last_updated": "Last Updated",
      "status": "Status",
      "actions": "Actions"
    },
    "status": {
      "positive": "Positive",
      "negative": "Negative",
      "zero": "Zero"
    },
    "actions": {
      "charge": "Recharge",
      "close": "Close",
      "edit": "Edit",
      "add_funds": "Add Funds",
      "add_funds_prompt": "Enter amount to add:"
    },
    "form": {
      "user": "User",
      "balance": "Balance",
      "balance_placeholder": "Enter balance",
      "search_user": "Search user...",
      "no_users_found": "No users found",
      "cancel": "Cancel",
      "create": "Create",
      "update": "Update"
    },
    "toasts": {
      "success": "Success",
      "error": "Error",
      "create_success": "Wallet created successfully",
      "update_success": "Wallet updated successfully",
      "save_error": "Error during save",
      "fetch_error": "Error fetching wallets",
      "funds_added": "Funds added successfully"
    },
    "errors": {
      "user_already_has_wallet": "This user already has a wallet"
    },
    "modals": {
      "add_funds": {
        "title": "Add Funds",
        "user": "User",
        "current_balance": "Current Balance",
        "amount_to_add": "Amount to Add",
        "amount_placeholder": "Enter amount to add",
        "cancel": "Cancel",
        "confirm": "Add Funds",
        "error_adding": "Error adding funds",
        "invalid_amount": "Please enter a valid amount"
      },
      "charge": {
        "title": "Recharge Wallet",
        "user": "User",
        "current_balance": "Current Balance",
        "amount": "Recharge Amount",
        "amount_placeholder": "Enter recharge amount",
        "description": "Description",
        "description_placeholder": "Recharge description",
        "payment_method": "Payment Method",
        "payment_methods": {
          "credit_card": "Credit Card",
          "paypal": "PayPal",
          "bank_transfer": "Bank Transfer",
          "crypto": "Cryptocurrency"
        },
        "cancel": "Cancel",
        "confirm": "Recharge",
        "success_message": "Wallet successfully recharged with {amount}€",
        "error_message": "Error recharging wallet",
        "auth_error": "Authentication error - please log in again",
        "permission_error": "No permission to perform this action",
        "not_found_error": "Wallet not found",
        "server_error": "Server error - please try again later",
        "invalid_amount": "Please enter a valid amount"
      },
      "close": {
        "title": "Close Wallet",
        "user": "User",
        "current_balance": "Current Balance",
        "reason": "Reason for Closing",
        "reason_placeholder": "Please explain why you are closing this wallet",
        "cancel": "Cancel",
        "confirm": "Close Wallet",
        "reason_required": "Please provide a reason for closing the wallet",
        "success_message": "Wallet successfully closed",
        "error_message": "Error closing wallet",
        "auth_error": "Authentication error - please log in again",
        "permission_error": "No permission to perform this action",
        "not_found_error": "Wallet not found",
        "server_error": "Server error - please try again later"
      }
    }
  },
  "withdrawPage": {
    "creditCard": "Credit Card",
    "title": "Withdrawal Management",
    "agentSubtitle": "Manage your earnings and withdrawal requests",
    "adminSubtitle": "Approve or reject agent withdrawal requests",
    "roleAgent": "Agent",
    "roleAdmin": "Administrator",
    "requestWithdrawal": "Request Withdrawal",
    "minimumAmounts": {
      "button": "Min Amounts",
      "title": "Minimum Withdrawal Amounts",
      "usdtLabel": "Min Amount USDT",
      "usdtPlaceholder": "Enter minimum USDT amount",
      "bankCardLabel": "Min Amount Bank Card",
      "bankCardPlaceholder": "Enter minimum bank card amount"
    },
    "wallet": {
      "available": "Available Balance",
      "total": "Total Accumulated",
      "withdrawn": "Withdrawn",
      "pending": "Pending",
      "approved": "Approved",
      "thisMonth": "This Month",
      "thisWeek": "This Week",
      "monthlyProgress": "Monthly Progress"
    },
    "tabs": {
      "history": "History",
      "commissions": "Commissions",
      "settlement": "Settlement",
      "pending": "Pending Requests"
    },
    "filters": {
      "all": "All",
      "pending": "Pending",
      "approved": "Approved",
      "paid": "Submitted",
      "rejected": "Rejected"
    },
    "table": {
      "amount": "Amount",
      "method": "Payment Method",
      "status": "Status",
      "date": "Date",
      "requestDate": "Request Date",
      "approvalDate": "Approval Date",
      "paymentDate": "Payment Date",
      "actions": "Actions",
      "view": "View",
      "edit": "Edit",
      "approve": "Approve",
      "reject": "Reject",
      "pay": "Pay",
      "agent": "Agent",
      "commission": "Commission",
      "rate": "Rate (%)",
      "transactionId": "Transaction",
      "account": "Account",
      "beneficiary": "Beneficiary",
      "comment": "Comment"
    },
    "qr": {
      "button": {
        "changeImage": "Change Image",
        "uploadQrImage": "Upload QR Image"
      }
    },
    "upload": {
      "button": {
        "changeScreenshot": "Change Screenshot",
        "uploadScreenshot": "Upload Screenshot"
      },
      "hint": {
        "imageFormats": "Accepted formats: JPG, PNG, WebP (Max size: 5MB)",
        "screenshotFormats": "Accepted formats: JPG, PNG, WebP (Max size: 10MB)"
      },
      "noImageSelected": "No image selected",
      "qrPreviewAlt": "QR preview",
      "screenshotPreviewAlt": "Screenshot preview",
      "proofImageAlt": "Transfer proof"
    },
    "modal": {
      "newWithdrawalRequest": "New Withdrawal Request",
      "fillInformation": "Fill in your request information",
      "editRequest": "Edit Request",
      "reviewWithdrawal": "Review Withdrawal",
      "amount": "Withdrawal Amount",
      "amountPlaceholder": "Enter amount",
      "method": "Payment Method",
      "selectMethod": "Select payment method",
      "address": "Wallet Address",
      "addressPlaceholder": "Enter wallet address",
      "trc20Hint": "TRC20 USDT Address",
      "bankAccount": "Bank Account",
      "accountNumber": "Account Number",
      "accountName": "Account Name",
      "bankName": "Bank Name",
      "bankNamePlaceholder": "e.g. BNP Paribas, Credit Agricole",
      "iban": "IBAN",
      "ibanPlaceholder": "FR76 XXXX XXXX XXXX XXXX XXXX XXX",
      "ibanHint": "International standard format",
      "proof": "Payment Proof",
      "proofPlaceholder": "Upload proof image/file",
      "beneficiaryName": "Beneficiary Name",
      "fullName": "Full beneficiary name",
      "note": "Notes (optional)",
      "notes": "Notes (optional)",
      "notesPlaceholder": "Add notes...",
      "additionalInfo": "Add additional information...",
      "withdrawalPassword": "Withdrawal Password",
      "enterWithdrawalPassword": "Enter your withdrawal password",
      "withdrawalPasswordHint": "For security purposes, your withdrawal password is required",
      "qrCode": "QR Code (optional)",
      "qrCodeLabel": "QR Code:",
      "proofPreview": "Proof Preview",
      "transferProof": "Transfer Proof",
      "approvalNotes": "Approval Notes",
      "approvalNotesPlaceholder": "Add approval notes...",
      "rejectionReason": "Rejection Reason",
      "rejectionReasonPlaceholder": "Explain why you are rejecting this...",
      "summary": "Withdrawal Summary",
      "requestedAmount": "Requested Amount",
      "newBalance": "New Balance",
      "fees": "Transaction Fees",
      "finalAmount": "Final Amount",
      "cancel": "Cancel",
      "request": "Request Withdrawal",
      "submit": "Submit",
      "approve": "Approve",
      "reject": "Reject",
      "save": "Save Changes",
      "close": "Close"
    },
    "paymentMethods": {
      "usdt": "USDT (TRC20)",
      "bank": "Bank Card / Alipay",
      "USDT": "USDT",
      "USDT_SHORT": "TRC20",
      "BANK": "Bank Card / Alipay",
      "BANK_SHORT": "card",
      "BANK_TABLE": "card / Alipay"
    },
    "paymentMethodsmin": {
      "usdt": "USDT (TRC20)"
    },
    "agentTable": {
      "withdrawal": "Withdrawal",
      "status": "Status",
      "timeline": "Timeline",
      "account": "Account",
      "date": "Date",
      "actions": "Actions"
    },
    "status": {
      "PENDING": "Pending",
      "APPROVED": "Approved",
      "PAID": "Paid",
      "REJECTED": "Rejected",
      "SETTLED": "Settled"
    },
    "empty": {
      "noWithdrawals": "No withdrawal records found",
      "noHistory": "No withdrawal history",
      "noCommissions": "No commission data",
      "startWithdrawal": "Start your first withdrawal request",
      "startWithdrawing": "Start your first withdrawal request",
      "firstRequest": "Make your first request",
      "noPending": "No pending withdrawals",
      "allProcessed": "All withdrawals have been processed",
      "noApproved": "No approved withdrawals",
      "approvedAppear": "Approved withdrawals will appear here for payment",
      "processedAppear": "Processed withdrawals will appear here",
      "noData": "No data available"
    },
    "search": {
      "placeholder": "Search withdrawal...",
      "agentPlaceholder": "Search agents...",
      "dateFrom": "From",
      "dateTo": "To",
      "filterPlaceholder": "Filter",
      "searchAgent": "Search agent...",
      "adminSearchPlaceholder": "Search agent or request...",
      "searchApproved": "Search approved withdrawals...",
      "searchHistory": "Search history..."
    },
    "validation": {
      "amountRequired": "Amount is required",
      "amountPositive": "Amount must be positive",
      "minimumAmountUSDT": "Minimum withdrawal amount for USDT (TRC20) is 200",
      "minimumAmountBank": "Minimum withdrawal amount for Credit Card is 100",
      "methodRequired": "Please select a payment method",
      "addressRequired": "Wallet address is required",
      "reasonRequired": "Rejection reason is required",
      "withdrawalPasswordRequired": "Withdrawal password is required",
      "exceedsBalance": "Amount exceeds available balance"
    },
    "messages": {
      "success": "Success!",
      "error": "Error!",
      "withdrawalRequested": "Withdrawal request submitted successfully",
      "withdrawalApproved": "Withdrawal approved successfully",
      "withdrawalRejected": "Withdrawal rejected",
      "withdrawalPaid": "Withdrawal marked as paid",
      "withdrawalUpdated": "Withdrawal updated successfully",
      "withdrawalDeleted": "Withdrawal deleted successfully",
      "pleaseSelectRequest": "Please select a withdrawal request",
      "confirmApprove": "Are you sure you want to approve this withdrawal?",
      "confirmReject": "Are you sure you want to reject this withdrawal?",
      "confirmPay": "Mark this withdrawal as paid?",
      "confirmDelete": "Delete this withdrawal request?",
      "maxWithdrawAmount": "You can withdraw up to this amount",
      "loadWithdrawalHistoryError": "Failed to load withdrawal history. Please try again.",
      "loadWithdrawalDataError": "Failed to load withdrawal data. Please try again.",
      "loadWithdrawalStatsError": "Failed to load withdrawal statistics.",
      "loadWithdrawalStatsByChildrenError": "Failed to load withdrawal statistics by sub-accounts.",
      "refreshSuccess": "Data refreshed successfully",
      "refreshError": "Error refreshing data. Please try again.",
      "loadWalletStatsError": "Failed to load wallet statistics. Using default values.",
      "formLoadError": "Error loading form data",
      "qrImageTooLarge": "QR code image cannot exceed 5MB",
      "acceptedFormats": "Accepted formats: JPG, PNG, WebP",
      "copyError": "Failed to copy to clipboard",
      "fillAllFields": "Please fill in all required fields correctly",
      "commentRequired": "Comment required to reject withdrawal",
      "rejectionCommentPlaceholder": "Comment required to reject withdrawal...",
      "rejectionCommentRequired": "* Comment is mandatory to justify rejection",
      "withdrawalRevertedToPending": "Withdrawal set back to pending",
      "updateStatusError": "Failed to update withdrawal status",
      "fileTooBig": "File size cannot exceed 10MB",
      "invalidImage": "Please select a valid image file",
      "screenshotRequired": "Please upload a transfer screenshot",
      "markedAsPaidSuccess": "Withdrawal marked as paid successfully",
      "markAsPaidError": "Error marking withdrawal as paid",
      "loadError": "Failed to load withdrawal data. Please refresh the page.",
      "loadMinimumAmountsError": "Failed to load minimum withdrawal amounts",
      "minimumAmountsSaved": "Minimum withdrawal amounts saved successfully",
      "minimumAmountsSaveError": "Failed to save minimum withdrawal amounts"
    },
    "admin": {
      "pending": "Pending Approval",
      "approved": "Approved",
      "history": "Payment History",
      "settledCycles": "Settled Cycles",
      "withdrawalDetails": "Withdrawal Details",
      "paidAt": "Payment Time",
      "paid": "Paid",
      "date": "Date",
      "transferProof": "Transfer Proof",
      "process": "Approve",
      "addComment": "Add comment (optional)",
      "approvalConfirmation": "Approval Confirmation",
      "approveConfirm": "Are you sure you want to approve this withdrawal request?",
      "rejectionConfirmation": "Rejection Confirmation",
      "rejectConfirm": "Are you sure you want to reject this request? It is recommended to add a comment for the agent.",
      "cancel": "Cancel",
      "approve": "Approve",
      "reject": "Reject",
      "totalLabel": "Total",
      "pendingTab": "Pending",
      "pendingCount": "Pending",
      "approvedTab": "Approved",
      "approvedCount": "Approved",
      "markAsPaid": "Mark as Paid",
      "markAsPaidDescription": "This withdrawal will be marked as paid with the provided transfer proof.",
      "revertToPending": "Revert to Pending",
      "revertToPendingDescription": "This withdrawal will be set back to Pending and can be processed later.",
      "errorTitle": "Error",
      "withdrawalNotFound": "Withdrawal not found. ID: {id}",
      "total": "Total",
      "totalWitdrawals": "Total Withdrawals"
    },
    "agent": {
      "viewProof": "View Proof",
      "viewDetails": "View Details",
      "editWithdrawal": "Edit Withdrawal",
      "withdrawalDetails": "Withdrawal Details",
      "statusHistory": "Status History",
      "editWithdrawalTitle": "Edit Withdrawal",
      "editWithdrawalSubtitle": "Update your withdrawal request information",
      "currentInfo": "Current Information",
      "confirmPasswordHint": "Confirm with your withdrawal password",
      "editNotAllowed": "Only pending withdrawals can be edited",
      "editSuccess": "Withdrawal updated successfully",
      "saveChanges": "Save Changes",
      "list": {
        "withdrawal": "Withdrawal",
        "status": "Status",
        "timeline": "Timeline",
        "account": "Account",
        "actions": "Actions"
      }
    },
    "commissions": {
      "all": "All",
      "settled": "Settled",
      "pending": "Pending",
      "order": "Order",
      "date": "Date",
      "orderAmount": "Amount",
      "commission": "Commission",
      "status": "Status",
      "settledStatus": "Settled",
      "pendingStatus": "Pending"
    },
    "settlement": {
      "cycle": "Settlement Cycle",
      "cycleDescription": "Settlement occurs monthly on the last day",
      "cycleDescriptionDetailed": "Order income is settled monthly. Income from each month is converted into withdrawable balance the following month.",
      "nextSettlementTitle": "Next Settlement",
      "nextSettlementExample": "February 2026 settlement will be available on March 1, 2026.",
      "periods": {
        "january2026": {
          "month": "January 2026",
          "status": "Available on February 1"
        },
        "february2026": {
          "month": "February 2026",
          "status": "In progress - Available on March 1"
        },
        "march2026": {
          "month": "March 2026",
          "status": "Coming soon"
        }
      }
    },
    "pagination": {
      "showing": "Showing {start} to {end} of {total}"
    },
    "common": {
      "copy": "Copy"
    },
    "stats": {
      "title": "Withdrawal Statistics",
      "subtitle": "Overview of withdrawal requests by sub-accounts",
      "yesterday": "Yesterday Withdrawals Count/Amount",
      "today": "Today Withdrawals Count/Amount",
      "lastThreeDays": "Last 3 Days Withdrawals",
      "unpaid": "Unsettled Amount"
    },
    "maxButton": "Max"
  },
  "emoji": {
    "title": "Emoji Management",
    "addNew": "Add New Emoji",
    "addNewGroup": "Add New Group",
    "updateEmoji": "Update Emoji",
    "confirmDelete": "Confirm Delete",
    "code": "Code",
    "images": "Images (max 100)",
    "single": "Single",
    "multiple": "Multiple",
    "group": "Group",
    "type": "Type",
    "groupName": "Group Name",
    "description": "Description",
    "status": "Status",
    "newImage": "New Image",
    "cancel": "Cancel",
    "addEmoji": "Add Emoji",
    "addEmojis": "Add {count} Emojis",
    "createGroup": "Create Group",
    "save": "Save",
    "delete": "Delete",
    "newGroup": "New Group",
    "totalEmojis": "Total Emojis",
    "groups": "Groups",
    "svgEmojis": "SVG Emojis",
    "gifEmojis": "GIF Emojis",
    "jpgEmojis": "JPG Emojis",
    "filterByGroup": "Filter by Group",
    "filterByType": "Filter by Type",
    "allGroups": "All Groups",
    "allTypes": "All Types",
    "reset": "Reset",
    "loading": "Loading emojis...",
    "id": "ID",
    "image": "Image",
    "url": "URL",
    "actions": "Actions",
    "selectAGroup": "Select a Group",
    "noGroupFound": "⚠️ No group found. Create one first",
    "filesSelected": "{count} file(s) selected",
    "keepCurrentImage": "Keep the current image if no file is selected",
    "areYouSureDelete": "Are you sure you want to delete this emoji",
    "emojiNumber": "Emoji #{id}",
    "groupDescription": "Group Description",
    "codePlaceholder": "Ex: smiley_face",
    "groupNamePlaceholder": "Ex: Emotions",
    "groupCodePlaceholder": "Ex: emotions",
    "groupDescriptionPlaceholder": "Group description",
    "svg": "SVG",
    "jpg": "JPG",
    "gif": "GIF",
    "imageRequired": "Image required",
    "pleaseSelectImage": "Please select an image",
    "chooseFile": "Choose a file",
    "noFileChosen": "No file chosen",
    "noEmojiAvailable": "No emoji available",
    "noResultForFilter": "No results for filter",
    "createGroupFirst": "Create a group first",
    "tryModifyFilter": "Try modifying the filter",
    "createAGroup": "Create a Group",
    "noGroup": "No Group",
    "preview": "Preview",
    "activated": "Activated",
    "deactivated": "Deactivated",
    "edit": "Edit",
    "emojiCreated": "Emoji created!",
    "emojiCreatedSuccess": "{count} emojis created successfully!",
    "emojiDeleted": "Emoji deleted!",
    "emojiStatusUpdated": "Emoji status updated!",
    "emojiUpdated": "Emoji updated!",
    "errorCreatingEmoji": "Error creating emoji",
    "errorCreatingGroup": "Error creating group",
    "errorDeletingEmoji": "Error deleting emoji",
    "errorLoadingEmoji": "Error loading emojis",
    "errorLoadingGroups": "Error loading groups",
    "errorUpdatingEmoji": "Error updating emoji",
    "errorUpdatingEmojiStatus": "Error updating emoji status",
    "fileNotSupported": "File not supported. Please use JPEG, PNG, GIF, WebP or SVG.",
    "fileTooLarge": "File too large (maximum 2MB)",
    "fileTooLargeMessage": "File too large. Maximum 2MB.",
    "fileTypeNotSupported": "File type not supported",
    "groupCreated": "Group \"{name}\" created!",
    "maximum100Files": "Maximum 100 files allowed",
    "next": "Next",
    "noEmojiSelected": "No emoji selected",
    "onlyOneFileAllowed": "Only one file allowed in single file mode",
    "page": "Page {page}",
    "pleaseCorrectErrors": "Please correct the errors",
    "pleaseCreateGroup": "Please create a group first",
    "previous": "Previous",
    "resetFilters": "Reset filters",
    "emojiGroups": "Emoji Groups",
    "manageGroups": "Manage your emoji groups",
    "noGroupCreated": "No group created",
    "createFirstGroupDesc": "Create your first group to start organising your emojis",
    "editGroupModal": "Edit Group",
    "confirmDeletion": "Confirm Delete",
    "deleteGroupConfirm": "Are you sure you want to delete the group \"{name}\"?",
    "groupDeleteWarning": "⚠️ You must delete all emojis in this group before deleting it.",
    "noGroupSelected": "No group selected",
    "groupUpdated": "Group \"{name}\" updated!",
    "errorUpdatingGroup": "Error updating group",
    "cannotDeleteGroupWithEmojis": "Cannot delete a group that contains emojis. Please delete the emojis in the group first.",
    "groupDeleted": "Group \"{name}\" deleted!",
    "errorDeletingGroup": "Error deleting group",
    "countEmojis": "Emoji Count",
    "noDescription": "-"
  },
  "chatlog": {
    "title": "Chat Log",
    "columns": {
      "from": "From",
      "to": "To",
      "agent_name": "Agent Name",
      "date": "Date"
    },
    "filters": {
      "userbyId": "Search by User ID...",
      "user": "User ID",
      "keyword": "Keyword",
      "date": "Created At",
      "search_user": "Search by User ID...",
      "search_keyword": "Search keyword..."
    },
    "noData": "No chat logs"
  },
  "price_config": {
    "pageTitle": "Price Configuration",
    "filters": {
      "agentPlaceholder": "Agent Name",
      "typePlaceholder": "Select Configuration Type",
      "searchButton": "Search",
      "initializeAllAgentsButton": "Initialize All Agents"
    },
    "typeOptions": {
      "home": "Homepage Short Video",
      "video": "Long Video",
      "post": "Post"
    },
    "table": {
      "agentName": "Agent Name",
      "type": "Type",
      "minPrice": "Minimum Price",
      "maxPrice": "Maximum Price",
      "createdAt": "Created At",
      "updatedAt": "Updated At",
      "noData": "-",
      "edit": "Edit",
      "actions": "Actions"
    },
    "messages": {
      "initSuccess": "All agents' price mappings have been successfully initialized",
      "initFail": "Failed to initialize agent price mappings"
    },
    "editModal": {
      "title": "Edit Price Configuration",
      "typePlaceholder": "Please select a type",
      "minPricePlaceholder": "Enter minimum price",
      "maxPricePlaceholder": "Enter maximum price",
      "cancel": "Cancel",
      "save": "Save",
      "saveFailed": "Failed to save, please try again"
    }
  },
  "orders": {
    "title": "Order Management System",
    "subtitle": "Dashboard · Operations Panel",
    "error": {
      "fetchOrders": "Failed to fetch payment orders"
    },
    "filters": {
      "title": "Search & Filter",
      "total": "Total",
      "records": "records",
      "agentName": "Agent Name",
      "userId": "User ID",
      "orderType": "Order Type",
      "orderNumber": "Order Number",
      "paymentStatus": "Payment Status",
      "paymentChannel": "Payment Channel",
      "deduction": "Deduction",
      "deductionYes": "Yes",
      "noChannelsFound": "No channels found",
      "deductionNo": "No",
      "minimumOrderAmount": "Minimum Order Amount",
      "orderTime": "Order Time",
      "advanced": "Advanced filters",
      "fromApp": "From App",
      "userIp": "User IP",
      "allAgents": "All Agents",
      "noAgentsFound": "No agents found",
      "allTypes": "All Types",
      "allStatuses": "All Status",
      "allChannels": "All Channels",
      "all": "All",
      "mobile": "Android",
      "android": "Android",
      "androidHint": "Android orders only (iOS excluded).",
      "web": "Web",
      "placeholders": {
        "agentSearch": "Search agents...",
        "username": "Exact username...",
        "userId": "Exact match…",
        "channelSearch": "Search channels...",
        "orderNumber": "Last 6 digits or full…",
        "minimumOrderAmount": "e.g. 200",
        "userIp": "e.g. 192.168.1.1"
      }
    },
    "actions": {
      "search": "Search",
      "reset": "Reset",
      "export": "Export CSV",
      "retry": "Retry",
      "lock": "Lock Order",
      "unlock": "Unlock Order",
      "cancel": "Cancel Order",
      "block": "Block Agent",
      "blockUser": "Block User",
      "reactivateUser": "Reactivate User",
      "revokeStolen": "Revoke Stolen",
      "confirmBlockOrder": "Are you sure you want to block order {orderNumber}?",
      "confirmBlockUserFromOrder": "Are you sure you want to block user {userId}?",
      "confirmReactivateUserFromOrder": "Are you sure you want to reactivate user {userId}?",
      "confirmLockOrder": "Are you sure you want to lock order {orderNumber}?",
      "confirmRevokeStolen": "Are you sure you want to revoke stolen order {orderNumber}?",
      "openAgentBackend": "Connected as",
      "lockOrder": "Lock"
    },
    "table": {
      "total": "Total",
      "records": "records",
      "headers": {
        "orderNumber": "Order Number",
        "isStolen": "Reduce",
        "billingAddress": "Billing Address",
        "paymentDuration": "Payment Duration",
        "agentName": "Agent Name",
        "userId": "User ID",
        "productName": "Product Name",
        "orderAmount": "Order Amount",
        "orderStatus": "Order Status",
        "paymentChannel": "Payment Channel",
        "orderType": "Order Type",
        "userIp": "User IP",
        "fromApp": "From App",
        "userRegTime": "User Reg. Time",
        "orderTime": "Order Time",
        "actions": "Blocked action"
      },
      "noData": "No orders found matching your criteria.",
      "copyTooltip": "Click to copy"
    },
    "sorting": {
      "newest": "Newest",
      "oldest": "Oldest",
      "amount": "Amount",
      "amountAsc": "Amount Asc",
      "amountDesc": "Amount Desc"
    },
    "statuses": {
      "pending": "Pending",
      "success": "Success",
      "failed": "Failed"
    },
    "orderTypes": {
      "recharge": "Recharge",
      "resource": "Video / Community",
      "vip": "VIP",
      "time_package": "Time Package"
    },
    "pagination": {
      "page": "Page",
      "total": "of",
      "showing": "showing",
      "showingOf": "of",
      "rowsPerPage": "Rows/page"
    },
    "messages": {
      "loading": "Loading...",
      "agentCredentialsMissing": "Unable to impersonate: Missing agent account or password ",
      "websocketConnectionFailed": "Websocket connection failed. Real-time updates may not work.",
      "loadingError": "Error loading orders",
      "filtersReset": "Filters reset",
      "orderAction": "Order {orderNumber} {action} successfully",
      "copySuccess": "✓ Copied: {text}",
      "exportSuccess": "✓ CSV exported ({count} rows)",
      "retry": "Retry",
      "filtersApplied": "Filters applied",
      "orderActionLocked": "Order {orderNumber} locked successfully",
      "orderActionUnlocked": "Order {orderNumber} unlocked successfully",
      "orderActionCanceled": "Order {orderNumber} canceled successfully",
      "orderActionBlocked": "Order {orderNumber} blocked successfully",
      "noUserId": "No user linked to this order",
      "blockUserSuccess": "User {userId} blocked successfully",
      "blockUserFailed": "Failed to block user. Please try again.",
      "reactivateUserSuccess": "User {userId} reactivated successfully",
      "reactivateUserFailed": "Failed to reactivate user. Please try again.",
      "impersonateNotAgent": "This account is not an agent and cannot access the agent backend.",
      "actionFailed": "Operation failed. Please try again."
    },
    "dateRange": "Date Range",
    "search": "Search",
    "reset": "Reset",
    "exportCsv": "Export CSV",
    "filteredTotal": "Filtered Total",
    "colAgent": "Agent",
    "colAmount": "Amount (¥)",
    "colType": "Type",
    "colSubAgent": "Sub Agent",
    "colTime": "Time",
    "noData": "No records match the current filters.",
    "prev": "Prev",
    "next": "Next",
    "pageOf": "Page {page}",
    "totalRecords": "{n} records total",
    "csvExported": "✓ CSV exported",
    "agentPlaceholder": "Enter ID / Name"
  },
  "agentIncomes": {
    "title": "Agent Incomes",
    "exportCsv": "Export CSV",
    "agent": "Agent",
    "type": "Type",
    "dateRange": "Date Range",
    "search": "Search",
    "reset": "Reset",
    "filteredTotal": "Filtered Total",
    "colAgent": "Agent",
    "colType": "Type",
    "colTime": "Time",
    "noData": "No records match the current filters.",
    "pageOf": "Page {page}",
    "totalRecords": "{n} records total",
    "next": "Next ",
    "subtitle": "Dashboard · Operations Panel",
    "agentPlaceholder": "Enter ID / Name",
    "typeAllt": "All Types",
    "colAmount": "Amount",
    "colSubAgent": "Sub Agent",
    "prev": "Prev",
    "typeVideo": "Video",
    "typePosts": "Posts",
    "typeShortVideo": "Short Video",
    "typeVIP": "VIP",
    "fetchError": "Failed to load agent income data. Please refresh the page and try again.",
    "csvExported": "Agent income data has been successfully exported to CSV."
  },
  "domainRegistration": {
    "title": "Domain name registration",
    "list": "List",
    "keyword": "Keyword",
    "tabs": {
      "domains": "Short Domains",
      "types": "Domain Types"
    },
    "approve": {
      "success": "Domain {domain} approved successfully"
    },
    "reject": {
      "success": "Domain {domain} rejected successfully",
      "error": "Failed to reject domain"
    },
    "editModal": {
      "success": "Domain type updated successfully"
    },
    "deleteType": {
      "success": "Domain type deleted successfully"
    },
    "delete": {
      "confirm": "Are you sure you want to delete this domain?",
      "success": "Domain deleted successfully",
      "error": "Failed to delete domain"
    },
    "status": {
      "success": "Success",
      "pending": "Pending",
      "rejected": "Rejected"
    },
    "refreshing": "Refreshing data...",
    "refreshSuccess": "Data refreshed successfully",
    "refreshError": "Failed to refresh data",
    "setToPending": {
      "success": "Domain {domain} set to pending successfully"
    },
    "pagination": {
      "itemsPerPage": "{count} per page",
      "perPage": "{count} / page",
      "page": "Page",
      "of": "of",
      "show": "Show"
    },
    "manageAddress": "Address resolution management",
    "addDomain": "Add domain",
    "search": "search",
    "actions": "Actions",
    "serialNumber": "Serial number",
    "agentName": "Agent Name",
    "agentNumber": "Agent Number",
    "domainName": "Apply for a domain name",
    "parsingType": "Parsing type",
    "resolvedAddress": "Resolved address",
    "state": "State",
    "creationTime": "Creation time",
    "noData": "No data found",
    "currentlyDisplaying": "Currently displaying items {start} through {end}, a total of {total} items.",
    "eachPage": "Each page",
    "dnsModal": {
      "title": "Address resolution management",
      "cnameAddress": "Type",
      "ipAddress": "URL or DNS",
      "redirectAddress": "Mark",
      "submit": "Submit",
      "cancel": "Cancel",
      "errors": {
        "cnameRequired": "Type is required",
        "invalidCname": "Invalid Type",
        "ipRequired": "URL or DNS is required",
        "invalidIp": "Invalid URL or DNS",
        "redirectRequired": "Redirect address is required",
        "invalidRedirect": "Invalid redirect address",
        "invalidIpRange": "Each URL or DNS part must be between 0 and 255",
        "invalidUrl": "Please enter a valid URL (starting with http:// or https://)",
        "fillRequiredFields": "Please fill in all required fields correctly"
      }
    },
    "addDomainModal": {
      "title": "Create a domain name application",
      "domainNameLabel": "Apply for a domain name",
      "parsingTypeLabel": "Parsing type",
      "selectOptions": "Select Options",
      "cdn": "CDN(cname)",
      "success": "Domain {domain} created successfully",
      "btPanel": "BT Panel (IP address)",
      "urlRedirection": "URL redirection",
      "required": "*",
      "keep": "keep",
      "saveAndCreate": "Save and create another",
      "cancel": "Cancel",
      "errors": {
        "domainRequired": "Domain name is required",
        "domainMinLength": "Domain name must be at least 2 characters long",
        "parsingTypeRequired": "Parsing type is required",
        "RequiredFields": "Please fill in all required fields",
        "invalidType": "Invalid parsing type",
        "noAdmin": "User not authenticated",
        "fillRequiredFields": "Please fill in all required fields correctly"
      }
    },
    "rejectionModal": {
      "title": "Rejection Reason",
      "reasonLabel": "Reason for rejection",
      "placeholder": "Please enter the reason for rejection...",
      "cancel": "Cancel",
      "submit": "Confirm rejection",
      "errors": {
        "reasonRequired": "Please enter a rejection reason"
      }
    },
    "columns": {
      "serialNumber": "Serial number",
      "agentName": "Agent Name",
      "agentNumber": "Agent Number",
      "domainName": "Domain Name",
      "parsingType": "Parsing Type",
      "resolvedAddress": "Resolved Address",
      "redirectAddress": "Mark",
      "state": "State",
      "action": "Action",
      "domain": "Domain",
      "rejectionReason": "Rejection Reason",
      "creationTime": "Creation Time"
    },
    "typeColumns": {
      "id": "ID",
      "name": "Name",
      "ipAddress": "Type",
      "redirectAddress": "Mark",
      "createdAt": "Creation Time"
    }
  },
  "impersonation": {
    "loading": "Loading...",
    "authenticating": "Authenticating...",
    "goToLogin": "Go to login",
    "error": "Error",
    "closeTab": "Close Tab",
    "redeemError": "Failed to redeem impersonation session",
    "checkingDomain": "Checking redirect domain...",
    "domainUnreachable": "Redirect domain unreachable",
    "fallbackMessage": "You will be redirected to the default application.",
    "redirectingToFallback": "Redirecting to default application...",
    "redirecting": "Redirecting..."
  },
  "userNotificationPage": {
    "title": "System Notifications",
    "subtitle": "Manage and send notifications to users",
    "newNotification": "New Notification",
    "editNotification": "Edit Notification",
    "total": "Total",
    "notifications": "notifications",
    "loadingHistory": "Loading history...",
    "empty": "No notifications found",
    "confirmDelete": "Are you sure you want to delete this notification?",
    "form": {
      "notificationTitle": "Notification title",
      "notificationTitlePlaceholder": "Example: Planned maintenance",
      "notificationType": "Notification type",
      "chooseType": "Choose a type...",
      "recipient": "Recipient",
      "allUsers": "All users",
      "specificUser": "Specific user",
      "userId": "User ID (user_id)",
      "userIdPlaceholder": "Example: 12345",
      "deviceType": "Device type",
      "allDevices": "All devices",
      "actionUrlOptional": "Action URL (Optional)",
      "messageContent": "Message content",
      "messageContentPlaceholder": "Notification details..."
    },
    "actions": {
      "sending": "Sending...",
      "sendNotification": "Send notification",
      "reset": "Reset",
      "refresh": "Refresh",
      "edit": "Edit",
      "updateNotification": "Update Notification",
      "markAsRead": "Mark as read",
      "delete": "Delete",
      "cancel": "Cancel",
      "createNotification": "Create Notification",
      "search": "Search"
    },
    "table": {
      "type": "Type",
      "title": "Title",
      "recipient": "Recipient",
      "device": "Device",
      "createdAt": "Creation date",
      "status": "Status",
      "actions": "Actions",
      "allBroadcast": "All (Broadcast)",
      "idPrefix": "ID",
      "read": "Read",
      "unread": "Unread"
    },
    "devices": {
      "all": "All",
      "h5": "H5",
      "web": "Web",
      "ios": "iOS",
      "android": "Android"
    },
    "filters": {
      "searchPlaceholder": "Search by title or content...",
      "device": "Device"
    },
    "types": {
      "systemAlert": "System Alert",
      "groupInvitation": "Group Invitation",
      "joinGroup": "Join Group",
      "invitationAccepted": "Invitation Accepted",
      "invitationApproved": "Invitation Approved",
      "invitationDeclined": "Invitation Declined",
      "invitationPending": "Invitation Pending",
      "invitationToJoinRejected": "Invitation to Join Rejected",
      "accountUpdate": "Account Update",
      "featureAnnouncement": "Feature Announcement",
      "maintenance": "Maintenance",
      "securityAlert": "Security Alert"
    },
    "toasts": {
      "requiredFields": "Title and content are required.",
      "sendSuccess": "Notification sent successfully!",
      "sendError": "Failed to send notification.",
      "loadError": "Failed to load notifications.",
      "markedAsRead": "Marked as read",
      "deleted": "Notification deleted",
      "updateSuccess": "Notification updated successfully",
      "urlCopied": "URL copied to clipboard",
      "userIdRequired": "User ID is required"
    },
    "pagination": {
      "previous": "Previous",
      "next": "Next",
      "pageInfo": "Page {page} / {totalPages}",
      "limit": "Items per page"
    }
  },
  "revenue": {
    "title": "Revenue Report",
    "subtitle": "Agent and subordinate revenue overview",
    "filters": {
      "title": "Filters",
      "agent": "Agent",
      "allAgents": "All Agents",
      "searchAgent": "Search agent...",
      "noAgents": "No agents found",
      "date": "Date",
      "vipLevel": "VIP Level",
      "allLevels": "All Levels"
    },
  
    "summary": {
      "totalAgents": "Total Agents",
      "totalSubordinates": "Total Subordinates",
      "todayRevenue": "Today's Revenue",
      "yesterdayRevenue": "Yesterday's Revenue",
      "totalVipShare": "Avg VIP Rate"
    },
    "table": {
      "total": "Total",
      "records": "records",
      "rank": "Rank",
      "agent": "Agent",
      "code": "Code",
      "today": "Today",
      "yesterday": "Yesterday",
      "vipShareRate": "VIP Share Rate",
      "subscription": "Subscription",
      "action": "Action",
      "todayRevenue": "Today CA",
      "yesterdayRevenue": "Yesterday CA",
      "subordinates": "Sub.",
      "noSubordinates": "No subordinates found",
      "noData": "No data available",
      "headers": {
        "subordinateName": "Subordinate Name",
        "subordinateCode": "Code",
        "todayRevenue": "Today's Revenue",
        "yesterdayRevenue": "Yesterday's Revenue",
        "vipShareRate": "VIP Share Rate",
        "vipLevel": "VIP Level",
        "registrationDate": "Registration Date"
      }
    },
    "actions": {
      "search": "Search",
      "reset": "Reset",
      "retry": "Retry",
      "export": "Export CSV"
    },
    "messages": {
      "loading": "Loading revenue data...",
      "loadError": "Error loading revenue data",
      "searchApplied": "Filters applied",
      "filtersReset": "Filters reset",
      "exportSuccess": "Export successful ({count} rows)"
    }
  }
}


